// src/roles.ts
var ROLES = [
  "ADMIN",
  "BOARD",
  "SALES_MANAGER",
  "SALES_REP",
  "LOGISTICS",
  "ORDER_DESK",
  "COLLECTIONS",
  "DRIVER",
  "FLEET_ADMIN",
  "DISPATCHER",
  "WAREHOUSE_MANAGER",
  "WAREHOUSE"
];
var ROLE_DATA_SCOPE = {
  ADMIN: "ALL",
  BOARD: "ALL",
  SALES_MANAGER: "TEAM",
  SALES_REP: "OWN",
  LOGISTICS: "ALL",
  ORDER_DESK: "ALL",
  COLLECTIONS: "ALL",
  DRIVER: "OWN",
  // Fleet: tylko własne karty drogowe i przypisane pojazdy
  FLEET_ADMIN: "ALL",
  DISPATCHER: "ALL",
  WAREHOUSE_MANAGER: "ALL",
  WAREHOUSE: "OWN"
  // Magazynier: tylko własne odbicia RCP
};

// src/permissions.ts
var PERMISSIONS = {
  "customers.read": "Podgl\u0105d klient\xF3w",
  "customers.write": "Edycja klient\xF3w",
  "customers.reassign": "Zmiana przypisanego handlowca",
  "customers.financial.read": "Dane finansowe klienta (p\u0142atno\u015Bci, limit)",
  "customers.documents.send": "Wysy\u0142ka dokument\xF3w do klienta \u2014 lista dokument\xF3w, zestawienie nale\u017Cno\u015Bci, potwierdzenie salda, przypomnienie o p\u0142atno\u015Bci (handlowiec: tylko swoi klienci)",
  "leads.read": "Podgl\u0105d lead\xF3w",
  "leads.write": "Edycja lead\xF3w",
  "visits.read": "Podgl\u0105d wizyt",
  "visits.write": "Rejestrowanie wizyt",
  "tasks.read": "Podgl\u0105d zada\u0144",
  "tasks.write": "Edycja zada\u0144",
  "orders.read": "Podgl\u0105d zam\xF3wie\u0144 i dokument\xF3w",
  "orders.create": "Zam\xF3wienie od handlowca \u2014 sk\u0142adanie zam\xF3wie\u0144 klienta do Biura zam\xF3wie\u0144, podgl\u0105d i wycofanie w\u0142asnych (handlowiec: swoi klienci, kierownik: zesp\xF3\u0142)",
  "orders.manage": "Zam\xF3wienia od handlowc\xF3w \u2014 kolejka Biura zam\xF3wie\u0144: wprowadzenie do Subiektu, odrzucenie z powodem (ca\u0142a organizacja)",
  "logistics.read": "Podgl\u0105d danych logistycznych",
  "logistics.write": "Edycja danych logistycznych",
  "logistics.insights": "Logistyka \u2014 AI Insight (podsumowania dostaw i tras, czat o logistyce)",
  "receivables.read": "Podgl\u0105d nale\u017Cno\u015Bci",
  "workflow.start": "Uruchamianie proces\xF3w (np. nowy klient)",
  "workflow.approve.prices": "Akceptacja cen",
  "workflow.approve.logistics": "Akceptacja logistyki / awizacji",
  "workflow.approve.orders": "Akceptacja dzia\u0142u zam\xF3wie\u0144",
  "workflow.approve.credit": "Akceptacja limitu kupieckiego",
  "targets.read": "Podgl\u0105d target\xF3w",
  "targets.write": "Ustalanie target\xF3w",
  "bi.sales": "BI \u2014 sprzeda\u017C i mar\u017Ca",
  "bi.board": "BI \u2014 dashboard zarz\u0105du",
  "bi.team": "BI \u2014 dashboard kierownika",
  "bi.profitability": "BI \u2014 rentowno\u015B\u0107 klient\xF3w i tras",
  "bi.receivables": "BI \u2014 nale\u017Cno\u015Bci",
  "ai.insights": "AI Insights",
  "dashboard.owner": "Pulpit mened\u017Cera (zarz\u0105d i administrator)",
  "chat.use": "Czat wewn\u0119trzny",
  "chat.broadcast": "Czat \u2014 og\u0142oszenia do zespo\u0142u",
  "notifications.announce": "Powiadomienia \u2014 wysy\u0142anie og\u0142osze\u0144 i historia wysy\u0142ek",
  "admin.users": "Zarz\u0105dzanie u\u017Cytkownikami",
  "gdpr.manage": "RODO \u2014 \u017C\u0105dania os\xF3b (eksport i anonimizacja danych)",
  "admin.settings": "Ustawienia organizacji",
  "admin.audit": "Dziennik audytu",
  "erp.sync": "Synchronizacja z ERP",
  "erp.sync.view": "Integracje \u2014 dziennik synchronizacji z ERP (podgl\u0105d przebieg\xF3w, stan, kolejka do ERP)",
  "erp.sync.run": "Integracje \u2014 uruchamianie synchronizacji z ERP (pr\xF3ba na sucho, import), tokeny integracji i ponawianie kolejki do ERP",
  "fleet.vehicles.read": "Flota \u2014 podgl\u0105d pojazd\xF3w i przypisa\u0144",
  "fleet.vehicles.write": "Flota \u2014 edycja pojazd\xF3w, grup i przypisa\u0144 kierowc\xF3w",
  "fleet.leases.read": "Flota \u2014 podgl\u0105d um\xF3w leasingowych i limit\xF3w km",
  "fleet.leases.write": "Flota \u2014 edycja um\xF3w leasingowych",
  "fleet.logbook.own": "Flota \u2014 w\u0142asne karty drogowe kierowcy",
  "fleet.logbook.read": "Flota \u2014 podgl\u0105d wszystkich kart drogowych",
  "fleet.logbook.review": "Flota \u2014 weryfikacja i akceptacja kart drogowych",
  "fleet.odometer.correct": "Flota \u2014 korekta i wymiana licznika",
  "fleet.fuel.write": "Flota \u2014 wprowadzanie tankowa\u0144",
  "fleet.fuel.review": "Flota \u2014 weryfikacja tankowa\u0144",
  "fleet.expenses.write": "Flota \u2014 zg\u0142aszanie koszt\xF3w pojazdu",
  "fleet.expenses.review": "Flota \u2014 akceptacja koszt\xF3w pojazdu",
  "fleet.incidents.write": "Flota \u2014 zg\u0142aszanie zdarze\u0144 i usterek",
  "fleet.incidents.manage": "Flota \u2014 obs\u0142uga zdarze\u0144 i usterek",
  "fleet.analytics": "Flota \u2014 analityka i pulpit",
  "fleet.insights": "Flota \u2014 AI Insight floty",
  "fleet.settings": "Flota \u2014 ustawienia modu\u0142u",
  "fleet.integration": "Flota \u2014 integracja z systemem tras",
  "mbr.read": "Raport zarz\u0105du \u2014 podgl\u0105d (sprzeda\u017C, klienci, logistyka, operacje)",
  "mbr.finance": "Raport zarz\u0105du \u2014 koszty, wynik, pr\xF3g rentowno\u015Bci, nale\u017Cno\u015Bci, sumy kadr",
  "mbr.write": "Raport zarz\u0105du \u2014 wprowadzanie danych dzia\u0142u w zamkni\u0119ciu miesi\u0105ca (formularze, rejestry)",
  "mbr.close": "Raport zarz\u0105du \u2014 zatwierdzanie, zamro\u017Cenie i wysy\u0142ka miesi\u0105ca",
  "mbr.hr": "Raport zarz\u0105du \u2014 kadry per osoba (dane osobowe)",
  "mbr.settings": "Raport zarz\u0105du \u2014 ustawienia (progi, klucz podzia\u0142u, odbiorcy, harmonogram)",
  "insurance.view": "Ubezpieczenia \u2014 pulpit, polisy i umowy (podgl\u0105d)",
  "insurance.manage": "Ubezpieczenia \u2014 edycja polis i um\xF3w, import od ubezpieczyciela, ustawienia modu\u0142u",
  "insurance.analytics": "Ubezpieczenia \u2014 szkodowo\u015B\u0107 i raport do odnowienia",
  "claims.view": "Szkody \u2014 podgl\u0105d spraw szkodowych",
  "claims.qualify": "Szkody \u2014 kwalifikacja zg\u0142osze\u0144 floty (Do kwalifikacji)",
  "claims.manage": "Szkody \u2014 prowadzenie likwidacji (etapy, kwoty, pisma, wyp\u0142aty)",
  "tenders.manage": "Ubezpieczenia \u2014 post\u0119powania na wyb\xF3r ubezpieczyciela (przetargi)",
  "planner.view": "Planer \u2014 podgl\u0105d grafiku zespo\u0142u",
  "planner.manage": "Planer \u2014 uk\u0142adanie grafiku, nieobecno\u015Bci, rozpatrywanie wniosk\xF3w, szablony czynno\u015Bci i atrybuty zmian",
  "worktime.own": "RCP \u2014 w\u0142asne odbicia wej\u015Bcia i wyj\u015Bcia, w\u0142asna karta czasu pracy, grafik i wnioski",
  "worktime.view": "RCP \u2014 karty czasu pracy i zestawienia zespo\u0142u",
  "worktime.manage": "RCP \u2014 korekty wpis\xF3w, profile czasu pracy, okresy rozliczeniowe, eksport",
  "worktime.settings": "RCP \u2014 regu\u0142y kontroli grafiku (odpoczynek, tygodniowy czas pracy)",
  "leave.view": "Urlopy \u2014 salda, kalendarz i wnioski zespo\u0142u z danymi z InsERT (kierownik: sw\xF3j zesp\xF3\u0142; dane osobowe pracownik\xF3w)",
  "leave.manage": "Urlopy \u2014 r\u0119czny wymiar i zaleg\u0142y urlop, powi\u0105zanie pracownik\xF3w kadr z InsERT z kontami NEXOPS",
  "costs.view": "Koszty z ksi\u0119gi \u2014 kadry wg dzia\u0142\xF3w, flota wg pojazd\xF3w, produkcja, mapa kont",
  "collections.view": "Windykacja \u2014 nale\u017Cno\u015Bci, lista wstydu, Top 40, \u015Bcie\u017Cka windykacji i e-monity (handlowiec: tylko swoi klienci)",
  "collections.manage": "Windykacja \u2014 sprawy w kancelarii, import factoringu, wysy\u0142ka Top 40",
  "cashflow.view": "Finanse \u2014 cash flow (kasy, bank, zobowi\u0105zania, prognoza p\u0142ynno\u015Bci)",
  "cashflow.manage": "Finanse \u2014 cash flow: wpisywanie stanu rachunk\xF3w bankowych",
  "purchasing.view": "Zakupy \u2014 dostawcy, zakup po PZ, stany magazynowe, prognoza i ilo\u015Bci do zam\xF3wienia (ca\u0142a organizacja)",
  "quality.view": "Jako\u015B\u0107 \u2014 rejestr i analityka reklamacji (handlowiec: reklamacje swoich klient\xF3w)",
  "quality.events": "Jako\u015B\u0107 \u2014 rejestr zdarze\u0144 jako\u015Bciowych i uzgodnienia z dostawcami (podgl\u0105d)",
  "quality.manage": "Jako\u015B\u0107 \u2014 status obs\u0142ugi reklamacji, zdarzenia jako\u015Bciowe, uzgodnienia z dostawcami",
  "commissions.view": "Prowizje handlowc\xF3w z ERP (handlowiec \u2014 w\u0142asne, kierownik \u2014 zesp\xF3\u0142, zarz\u0105d \u2014 wszystkie)",
  "retro.view": "Retro przy kliencie \u2014 podgl\u0105d i mar\u017Ca po retro (wy\u0142\u0105cznie zarz\u0105d i administrator, D15)",
  "retro.manage": "Retro przy kliencie \u2014 wpisywanie i zmiana (wy\u0142\u0105cznie zarz\u0105d i administrator, D15)",
  "warehouse.view": "Magazyn \u2014 normy i wykonanie (zmiany, zespo\u0142y, osoby), analizy pod premie",
  "warehouse.manage": "Magazyn \u2014 lokalizacje, zespo\u0142y, korekta norm, ustawienia, import zdarze\u0144 kompletacji (CSV z WMS)",
  "surveys.manage": "Ankiety klient\xF3w \u2014 kreator szablon\xF3w i wyniki (kierownik: odpowiedzi klient\xF3w zespo\u0142u)",
  "prices.view": "Cennik i ceny klienta z ERP \u2014 poziomy cen, ceny indywidualne i rabaty (handlowiec: swoi klienci, kierownik: zesp\xF3\u0142)",
  "prices.compare_invoice": "Por\xF3wnanie faktury ze zdj\u0119cia / PDF z naszym cennikiem \u2014 odczyt przez AI, oszcz\u0119dno\u015B\u0107 klienta, propozycja cenowa (handlowiec: swoi klienci, kierownik: zesp\xF3\u0142)"
};
var ALL = Object.keys(PERMISSIONS);
var FLEET_MANAGE = [
  "fleet.vehicles.write",
  "fleet.leases.write",
  "fleet.logbook.own",
  "fleet.logbook.review",
  "fleet.odometer.correct",
  "fleet.fuel.write",
  "fleet.fuel.review",
  "fleet.expenses.write",
  "fleet.expenses.review",
  "fleet.incidents.write",
  "fleet.incidents.manage",
  "fleet.settings",
  "fleet.integration"
];
var INSURANCE_MANAGE = ["insurance.manage", "claims.qualify", "claims.manage", "tenders.manage"];
var INSURANCE_READ = ["insurance.view", "insurance.analytics", "claims.view"];
var WORKTIME_OWN = ["worktime.own"];
var PLANNER_MANAGE = ["planner.view", "planner.manage", "worktime.own", "worktime.view", "worktime.manage", "leave.view", "leave.manage"];
var QUALITY_ALL = ["quality.view", "quality.events", "quality.manage"];
var FLEET_READ = ["fleet.vehicles.read", "fleet.leases.read", "fleet.logbook.read", "fleet.analytics"];
var SALES_BASE = [
  "customers.read",
  "customers.write",
  "customers.financial.read",
  "leads.read",
  "leads.write",
  "visits.read",
  "visits.write",
  "tasks.read",
  "tasks.write",
  "orders.read",
  "logistics.read",
  "receivables.read",
  "workflow.start",
  "targets.read",
  "bi.sales",
  "ai.insights",
  "chat.use",
  // Windykacja: handlowiec widzi tylko swoich klientów (zakres OWN / TEAM egzekwuje backend).
  "collections.view",
  // Cennik i ceny klienta (NX-416): ceny sprzedaży (bez cen zakupu i marży) - handlowiec ich potrzebuje do oferty.
  "prices.view",
  // Porównanie faktury z cennikiem (NX-417): zdjęcie faktury od konkurencji -> ile klient zapłaciłby u nas.
  "prices.compare_invoice",
  // Zamówienie od handlowca (NX-419): do kolejki Biura zamówień, cena z cennika klienta (zakres OWN / TEAM egzekwuje backend).
  "orders.create"
];
var DEFAULT_ROLE_PERMISSIONS = {
  ADMIN: ALL,
  BOARD: ALL.filter(
    (p) => !p.startsWith("admin.") && p !== "erp.sync" && p !== "erp.sync.run" && !FLEET_MANAGE.includes(p) && !INSURANCE_MANAGE.includes(p) && !["planner.manage", "worktime.manage", "worktime.settings", "leave.manage"].includes(p) && p !== "warehouse.manage"
  ),
  SALES_MANAGER: [
    ...SALES_BASE,
    "customers.reassign",
    "targets.write",
    "bi.team",
    "bi.profitability",
    "bi.receivables",
    "workflow.approve.prices",
    "logistics.insights",
    "chat.broadcast",
    "notifications.announce",
    ...FLEET_READ,
    // Raport zarządu bez kosztów i kadr (mbr.finance / mbr.hr); klienci i handlowcy w zakresie TEAM.
    "mbr.read",
    "mbr.write",
    ...PLANNER_MANAGE,
    ...QUALITY_ALL,
    // Prowizje zespołu (zakres TEAM); retro przy kliencie NIE (D15: tylko zarząd i administrator).
    "commissions.view",
    // Kreator ankiet klientów i wyniki (odpowiedzi klientów zespołu - zakres TEAM).
    "surveys.manage"
  ],
  // Handlowiec: reklamacje i prowizje swoich klientów, wysyłka dokumentów do swoich klientów (D23; zakres OWN egzekwuje backend).
  SALES_REP: [...SALES_BASE, ...WORKTIME_OWN, "quality.view", "commissions.view", "customers.documents.send"],
  LOGISTICS: [
    "customers.read",
    "orders.read",
    "logistics.read",
    "logistics.write",
    "logistics.insights",
    "tasks.read",
    "tasks.write",
    "workflow.approve.logistics",
    "chat.use",
    "mbr.write",
    ...WORKTIME_OWN,
    // Zakupy (etap 3a): logistyka planuje zamówienia do dostawców - dane całej organizacji, bez handlowców.
    "purchasing.view",
    ...QUALITY_ALL
  ],
  // Dział zamówień: ceny klienta do kontroli zamówień i faktur (NX-416 / NX-417), kolejka zamówień od handlowców (NX-419).
  ORDER_DESK: ["customers.read", "orders.read", "logistics.read", "logistics.insights", "tasks.read", "tasks.write", "workflow.approve.orders", "chat.use", "mbr.write", ...WORKTIME_OWN, "prices.view", "orders.manage"],
  COLLECTIONS: [
    "customers.read",
    "customers.financial.read",
    "receivables.read",
    "bi.receivables",
    "tasks.read",
    "tasks.write",
    "workflow.approve.credit",
    "chat.use",
    "mbr.write",
    ...WORKTIME_OWN,
    "collections.view",
    "collections.manage",
    // D23: wysyłka zestawień, potwierdzeń salda i przypomnień do wszystkich klientów.
    "customers.documents.send",
    "cashflow.view",
    "cashflow.manage"
  ],
  // Fleet. Kierowca widzi tylko własne karty i przypisane pojazdy (zakres OWN egzekwuje backend).
  DRIVER: [
    "fleet.vehicles.read",
    "fleet.logbook.own",
    "fleet.fuel.write",
    "fleet.expenses.write",
    "fleet.incidents.write",
    "chat.use",
    ...WORKTIME_OWN
  ],
  FLEET_ADMIN: [
    ...FLEET_READ,
    ...FLEET_MANAGE,
    "fleet.insights",
    ...INSURANCE_READ,
    ...INSURANCE_MANAGE,
    "customers.read",
    "logistics.read",
    "tasks.read",
    "tasks.write",
    "chat.use",
    "mbr.write",
    // Grafik i RCP kierowców (zakres ALL — filtr działu w planerze).
    ...PLANNER_MANAGE
  ],
  DISPATCHER: [
    "fleet.vehicles.read",
    "fleet.leases.read",
    "fleet.logbook.read",
    "fleet.logbook.review",
    "fleet.incidents.write",
    "fleet.incidents.manage",
    // Dyspozytor kwalifikuje zgłoszenia floty do szkód; likwidację prowadzi administrator floty.
    "claims.view",
    "claims.qualify",
    "logistics.read",
    "tasks.read",
    "tasks.write",
    "chat.use",
    ...PLANNER_MANAGE
  ],
  // Magazyn (Etap 6): kierownik magazynu — normy i wykonanie, grafik i RCP magazynierów (zakres ALL).
  WAREHOUSE_MANAGER: ["warehouse.view", "warehouse.manage", "tasks.read", "tasks.write", "chat.use", ...PLANNER_MANAGE],
  // Magazynier: własne odbicia RCP i czat; wykonania norm nie widzi (decyzja: kierownik, zarząd, administrator).
  WAREHOUSE: ["chat.use", ...WORKTIME_OWN]
};
function roleHasPermission(role, permission) {
  return DEFAULT_ROLE_PERMISSIONS[role].includes(permission);
}

// src/domain.ts
var CUSTOMER_STATUSES = ["NEW", "ACTIVE", "INACTIVE", "LOST", "RECOVERED", "TO_CONTACT"];
var LEAD_STAGES = [
  "NEW",
  "CONTACTED",
  "QUALIFIED",
  "VISIT",
  "OFFER",
  "APPROVAL",
  "WON",
  "LOST"
];
var ALERT_TYPES = [
  "SALES_DROP",
  "NO_ORDER",
  "MARGIN_DROP",
  "PRODUCT_LOST",
  "CROSS_SELL",
  "VISIT_DUE",
  "DELIVERY_FAILED",
  "DELIVERY_LATE"
];
var ALERT_SEVERITIES = ["CRITICAL", "WARNING", "INFO", "OPPORTUNITY"];
var CONTACT_CADENCE_DAYS = { A: 7, B: 14, C: 30, STRATEGIC: 14 };

// src/i18n/en.ts
var en = {
  app: { name: "NEXOPS", tagline: "Sales \xB7 Customers \xB7 Analytics" },
  nav: {
    myDay: "My day",
    customers: "Customers",
    leads: "Leads",
    visits: "Visits",
    tasks: "Tasks",
    workflow: "Approvals",
    analytics: "Analytics",
    logistics: "Logistics",
    admin: "Administration"
  },
  roles: {
    ADMIN: "Administrator",
    BOARD: "Board",
    SALES_MANAGER: "Sales manager",
    SALES_REP: "Sales rep",
    LOGISTICS: "Logistics",
    ORDER_DESK: "Order desk",
    COLLECTIONS: "Collections",
    DRIVER: "Driver",
    FLEET_ADMIN: "Fleet administrator",
    DISPATCHER: "Dispatcher",
    WAREHOUSE_MANAGER: "Warehouse manager",
    WAREHOUSE: "Warehouse operative"
  },
  customerStatus: {
    NEW: "New",
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    LOST: "Lost",
    RECOVERED: "Recovered",
    TO_CONTACT: "To contact"
  },
  common: {
    save: "Save",
    cancel: "Cancel",
    search: "Search\u2026",
    loading: "Loading\u2026",
    empty: "No data",
    logout: "Log out",
    login: "Log in",
    email: "E-mail",
    password: "Password"
  },
  workflow: {
    status: {
      PENDING: "Pending",
      IN_PROGRESS: "In progress",
      RETURNED: "Returned for changes",
      APPROVED: "Approved",
      REJECTED: "Rejected",
      CANCELLED: "Cancelled"
    },
    stepStatus: {
      PENDING: "Awaiting decision",
      APPROVED: "Approved",
      RETURNED: "Returned",
      REJECTED: "Rejected",
      SKIPPED: "Skipped"
    },
    area: { SALES: "Sales", LOGISTICS: "Logistics", ORDERS: "Orders", CREDIT: "Collections" },
    decision: { APPROVE: "Approve", RETURN: "Return for changes", REJECT: "Reject" },
    event: {
      STARTED: "Request submitted",
      DECISION: "Department decision",
      RETURNED: "Returned for changes",
      RESUBMITTED: "Resubmitted",
      CANCELLED: "Request cancelled",
      OVERDUE: "Deadline exceeded",
      COMPLETED: "All departments approved"
    },
    notification: {
      WORKFLOW_STEP_WAITING: "Request awaits your approval",
      WORKFLOW_STEP_DECIDED: "A department made a decision",
      WORKFLOW_RETURNED: "Request returned for changes",
      WORKFLOW_RESUBMITTED: "Request corrected and resubmitted",
      WORKFLOW_ALL_APPROVED: "All departments approved",
      WORKFLOW_APPROVED: "Request completed",
      WORKFLOW_REJECTED: "Request rejected",
      WORKFLOW_CANCELLED: "Request cancelled",
      WORKFLOW_STEP_OVERDUE: "Approval deadline exceeded"
    },
    error: {
      FORBIDDEN: "You are not allowed to do this.",
      NOT_FOUND: "Request not found.",
      STEP_NOT_FOUND: "Step not found.",
      PROCESS_NOT_FOUND: "Approval process not found.",
      REQUEST_EXISTS: "An approval request is already in progress for this customer.",
      REQUEST_CLOSED: "The request is already closed.",
      STEP_ALREADY_DECIDED: "This step has already been decided.",
      STEP_NOT_CURRENT: "This step is not active yet.",
      NOT_RETURNED: "A request can be resubmitted only after it was returned for changes.",
      REQUEST_CHANGED: "The request changed in the meantime \u2014 refresh and try again.",
      NOT_APPROVED: "Export is available only after all departments approved.",
      LEAD_LOST: "The lead is lost.",
      COMMENT_REQUIRED: "A comment is required when returning or rejecting.",
      INVALID_STEP_DATA: "Department data has an invalid format.",
      STEP_DATA_REQUIRED: "Choose the approved payment method and the B2B account decision.",
      INVALID_ROUTE: "The selected route does not exist or is inactive."
    }
  },
  cardEnum: {
    paymentMethod: {
      TRANSFER: "Bank transfer",
      CASH: "Cash",
      CARD: "Payment card",
      CASH_ON_DELIVERY: "Cash on delivery",
      COMPENSATION: "Offset (compensation)",
      OTHER: "Other"
    },
    targetDocument: { INVOICE: "VAT invoice", RECEIPT: "Receipt", WZ: "Goods issue note (WZ)" },
    deliveryPriority: { HIGH: "High", NORMAL: "Normal", LOW: "Low" },
    b2bStatus: { YES: "Yes", NO: "No", NEW: "Newly created", TO_CREATE: "To be created" },
    contactRole: {
      OWNER: "Owner",
      ACCOUNTING: "Accounting",
      OFFICE: "Office",
      EMPLOYEE: "Employee",
      DELIVERY_RECEIVER: "Delivery receiver",
      OTHER: "Other"
    },
    reportClientStatus: { NEW: "New", SERVICED: "Serviced", RECOVERED: "Recovered" },
    reportOffer: { YES: "Yes", NO: "No", TO_PREPARE: "To prepare" },
    reportPeriodType: { WEEK: "Week", MONTH: "Month" },
    b2bDecision: { CREATE: "Create a B2B account", SKIP: "No B2B account" },
    potentialBand: {
      "1k-5k": "PLN 1\u20135k",
      "5k-10k": "PLN 5\u201310k",
      "10k-15k": "PLN 10\u201315k",
      "15k-20k": "PLN 15\u201320k",
      "20k-30k": "PLN 20\u201330k",
      "30k-40k": "PLN 30\u201340k",
      "40k-50k": "PLN 40\u201350k",
      "50k-60k": "PLN 50\u201360k",
      "60k-80k": "PLN 60\u201380k",
      "80k-100k": "PLN 80\u2013100k",
      "100k+": "over PLN 100k"
    },
    competitorOther: "Other"
  },
  fleet: {
    nav: {
      title: "Fleet",
      vehicles: "Vehicles",
      leases: "Leases",
      logbooks: "Logbooks",
      myLogbooks: "My logbooks",
      settings: "Fleet settings"
    },
    vehicleStatus: {
      ACTIVE: "Active",
      IN_SERVICE: "In service",
      DECOMMISSIONED: "Decommissioned"
    },
    vehicleType: {
      PASSENGER_CAR: "Passenger car",
      VAN: "Van",
      TRUCK: "Truck",
      REFRIGERATED_VAN: "Refrigerated van",
      REFRIGERATED_TRUCK: "Refrigerated truck",
      TRAILER: "Trailer",
      OTHER: "Other"
    },
    leaseStatus: {
      ACTIVE: "Active",
      ENDED: "Ended",
      CANCELLED: "Cancelled"
    },
    leaseWarning: {
      OK: "On track",
      WARNING_1: "Warning",
      WARNING_2: "High risk",
      EXCEEDED: "Limit exceeded"
    },
    indicative: "Indicative forecast \u2014 not enough data",
    odometerSource: {
      MANUAL: "Manual entry",
      LOGBOOK_START: "Logbook start",
      LOGBOOK_END: "Logbook end",
      FUEL: "Refuelling",
      SERVICE: "Service",
      CHECKLIST: "Checklist",
      IMPORT: "Import",
      LEASE_START: "Lease start",
      CORRECTION: "Odometer correction"
    },
    logbookStatus: {
      DRAFT: "Draft",
      OPEN: "Open",
      SUBMITTED: "Awaiting review",
      APPROVED: "Approved",
      RETURNED: "Returned",
      DISCREPANCY: "Discrepancy"
    },
    logbookAction: {
      start: "Start",
      submit: "Finish and submit",
      resubmit: "Resubmit",
      approve: "Approve",
      return: "Return for correction",
      discrepancy: "Mark discrepancy"
    },
    logbookEvent: {
      CREATED: "Logbook created",
      STARTED: "Trip started",
      SUBMITTED: "Submitted for review",
      RESUBMITTED: "Resubmitted",
      APPROVED: "Approved",
      RETURNED: "Returned for correction",
      DISCREPANCY: "Discrepancy marked",
      ODOMETER_CORRECTED: "Odometer corrected",
      UPDATED: "Logbook data changed"
    },
    logbookFlag: {
      KM_ABOVE_PLAN: "Distance above plan",
      KM_BELOW_PLAN: "Distance below plan",
      KM_ABOVE_DAILY_MAX: "Distance above daily maximum",
      METER_EVENT: "Odometer correction or replacement during the trip"
    },
    requirements: {
      CHECKLIST_BEFORE_TRIP: "The pre-trip checklist has not been completed.",
      CHECKLIST_AFTER_TRIP: "The post-trip checklist has not been completed.",
      CHECKLIST_DRAFT_OPEN: "A checklist linked to this logbook has not been submitted \u2014 submit or delete it."
    },
    errors: {
      VEHICLE_NOT_FOUND: "Vehicle not found.",
      PLATE_EXISTS: "A vehicle with this plate number already exists.",
      VIN_EXISTS: "A vehicle with this VIN already exists.",
      DRIVER_NOT_FOUND: "Driver not found.",
      DRIVER_NOT_DRIVER_ROLE: "This account does not have the driver role.",
      GROUP_NOT_FOUND: "Driver group not found.",
      GROUP_EXISTS: "A group with this name already exists.",
      ASSIGNMENT_NOT_FOUND: "Assignment not found.",
      ASSIGNMENT_OVERLAP: "The assignment period overlaps another assignment of this vehicle.",
      ASSIGNMENT_INVALID_RANGE: "The assignment end date is before its start.",
      LEASE_NOT_FOUND: "Lease contract not found.",
      LEASE_OVERLAP: "The vehicle already has an active lease in this period.",
      LEASE_NUMBER_EXISTS: "A lease with this contract number already exists.",
      LEASE_INVALID_RANGE: "The contract end date must be after its start.",
      LEASE_THRESHOLDS_INVALID: "Warning thresholds must be increasing and within 1\u2013100.",
      ODOMETER_NOT_MONOTONIC: "The odometer value cannot be lower than the previous reading.",
      ODOMETER_CORRECTION_REASON_REQUIRED: "An odometer correction requires a reason.",
      ODOMETER_CORRECTION_NOT_LATEST: "A logbook can be corrected only while its reading is the latest of the vehicle.",
      LOGBOOK_NOT_FOUND: "Logbook not found.",
      LOGBOOK_INVALID_TRANSITION: "This action is not available in the current logbook status.",
      LOGBOOK_VEHICLE_BUSY: "This vehicle already has an open logbook.",
      LOGBOOK_DRIVER_BUSY: "The driver already has an open logbook.",
      LOGBOOK_VEHICLE_NOT_ACTIVE: "The vehicle is not active.",
      LOGBOOK_NOT_ASSIGNED: "The vehicle is not assigned to this driver.",
      LOGBOOK_END_BELOW_START: "The end odometer cannot be lower than the start.",
      LOGBOOK_NOTE_REQUIRED: "Distance exceeds the daily maximum \u2014 add an explanation in the notes.",
      LOGBOOK_REVIEW_COMMENT_REQUIRED: "Add a comment to this decision.",
      LOGBOOK_SELF_REVIEW: "You cannot approve your own logbook.",
      LOGBOOK_NOT_EDITABLE: "A logbook in this status cannot be edited.",
      LOGBOOK_ODOMETER_REQUIRED: "Enter the odometer value.",
      FUEL_NOT_FOUND: "Fuel entry not found.",
      FUEL_INVALID_TRANSITION: "This action is not available in the current fuel entry status.",
      FUEL_NOT_EDITABLE: "This fuel entry can no longer be edited.",
      FUEL_EXTERNAL_ID_EXISTS: "A transaction with this identifier has already been recorded.",
      FUEL_INCOMPLETE: "Complete the fuel entry (the date cannot be in the future).",
      FUEL_RECEIPT_REQUIRED: "Attach a receipt photo to approve the fuel entry.",
      EXPENSE_NOT_FOUND: "Expense not found.",
      EXPENSE_INVALID_TRANSITION: "This action is not available in the current expense status.",
      EXPENSE_NOT_EDITABLE: "This expense can no longer be edited.",
      EXPENSE_DESCRIPTION_REQUIRED: "A description is required for the category Other.",
      REVIEW_COMMENT_REQUIRED: "A comment is required.",
      REVIEW_SELF: "You cannot review your own entry.",
      CHECKLIST_TEMPLATE_NOT_FOUND: "Checklist template not found.",
      CHECKLIST_TEMPLATE_INVALID: "The checklist template is invalid or its code already exists.",
      CHECKLIST_TEMPLATE_INACTIVE: "This checklist version is no longer active.",
      CHECKLIST_TEMPLATE_VEHICLE_TYPE: "This checklist does not apply to this vehicle type.",
      CHECKLIST_RUN_NOT_FOUND: "Checklist not found.",
      CHECKLIST_RUN_NOT_EDITABLE: "The checklist has already been submitted.",
      CHECKLIST_INCOMPLETE: "Complete every checklist item (result, photo, comment).",
      CHECKLIST_ANSWER_INVALID: "Invalid checklist item.",
      INCIDENT_NOT_FOUND: "Incident not found.",
      INCIDENT_TEMPLATE_NOT_FOUND: "Incident template not found.",
      INCIDENT_TEMPLATE_INVALID: "The incident template is invalid or its name already exists.",
      INCIDENT_INVALID_TRANSITION: "This incident status change is not allowed.",
      INCIDENT_FIELD_INVALID: "Complete the required incident fields.",
      INCIDENT_DECISION_NOT_PENDING: "This incident is not waiting for a vehicle decision.",
      SERVICE_RECORD_NOT_FOUND: "Service record not found.",
      LOGBOOK_REQUIREMENTS_MISSING: "Complete the required forms before closing the logbook.",
      LOGBOOK_VEHICLE_PENDING_DECISION: "The vehicle awaits a decision after a reported defect - the logbook cannot be started.",
      ATTACHMENT_ENTITY_NOT_ALLOWED: "Attachments cannot be added to this item.",
      ANALYTICS_RANGE_INVALID: "The period start is later than its end.",
      ANALYTICS_RANGE_TOO_LARGE: "The period is too long \u2014 choose at most 1830 days (about 5 years).",
      FLEET_ALERT_NOT_FOUND: "Fleet alert not found.",
      FLEET_ALERT_RESOLVED: "This alert is already closed.",
      ROUTE_NOT_FOUND: "Route not found.",
      ROUTE_SYNC_RUN_NOT_FOUND: "Sync run not found.",
      ROUTE_IMPORT_FILE_REQUIRED: "Choose a CSV file to import.",
      ROUTE_IMPORT_FILE_TOO_LARGE: "The file is too large \u2014 the limit is 5 MB.",
      ROUTE_IMPORT_HEADER_INVALID: "The file header is invalid \u2014 required columns (route_id, route_date) are missing or one is duplicated.",
      ROUTE_IMPORT_EMPTY: "The file is empty.",
      ROUTE_ID_MAP_INVALID: "Provide exactly one vehicle (for a vehicle mapping) or driver (for a driver mapping) and a non-empty external value.",
      ROUTE_ID_MAP_NOT_FOUND: "Mapping not found.",
      ROUTE_LOGBOOK_NOT_FOUND: "Logbook linked to this route not found.",
      ROUTE_LOGBOOK_ALREADY_LINKED: "This logbook is already linked to another route.",
      ROUTE_VEHICLE_REQUIRED: "Map the route to a vehicle first, then link a logbook to it.",
      ROUTE_IMPORT_DUPLICATE: "These routes are already being imported (a parallel import of the same file) \u2014 refresh and check the result.",
      ROUTE_SYNC_FAILED: "The import failed \u2014 see the sync run log for details."
    }
  }
};

// src/i18n/pl.ts
var pl = {
  app: { name: "NEXOPS", tagline: "Sprzeda\u017C \xB7 Klienci \xB7 Analityka" },
  nav: {
    myDay: "M\xF3j dzie\u0144",
    customers: "Klienci",
    leads: "Leady",
    visits: "Wizyty",
    tasks: "Zadania",
    workflow: "Akceptacje",
    analytics: "Analityka",
    logistics: "Logistyka",
    admin: "Administracja"
  },
  roles: {
    ADMIN: "Administrator",
    BOARD: "Zarz\u0105d",
    SALES_MANAGER: "Kierownik sprzeda\u017Cy",
    SALES_REP: "Handlowiec",
    LOGISTICS: "Logistyka",
    ORDER_DESK: "Dzia\u0142 zam\xF3wie\u0144",
    COLLECTIONS: "Windykacja",
    DRIVER: "Kierowca",
    FLEET_ADMIN: "Administrator floty",
    DISPATCHER: "Dyspozytor",
    WAREHOUSE_MANAGER: "Kierownik magazynu",
    WAREHOUSE: "Magazynier"
  },
  customerStatus: {
    NEW: "Nowy",
    ACTIVE: "Aktywny",
    INACTIVE: "Nieaktywny",
    LOST: "Utracony",
    RECOVERED: "Odzyskany",
    TO_CONTACT: "Do kontaktu"
  },
  common: {
    save: "Zapisz",
    cancel: "Anuluj",
    search: "Szukaj\u2026",
    loading: "\u0141adowanie\u2026",
    empty: "Brak danych",
    logout: "Wyloguj",
    login: "Zaloguj",
    email: "E-mail",
    password: "Has\u0142o"
  },
  workflow: {
    status: {
      PENDING: "Oczekuje",
      IN_PROGRESS: "W toku",
      RETURNED: "Zwr\xF3cony do poprawy",
      APPROVED: "Zaakceptowany",
      REJECTED: "Odrzucony",
      CANCELLED: "Anulowany"
    },
    stepStatus: {
      PENDING: "Czeka na decyzj\u0119",
      APPROVED: "Zaakceptowano",
      RETURNED: "Zwr\xF3cono",
      REJECTED: "Odrzucono",
      SKIPPED: "Pomini\u0119ty"
    },
    area: { SALES: "Handlowy", LOGISTICS: "Logistyka", ORDERS: "Zam\xF3wienia", CREDIT: "Windykacja" },
    decision: { APPROVE: "Zaakceptuj", RETURN: "Zwr\xF3\u0107 do poprawy", REJECT: "Odrzu\u0107" },
    event: {
      STARTED: "Wniosek zg\u0142oszony",
      DECISION: "Decyzja dzia\u0142u",
      RETURNED: "Zwrot do poprawy",
      RESUBMITTED: "Wys\u0142ano ponownie",
      CANCELLED: "Wniosek anulowany",
      OVERDUE: "Przekroczony termin",
      COMPLETED: "Wszystkie dzia\u0142y zaakceptowa\u0142y"
    },
    notification: {
      WORKFLOW_STEP_WAITING: "Wniosek czeka na akceptacj\u0119",
      WORKFLOW_STEP_DECIDED: "Dzia\u0142 podj\u0105\u0142 decyzj\u0119",
      WORKFLOW_RETURNED: "Wniosek zwr\xF3cony do poprawy",
      WORKFLOW_RESUBMITTED: "Wniosek poprawiony i wys\u0142any ponownie",
      WORKFLOW_ALL_APPROVED: "Wszystkie dzia\u0142y zaakceptowa\u0142y",
      WORKFLOW_APPROVED: "Wniosek zako\u0144czony",
      WORKFLOW_REJECTED: "Wniosek odrzucony",
      WORKFLOW_CANCELLED: "Wniosek anulowany",
      WORKFLOW_STEP_OVERDUE: "Przekroczony termin akceptacji"
    },
    error: {
      FORBIDDEN: "Brak uprawnie\u0144 do tej operacji.",
      NOT_FOUND: "Nie znaleziono wniosku.",
      STEP_NOT_FOUND: "Nie znaleziono kroku.",
      PROCESS_NOT_FOUND: "Nie znaleziono procesu akceptacji.",
      REQUEST_EXISTS: "Dla tego klienta trwa ju\u017C wniosek o akceptacj\u0119.",
      REQUEST_CLOSED: "Wniosek jest ju\u017C zamkni\u0119ty.",
      STEP_ALREADY_DECIDED: "Ten krok zosta\u0142 ju\u017C rozstrzygni\u0119ty.",
      STEP_NOT_CURRENT: "Ten krok nie jest jeszcze aktywny.",
      NOT_RETURNED: "Wniosek mo\u017Cna wys\u0142a\u0107 ponownie tylko po zwrocie do poprawy.",
      REQUEST_CHANGED: "Wniosek zmieni\u0142 si\u0119 w mi\u0119dzyczasie \u2014 od\u015Bwie\u017C i spr\xF3buj ponownie.",
      NOT_APPROVED: "Eksport jest dost\u0119pny dopiero po akceptacji wszystkich dzia\u0142\xF3w.",
      LEAD_LOST: "Lead jest utracony.",
      COMMENT_REQUIRED: "Przy zwrocie i odrzuceniu komentarz jest wymagany.",
      INVALID_STEP_DATA: "Dane dzia\u0142u maj\u0105 nieprawid\u0142owy format.",
      STEP_DATA_REQUIRED: "Wybierz rodzaj p\u0142atno\u015Bci zaakceptowanej i decyzj\u0119 o koncie B2B.",
      INVALID_ROUTE: "Wybrana trasa nie istnieje lub jest nieaktywna."
    }
  },
  /** Etykiety enumów karty klienta i raportu dziennego (customer-card.ts, daily-report-entries.ts). */
  cardEnum: {
    paymentMethod: {
      TRANSFER: "Przelew",
      CASH: "Got\xF3wka",
      CARD: "Karta p\u0142atnicza",
      CASH_ON_DELIVERY: "Pobranie",
      COMPENSATION: "Kompensata",
      OTHER: "Inna"
    },
    targetDocument: { INVOICE: "Faktura VAT", RECEIPT: "Paragon", WZ: "WZ" },
    deliveryPriority: { HIGH: "Wysoki", NORMAL: "Normalny", LOW: "Niski" },
    b2bStatus: { YES: "Tak", NO: "Nie", NEW: "Nowo za\u0142o\u017Cone", TO_CREATE: "Do za\u0142o\u017Cenia" },
    contactRole: {
      OWNER: "W\u0142a\u015Bciciel",
      ACCOUNTING: "Ksi\u0119gowo\u015B\u0107",
      OFFICE: "Biuro",
      EMPLOYEE: "Pracownik",
      DELIVERY_RECEIVER: "Odbieraj\u0105cy dostawy",
      OTHER: "Inna"
    },
    reportClientStatus: { NEW: "Nowy", SERVICED: "Obs\u0142ugiwany", RECOVERED: "Odzyskany" },
    reportOffer: { YES: "Tak", NO: "Nie", TO_PREPARE: "Do przygotowania" },
    reportPeriodType: { WEEK: "Tydzie\u0144", MONTH: "Miesi\u0105c" },
    b2bDecision: { CREATE: "Zak\u0142adamy konto B2B", SKIP: "Bez konta B2B" },
    potentialBand: {
      "1k-5k": "1\u20135 tys. z\u0142",
      "5k-10k": "5\u201310 tys. z\u0142",
      "10k-15k": "10\u201315 tys. z\u0142",
      "15k-20k": "15\u201320 tys. z\u0142",
      "20k-30k": "20\u201330 tys. z\u0142",
      "30k-40k": "30\u201340 tys. z\u0142",
      "40k-50k": "40\u201350 tys. z\u0142",
      "50k-60k": "50\u201360 tys. z\u0142",
      "60k-80k": "60\u201380 tys. z\u0142",
      "80k-100k": "80\u2013100 tys. z\u0142",
      "100k+": "powy\u017Cej 100 tys. z\u0142"
    },
    competitorOther: "Inny"
  },
  fleet: {
    nav: {
      title: "Flota",
      vehicles: "Pojazdy",
      leases: "Leasingi",
      logbooks: "Karty drogowe",
      myLogbooks: "Moje karty",
      settings: "Ustawienia floty"
    },
    vehicleStatus: {
      ACTIVE: "Aktywny",
      IN_SERVICE: "W serwisie",
      DECOMMISSIONED: "Wycofany"
    },
    vehicleType: {
      PASSENGER_CAR: "Samoch\xF3d osobowy",
      VAN: "Samoch\xF3d dostawczy",
      TRUCK: "Samoch\xF3d ci\u0119\u017Carowy",
      REFRIGERATED_VAN: "Dostawczy ch\u0142odnia",
      REFRIGERATED_TRUCK: "Ci\u0119\u017Carowy ch\u0142odnia",
      TRAILER: "Naczepa / przyczepa",
      OTHER: "Inny"
    },
    leaseStatus: {
      ACTIVE: "Aktywna",
      ENDED: "Zako\u0144czona",
      CANCELLED: "Anulowana"
    },
    leaseWarning: {
      OK: "W normie",
      WARNING_1: "Ostrze\u017Cenie",
      WARNING_2: "Wysokie ryzyko",
      EXCEEDED: "Limit przekroczony"
    },
    indicative: "Prognoza orientacyjna \u2014 za ma\u0142o danych",
    odometerSource: {
      MANUAL: "Wpis r\u0119czny",
      LOGBOOK_START: "Start karty drogowej",
      LOGBOOK_END: "Koniec karty drogowej",
      FUEL: "Tankowanie",
      SERVICE: "Serwis",
      CHECKLIST: "Checklista",
      IMPORT: "Import",
      LEASE_START: "Start umowy",
      CORRECTION: "Korekta licznika"
    },
    logbookStatus: {
      DRAFT: "Szkic",
      OPEN: "Otwarta",
      SUBMITTED: "Do weryfikacji",
      APPROVED: "Zatwierdzona",
      RETURNED: "Zwr\xF3cona",
      DISCREPANCY: "Rozbie\u017Cno\u015B\u0107"
    },
    logbookAction: {
      start: "Rozpocznij",
      submit: "Zako\u0144cz i wy\u015Blij",
      resubmit: "Wy\u015Blij ponownie",
      approve: "Zatwierd\u017A",
      return: "Zwr\xF3\u0107 do poprawy",
      discrepancy: "Oznacz rozbie\u017Cno\u015B\u0107"
    },
    logbookEvent: {
      CREATED: "Utworzono kart\u0119",
      STARTED: "Rozpocz\u0119to tras\u0119",
      SUBMITTED: "Wys\u0142ano do weryfikacji",
      RESUBMITTED: "Wys\u0142ano ponownie",
      APPROVED: "Zatwierdzono",
      RETURNED: "Zwr\xF3cono do poprawy",
      DISCREPANCY: "Oznaczono rozbie\u017Cno\u015B\u0107",
      ODOMETER_CORRECTED: "Skorygowano stan licznika",
      UPDATED: "Zmieniono dane karty"
    },
    logbookFlag: {
      KM_ABOVE_PLAN: "Przebieg powy\u017Cej planu",
      KM_BELOW_PLAN: "Przebieg poni\u017Cej planu",
      KM_ABOVE_DAILY_MAX: "Przebieg powy\u017Cej limitu dziennego",
      METER_EVENT: "Korekta lub wymiana licznika w trakcie"
    },
    requirements: {
      CHECKLIST_BEFORE_TRIP: "Brak wykonanej checklisty przed jazd\u0105.",
      CHECKLIST_AFTER_TRIP: "Brak wykonanej checklisty po je\u017Adzie.",
      CHECKLIST_DRAFT_OPEN: "Jest niewys\u0142ana checklista powi\u0105zana z kart\u0105 \u2014 wy\u015Blij j\u0105 albo usu\u0144."
    },
    errors: {
      VEHICLE_NOT_FOUND: "Nie znaleziono pojazdu.",
      PLATE_EXISTS: "Pojazd z takim numerem rejestracyjnym ju\u017C istnieje.",
      VIN_EXISTS: "Pojazd z takim numerem VIN ju\u017C istnieje.",
      DRIVER_NOT_FOUND: "Nie znaleziono kierowcy.",
      DRIVER_NOT_DRIVER_ROLE: "To konto nie ma roli kierowcy.",
      GROUP_NOT_FOUND: "Nie znaleziono grupy kierowc\xF3w.",
      GROUP_EXISTS: "Grupa o takiej nazwie ju\u017C istnieje.",
      ASSIGNMENT_NOT_FOUND: "Nie znaleziono przypisania.",
      ASSIGNMENT_OVERLAP: "Okres przypisania nak\u0142ada si\u0119 na inne przypisanie tego pojazdu.",
      ASSIGNMENT_INVALID_RANGE: "Data ko\u0144ca przypisania jest wcze\u015Bniejsza ni\u017C pocz\u0105tek.",
      LEASE_NOT_FOUND: "Nie znaleziono umowy leasingowej.",
      LEASE_OVERLAP: "Pojazd ma ju\u017C aktywn\u0105 umow\u0119 w tym okresie.",
      LEASE_NUMBER_EXISTS: "Umowa o takim numerze ju\u017C istnieje.",
      LEASE_INVALID_RANGE: "Data ko\u0144ca umowy musi by\u0107 p\xF3\u017Aniejsza ni\u017C pocz\u0105tek.",
      LEASE_THRESHOLDS_INVALID: "Progi ostrzegawcze musz\u0105 by\u0107 rosn\u0105ce i mie\u015Bci\u0107 si\u0119 w zakresie 1\u2013100.",
      ODOMETER_NOT_MONOTONIC: "Stan licznika nie mo\u017Ce by\u0107 mniejszy ni\u017C poprzedni odczyt.",
      ODOMETER_CORRECTION_REASON_REQUIRED: "Korekta licznika wymaga podania powodu.",
      ODOMETER_CORRECTION_NOT_LATEST: "Korekta karty mo\u017Cliwa tylko dla ostatniego odczytu pojazdu.",
      LOGBOOK_NOT_FOUND: "Nie znaleziono karty drogowej.",
      LOGBOOK_INVALID_TRANSITION: "Ta akcja nie jest dost\u0119pna w obecnym statusie karty.",
      LOGBOOK_VEHICLE_BUSY: "Ten pojazd ma ju\u017C otwart\u0105 kart\u0119 drogow\u0105.",
      LOGBOOK_DRIVER_BUSY: "Kierowca ma ju\u017C otwart\u0105 kart\u0119 drogow\u0105.",
      LOGBOOK_VEHICLE_NOT_ACTIVE: "Pojazd nie jest aktywny.",
      LOGBOOK_NOT_ASSIGNED: "Pojazd nie jest przypisany do tego kierowcy.",
      LOGBOOK_END_BELOW_START: "Stan licznika na ko\u0144cu nie mo\u017Ce by\u0107 mniejszy ni\u017C na starcie.",
      LOGBOOK_NOTE_REQUIRED: "Przebieg przekracza dzienny limit \u2014 dodaj wyja\u015Bnienie w uwagach.",
      LOGBOOK_REVIEW_COMMENT_REQUIRED: "Podaj komentarz do tej decyzji.",
      LOGBOOK_SELF_REVIEW: "Nie mo\u017Cna zatwierdza\u0107 w\u0142asnej karty.",
      LOGBOOK_NOT_EDITABLE: "Kart\u0119 w tym statusie nie mo\u017Cna edytowa\u0107.",
      LOGBOOK_ODOMETER_REQUIRED: "Podaj stan licznika.",
      FUEL_NOT_FOUND: "Nie znaleziono tankowania.",
      FUEL_INVALID_TRANSITION: "Ta akcja nie jest dost\u0119pna w obecnym statusie tankowania.",
      FUEL_NOT_EDITABLE: "Tego tankowania nie mo\u017Cna ju\u017C edytowa\u0107.",
      FUEL_EXTERNAL_ID_EXISTS: "Transakcja o tym identyfikatorze zosta\u0142a ju\u017C zapisana.",
      FUEL_INCOMPLETE: "Uzupe\u0142nij dane tankowania (data nie mo\u017Ce by\u0107 z przysz\u0142o\u015Bci).",
      FUEL_RECEIPT_REQUIRED: "Do\u0142\u0105cz zdj\u0119cie paragonu, aby zaakceptowa\u0107 tankowanie.",
      EXPENSE_NOT_FOUND: "Nie znaleziono kosztu.",
      EXPENSE_INVALID_TRANSITION: "Ta akcja nie jest dost\u0119pna w obecnym statusie kosztu.",
      EXPENSE_NOT_EDITABLE: "Tego kosztu nie mo\u017Cna ju\u017C edytowa\u0107.",
      EXPENSE_DESCRIPTION_REQUIRED: "Dla kategorii \u201EInne\u201D opis jest wymagany.",
      REVIEW_COMMENT_REQUIRED: "Podaj komentarz.",
      REVIEW_SELF: "Nie mo\u017Cesz weryfikowa\u0107 w\u0142asnego wpisu.",
      CHECKLIST_TEMPLATE_NOT_FOUND: "Nie znaleziono szablonu checklisty.",
      CHECKLIST_TEMPLATE_INVALID: "Szablon checklisty jest nieprawid\u0142owy lub jego kod ju\u017C istnieje.",
      CHECKLIST_TEMPLATE_INACTIVE: "Ta wersja checklisty jest ju\u017C nieaktywna.",
      CHECKLIST_TEMPLATE_VEHICLE_TYPE: "Ta checklista nie dotyczy tego typu pojazdu.",
      CHECKLIST_RUN_NOT_FOUND: "Nie znaleziono checklisty.",
      CHECKLIST_RUN_NOT_EDITABLE: "Checklista zosta\u0142a ju\u017C wys\u0142ana.",
      CHECKLIST_INCOMPLETE: "Uzupe\u0142nij wszystkie punkty checklisty (wynik, zdj\u0119cie, komentarz).",
      CHECKLIST_ANSWER_INVALID: "Nieprawid\u0142owy punkt checklisty.",
      INCIDENT_NOT_FOUND: "Nie znaleziono zg\u0142oszenia.",
      INCIDENT_TEMPLATE_NOT_FOUND: "Nie znaleziono szablonu zg\u0142oszenia.",
      INCIDENT_TEMPLATE_INVALID: "Szablon zg\u0142oszenia jest nieprawid\u0142owy lub jego nazwa ju\u017C istnieje.",
      INCIDENT_INVALID_TRANSITION: "Ta zmiana statusu zg\u0142oszenia nie jest dozwolona.",
      INCIDENT_FIELD_INVALID: "Uzupe\u0142nij wymagane pola zg\u0142oszenia.",
      INCIDENT_DECISION_NOT_PENDING: "To zg\u0142oszenie nie czeka na decyzj\u0119 o poje\u017Adzie.",
      SERVICE_RECORD_NOT_FOUND: "Nie znaleziono wpisu serwisowego.",
      LOGBOOK_REQUIREMENTS_MISSING: "Przed zamkni\u0119ciem karty uzupe\u0142nij wymagane formularze.",
      LOGBOOK_VEHICLE_PENDING_DECISION: "Pojazd czeka na decyzj\u0119 po zg\u0142oszonej usterce \u2014 nie mo\u017Cna rozpocz\u0105\u0107 karty.",
      ATTACHMENT_ENTITY_NOT_ALLOWED: "Do tego elementu nie mo\u017Cna doda\u0107 za\u0142\u0105cznika.",
      ANALYTICS_RANGE_INVALID: "Data pocz\u0105tku okresu jest p\xF3\u017Aniejsza ni\u017C data ko\u0144ca.",
      ANALYTICS_RANGE_TOO_LARGE: "Okres jest zbyt d\u0142ugi \u2014 wybierz maksymalnie 1830 dni (ok. 5 lat).",
      FLEET_ALERT_NOT_FOUND: "Nie znaleziono alertu floty.",
      FLEET_ALERT_RESOLVED: "Ten alert jest ju\u017C zamkni\u0119ty.",
      ROUTE_NOT_FOUND: "Nie znaleziono trasy.",
      ROUTE_SYNC_RUN_NOT_FOUND: "Nie znaleziono przebiegu synchronizacji.",
      ROUTE_IMPORT_FILE_REQUIRED: "Wybierz plik CSV do importu.",
      ROUTE_IMPORT_FILE_TOO_LARGE: "Plik jest zbyt du\u017Cy \u2014 limit to 5 MB.",
      ROUTE_IMPORT_HEADER_INVALID: "Nag\u0142\xF3wek pliku jest nieprawid\u0142owy \u2014 brakuje wymaganych kolumn (route_id, route_date) albo kt\xF3ra\u015B si\u0119 powtarza.",
      ROUTE_IMPORT_EMPTY: "Plik jest pusty.",
      ROUTE_ID_MAP_INVALID: "Wska\u017C dok\u0142adnie jeden pojazd (dla pojazdu) lub kierowc\u0119 (dla kierowcy) oraz niepust\u0105 warto\u015B\u0107 zewn\u0119trzn\u0105.",
      ROUTE_ID_MAP_NOT_FOUND: "Nie znaleziono mapowania.",
      ROUTE_LOGBOOK_NOT_FOUND: "Nie znaleziono karty drogowej powi\u0105zanej z t\u0105 tras\u0105.",
      ROUTE_LOGBOOK_ALREADY_LINKED: "Ta karta drogowa jest ju\u017C powi\u0105zana z inn\u0105 tras\u0105.",
      ROUTE_VEHICLE_REQUIRED: "Najpierw przypisz tras\u0119 do pojazdu (mapowanie), potem powi\u0105\u017C z ni\u0105 kart\u0119 drogow\u0105.",
      ROUTE_IMPORT_DUPLICATE: "Te trasy s\u0105 ju\u017C importowane (r\xF3wnoleg\u0142y import tego samego pliku) \u2014 od\u015Bwie\u017C list\u0119 i sprawd\u017A wynik.",
      ROUTE_SYNC_FAILED: "Import nie powi\xF3d\u0142 si\u0119 \u2014 szczeg\xF3\u0142y w dzienniku przebieg\xF3w."
    }
  }
};

// src/i18n/index.ts
var LOCALES = ["pl", "en"];
var DEFAULT_LOCALE = "pl";
var messages = { pl, en };

// src/customer-groups.ts
var CUSTOMER_GROUP_BY = ["status", "customerClass", "owner", "segment", "city"];
var CUSTOMER_GROUP_NONE = "__none";

// src/sales-work.ts
var TASK_PRIORITIES = ["NORMAL", "HIGH", "URGENT"];
var TASK_RECURRENCES = ["NONE", "DAILY", "WEEKLY", "BIWEEKLY", "MONTHLY"];
var TASK_REMINDER_MINUTES = [0, 15, 60, 1440];
var PRIORITY_RANK = { NORMAL: 0, HIGH: 1, URGENT: 2 };
var BULK_TASK_ACTIONS = ["complete", "cancel", "snooze", "assign", "priority"];
var BULK_TASKS_MAX = 100;

// src/analytics.ts
var SALES_BASES = ["FS", "WZ"];

// src/ai.ts
var AI_PROVIDERS = ["anthropic", "mock"];
var AI_MAX_HISTORY_TURNS = 10;
var AI_MAX_MESSAGE_CHARS = 2e3;
var AI_ERROR_CODES = [
  /** Dzienny limit pytań albo miesięczny budżet wyczerpany (HTTP 429). */
  "AI_LIMIT",
  /** Niepoprawne żądanie (pusta wiadomość, zbyt długa, zła historia). */
  "AI_BAD_REQUEST",
  /** Dostawca modelu niedostępny / błąd sieci / przeciążenie (po wyczerpaniu ponowień). */
  "AI_UNAVAILABLE",
  /** Model odmówił odpowiedzi (stop_reason = refusal, także po fallbacku). */
  "AI_REFUSED",
  /** Pozostałe błędy wewnętrzne. */
  "AI_ERROR"
];
var AI_INSIGHT_KINDS = ["DAILY_REP", "WEEKLY_TEAM", "WEEKLY_BOARD", "LOGISTICS_DAILY", "LOGISTICS_WEEKLY"];
var AI_LOGISTICS_INSIGHT_KINDS = ["LOGISTICS_DAILY", "LOGISTICS_WEEKLY"];
var isLogisticsInsightKind = (kind) => AI_LOGISTICS_INSIGHT_KINDS.includes(kind);
var AI_TOOL_LABELS = {
  search_customers: "Szukam klienta\u2026",
  customer_overview: "Sprawdzam sprzeda\u017C klienta\u2026",
  sales_summary: "Licz\u0119 sprzeda\u017C\u2026",
  top_customers: "Sprawdzam najwi\u0119kszych klient\xF3w\u2026",
  declining_customers: "Szukam klient\xF3w ze spadkiem\u2026",
  rep_performance: "Por\xF3wnuj\u0119 handlowc\xF3w\u2026",
  product_stats: "Sprawdzam sprzeda\u017C produkt\xF3w\u2026",
  list_alerts: "Przegl\u0105dam alerty\u2026",
  receivables_summary: "Sprawdzam nale\u017Cno\u015Bci\u2026",
  forecast: "Licz\u0119 prognoz\u0119 i realizacj\u0119 celu\u2026",
  product_demand_forecast: "Licz\u0119 prognoz\u0119 zapotrzebowania na towary\u2026",
  logistics_deliveries: "Sprawdzam dostawy\u2026",
  logistics_problems: "Sprawdzam op\xF3\u017Anione i nieudane dostawy\u2026",
  logistics_problem_customers: "Szukam klient\xF3w z problemami w dostawach\u2026",
  logistics_route_load: "Sprawdzam obci\u0105\u017Cenie tras\u2026"
};

// src/field.ts
var FIELD_VISIT_STEP_KEYS = [
  "CONFIRM_CUSTOMER",
  "SURVEY",
  "OFFER",
  "PHOTOS",
  "MARKETING_CONSENT",
  "GDPR",
  "SIGNATURE",
  "NOTES",
  "NEXT_TASK"
];
var FIELD_DEFAULT_MANDATORY_STEPS = ["CONFIRM_CUSTOMER", "GDPR", "SIGNATURE"];
var FIELD_DEFAULT_GEOFENCE_RADIUS_M = 100;
var FIELD_NEARBY_DEFAULT_RADIUS_M = 150;
var FIELD_NEARBY_MAX_RADIUS_M = 1e3;
var FIELD_LIMITS = {
  gpsBatchMax: 200,
  syncBatchMax: 100,
  /** Maksymalny rozmiar PNG podpisu po zdekodowaniu (bajty). */
  signatureMaxBytes: 12e4,
  signatureMaxWidthPx: 1600,
  signatureMaxHeightPx: 800,
  /** Ping starszy niż tyle dni jest odrzucany (replay offline). */
  gpsMaxAgeDays: 14,
  /** Zdjęcia wizyty (krok PHOTOS): maks. liczba na wizytę i rozmiar jednego pliku po kompresji po stronie klienta. */
  photoMax: 12,
  photoMaxBytes: 4e6,
  photoCaptionMax: 140
};
var FOREIGN_CUSTOMER_MESSAGE = "Klient przypisany do innego handlowca";
var FOREIGN_CUSTOMER_ACCESS = ["GPS_ONLY", "DIRECTORY"];
var FOREIGN_VISIT_POLICIES = ["BLOCK", "WARN_REASON"];
var FIELD_ERROR_CODES = {
  /** 409 — `details.missing: FieldVisitStepKey[]`. */
  STEPS_INCOMPLETE: "STEPS_INCOMPLETE",
  /** 409 — wizyta nie jest w statusie IN_PROGRESS. */
  VISIT_NOT_IN_PROGRESS: "VISIT_NOT_IN_PROGRESS",
  /** 409 — wizyta anulowana. */
  VISIT_CANCELLED: "VISIT_CANCELLED",
  /** 409 — krok obowiązkowy nie może być pominięty. */
  STEP_MANDATORY: "STEP_MANDATORY",
  /** 409 — krok wymaga wcześniejszego zapisu (podpis, zgoda RODO, ankieta). `details.requires`. */
  STEP_REQUIRES_RECORD: "STEP_REQUIRES_RECORD",
  /** 404 — klucz kroku nie istnieje w tej wizycie. */
  STEP_NOT_FOUND: "STEP_NOT_FOUND",
  /** 400 — odpowiedzi ankiety niezgodne z definicją. `details.errors: {question, message}[]`. */
  SURVEY_INVALID: "SURVEY_INVALID",
  /** 400 — nieznana wersja tekstu zgody. */
  CONSENT_VERSION_UNKNOWN: "CONSENT_VERSION_UNKNOWN",
  /** 404 — osoba kontaktowa nie należy do klienta. */
  CONTACT_NOT_FOUND: "CONTACT_NOT_FOUND",
  /** 400 — podpis nie jest poprawnym PNG / za duży. `details.reason`. */
  SIGNATURE_INVALID: "SIGNATURE_INVALID",
  /** 409 — `clientRef` należy do wizyty innego użytkownika. */
  CLIENT_REF_CONFLICT: "CLIENT_REF_CONFLICT",
  /** 400 — za duża paczka (gps / sync). */
  BATCH_TOO_LARGE: "BATCH_TOO_LARGE",
  /** sync: operacja zależna od nieudanego `visit.start`. */
  DEPENDENCY_FAILED: "DEPENDENCY_FAILED",
  /** sync: nieznany typ operacji / zły kształt `payload`. */
  OPERATION_INVALID: "OPERATION_INVALID",
  /** sync: nie znaleziono wizyty po `visitRef` / `visitId`. */
  VISIT_NOT_FOUND: "VISIT_NOT_FOUND",
  /** 403 — organizacja nie udostępnia listy klientów innych handlowców (`foreignCustomerAccess` = GPS_ONLY). */
  FOREIGN_DIRECTORY_DISABLED: "FOREIGN_DIRECTORY_DISABLED",
  /** 403 — wizyta u klienta spoza zakresu, a `foreignVisitPolicy` = BLOCK. W sync: wynik operacji `error` z tym kodem. */
  FOREIGN_VISIT_NOT_ALLOWED: "FOREIGN_VISIT_NOT_ALLOWED",
  /** 400 — wizyta u klienta spoza zakresu bez `foreignReason` (albo OTHER bez `foreignReasonNote`). */
  FOREIGN_REASON_REQUIRED: "FOREIGN_REASON_REQUIRED"
};
var FIELD_CUSTOMER_SORTS = ["name", "distance", "overdue", "decline", "lastOrder"];
var FIELD_CUSTOMER_SCOPES = ["mine", "all", "foreign"];
var isForeignCustomerRow = (row) => row.foreign === true;
var FOREIGN_VISIT_REASONS = ["STANDIN", "CUSTOMER_REQUEST", "NEARBY", "OTHER"];
var FOREIGN_VISIT_REASON_NOTE_MAX = 300;
var FOREIGN_VISIT_NOTIFICATION_TYPES = {
  STARTED: "FOREIGN_VISIT_STARTED",
  COMPLETED: "FOREIGN_VISIT_COMPLETED"
};
var CATALOG_LIMITS = { maxProducts: 5e3 };

// src/analytics-customers.ts
var ABC_THRESHOLDS = { a: 80, b: 95 };
var ABC_CLASS_LABELS = { A: "Klasa A", B: "Klasa B", C: "Klasa C" };
var RFM_SEGMENTS = [
  { key: "CHAMPIONS", label: "Champions", description: "Kupuj\u0105 cz\u0119sto, niedawno i za du\u017Co \u2014 R\u22654, F\u22654, M\u22654" },
  { key: "LOYAL", label: "Lojalni", description: "Regularni, niedawni kupuj\u0105cy \u2014 R\u22653, F\u22653" },
  { key: "POTENTIAL", label: "Potencjalnie lojalni", description: "Niedawni, ale kupuj\u0105 rzadziej lub za ma\u0142o \u2014 R\u22653, F\u22642" },
  { key: "NEW", label: "Nowi", description: "Pierwsze zam\xF3wienie w ostatnich 90 dniach" },
  { key: "AT_RISK", label: "Zagro\u017Ceni", description: "Dawniej dobrzy, dawno nie kupowali \u2014 R\u22642, F\u22653 lub M\u22653" },
  { key: "HIBERNATING", label: "Hibernuj\u0105cy", description: "Rzadko i dawno, niska warto\u015B\u0107 \u2014 R\u22642, F\u22642, M\u22642" },
  { key: "LOST", label: "Utraceni", description: "Brak zakupu d\u0142u\u017Cej ni\u017C pr\xF3g klienta utraconego (Ustawienia; domy\u015Blnie 120 dni)" }
];
var CHURN_BANDS = [
  { key: "LOW", label: "Niskie", minScore: 0 },
  { key: "MEDIUM", label: "\u015Arednie", minScore: 25 },
  { key: "HIGH", label: "Wysokie", minScore: 50 }
];
var PRODUCT_QUADRANTS = [
  { key: "STARS", label: "Gwiazdy", description: "Du\u017Cy wolumen i wysoka mar\u017Ca \u2014 chroni\u0107 i rozwija\u0107" },
  { key: "CASH_COWS", label: "Krowy dojne", description: "Du\u017Cy wolumen, niska mar\u017Ca \u2014 pilnowa\u0107 cen i koszt\xF3w" },
  { key: "QUESTION_MARKS", label: "Znaki zapytania", description: "Ma\u0142y wolumen, wysoka mar\u017Ca \u2014 potencja\u0142 do rozwini\u0119cia" },
  { key: "DOGS", label: "Psy", description: "Ma\u0142y wolumen, niska mar\u017Ca \u2014 kandydaci do wycofania" }
];
var DEMAND_FORECAST_SORT_KEYS = ["forecastNet", "season", "trend", "accuracy"];
var DEMAND_FORECAST_SEGMENTS = ["all", "seasonUp", "seasonDown", "growing", "falling", "uncertain"];

// src/analytics-ops.ts
var ACTIVITY_THRESHOLDS = {
  /** Wizyta rozpoczęta dalej niż tyle metrów od klienta. */
  geofenceMeters: 100,
  /** Wizyta krótsza niż tyle minut. */
  shortVisitMinutes: 5,
  /** Wizyta rozpoczęta o godzinie >= nightFromHour lub < nightToHour (Europe/Warsaw). */
  nightFromHour: 21,
  nightToHour: 6,
  /** Przerwa w pingach GPS handlowca dłuższa niż tyle minut (w godzinach 6:00-21:00). */
  gpsGapMinutes: 60
};
var BONUS_COMPONENT_KEYS = ["sales", "margin", "newCustomers", "tasksVisits"];
var BONUS_MANDATORY_KEYS = ["surveyCompleteness", "visitsCount", "dataCompleteness", "reportPunctuality"];
var DEFAULT_BONUS_RULES = {
  baseAmount: 3e3,
  weights: { sales: 60, margin: 20, newCustomers: 10, tasksVisits: 10 },
  components: {
    sales: { thresholdPct: 70, capPct: 120 },
    margin: { thresholdPct: 80, capPct: 110, defaultTargetPct: 25 },
    newCustomers: { thresholdPct: 0, capPct: 150, targetPerMonth: 2 },
    tasksVisits: { thresholdPct: 50, capPct: 110, visitsPerMonth: 40, taskOnTimePct: 90 }
  },
  mandatory: {
    surveyCompleteness: { enabled: true, threshold: 80, bonus: 150, penalty: 100 },
    visitsCount: { enabled: true, threshold: 40, bonus: 200, penalty: 150 },
    dataCompleteness: { enabled: true, threshold: 90, bonus: 100, penalty: 50 },
    reportPunctuality: { enabled: true, threshold: 90, bonus: 100, penalty: 100 }
  }
};

// src/analytics-finance.ts
var PROFIT_LOW_THRESHOLD_PCT = 10;

// src/search.ts
var SEARCH_MIN_CHARS = 2;
var SEARCH_MAX_CHARS = 80;
var SEARCH_DEFAULT_LIMIT = 5;
var SEARCH_MAX_LIMIT = 10;
var SEARCH_GROUPS = ["CUSTOMER", "CONTACT", "LEAD", "TASK", "REQUEST", "VEHICLE"];

// src/chat.ts
var CHAT_CONVERSATION_KINDS = ["DIRECT", "GROUP", "BROADCAST", "SUBJECT"];
var CHAT_SUBJECT_TYPES = ["CUSTOMER", "LEAD", "APPROVAL_REQUEST"];
var CHAT_MESSAGE_MAX_CHARS = 4e3;
var CHAT_TITLE_MAX_CHARS = 80;
var CHAT_PAGE_SIZE = 50;
var CHAT_MAX_ATTACHMENTS = 5;
var CHAT_MAX_FILE_BYTES = 10 * 1024 * 1024;
var CHAT_REACTION_EMOJIS = ["\u{1F44D}", "\u2764\uFE0F", "\u{1F602}", "\u{1F389}", "\u{1F64F}", "\u{1F440}"];
var CHAT_ALLOWED_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "pdf", "xlsx", "docx", "txt", "csv"];
var CHAT_SSE_HEARTBEAT_MS = 25e3;
var CHAT_TYPING_TTL_MS = 5e3;

// src/daily-report.ts
var DAILY_REPORT_COMMENT_MAX = 2e3;

// src/notifications.ts
var NOTIFICATION_CATEGORIES = ["ALERT", "TASK", "APPROVAL", "LEAD", "ANNOUNCEMENT", "SYSTEM"];
var MANUAL_NOTIFICATION_CATEGORIES = ["ANNOUNCEMENT", "ALERT", "TASK", "SYSTEM"];
var NOTIFICATION_PRIORITIES = ["HIGH", "MEDIUM", "LOW"];
var NOTIFICATION_TITLE_MAX = 120;
var NOTIFICATION_BODY_MAX = 500;
var NOTIFICATION_PAGE_SIZE = 50;
function notificationCategoryForType(type) {
  const t = type.toLowerCase();
  if (t.startsWith("alert")) return "ALERT";
  if (t.startsWith("task")) return "TASK";
  if (t.startsWith("workflow") || t.startsWith("approval") || t.startsWith("step")) return "APPROVAL";
  if (t.startsWith("lead")) return "LEAD";
  if (t === "announcement") return "ANNOUNCEMENT";
  return "SYSTEM";
}

// src/field-history.ts
var FIELD_HISTORY_LIMITS = {
  /** Maks. liczba punktów śladu na handlowca / dzień w odpowiedzi (po uproszczeniu; dystans liczony z pełnych danych). */
  maxPointsPerRep: 1500,
  /** Postój = brak ruchu co najmniej tyle minut w promieniu `stopRadiusM`. */
  stopMinMinutes: 5,
  stopRadiusM: 60,
  /** Przerwa w sygnale GPS dłuższa niż tyle minut jest zgłaszana w `stats.gaps`. */
  gapMinMinutes: 30,
  /** Wizyta krótsza niż tyle minut jest oznaczana jako `SHORT`. */
  shortVisitMinutes: 5,
  /** Wizyta rozpoczęta/zakończona poza godzinami 05:00–21:00 (Europe/Warsaw) jest oznaczana `NIGHT`. */
  nightFromHour: 21,
  nightToHour: 5,
  maxDaysRange: 92,
  defaultOverdueDays: 30
};

// src/field-visits-panel.ts
var FIELD_VISIT_BOARD_LIMIT = 1e3;
var FIELD_VISIT_PLAN_ERRORS = {
  /** 409 — dla tego klienta i handlowca jest już zaplanowana wizyta tego dnia. */
  alreadyPlanned: "VISIT_ALREADY_PLANNED",
  /** 409 — wizytę można przeplanować tylko ze statusu PLANNED lub MISSED. */
  notReschedulable: "VISIT_NOT_RESCHEDULABLE",
  /** 400 — termin w przeszłości. */
  pastDate: "VISIT_PAST_DATE"
};
var FIELD_VISIT_RESCHEDULABLE = ["PLANNED", "MISSED"];

// src/visit-views.ts
var dayFmt = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Warsaw", year: "numeric", month: "2-digit", day: "2-digit" });
var clockFmt = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Warsaw", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
var warsawDay = (iso) => dayFmt.format(typeof iso === "string" ? new Date(iso) : iso);
function warsawMinute(iso) {
  const p = clockFmt.formatToParts(typeof iso === "string" ? new Date(iso) : iso);
  const get = (t) => Number(p.find((x) => x.type === t)?.value ?? 0);
  return get("hour") * 60 + get("minute");
}
function warsawWallMs(ms) {
  const p = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Warsaw", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(new Date(ms));
  const get = (t) => Number(p.find((x) => x.type === t)?.value ?? 0);
  return Date.UTC(get("year"), get("month") - 1, get("day"), get("hour"), get("minute"));
}
function warsawToIso(day, time) {
  const [y, m, d] = day.split("-").map(Number);
  const [h, mi] = time.split(":").map(Number);
  const guess = Date.UTC(y, m - 1, d, h, mi);
  return new Date(guess - (warsawWallMs(guess) - guess)).toISOString();
}
function addDaysYmd(ymd2, n2) {
  const d = /* @__PURE__ */ new Date(`${ymd2}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n2);
  return d.toISOString().slice(0, 10);
}
function mondayOf(ymd2) {
  const wd = ((/* @__PURE__ */ new Date(`${ymd2}T12:00:00Z`)).getUTCDay() + 6) % 7;
  return addDaysYmd(ymd2, -wd);
}
var visitMoment = (v) => v.startedAt ?? v.plannedAt;
var visitDayOf = (v) => {
  const m = visitMoment(v);
  return m ? warsawDay(m) : null;
};
function visitFlags(v) {
  const out = [...v.anomalies];
  if (v.status === "COMPLETED" && !v.hasSignature) out.push("NO_SIGNATURE");
  return out;
}
function groupVisitsByDay(items) {
  const groups = /* @__PURE__ */ new Map();
  for (const v of items) {
    const day = visitDayOf(v) ?? "";
    let g = groups.get(day);
    if (!g) groups.set(day, g = { day, items: [], completed: 0, minutes: 0 });
    g.items.push(v);
    if (v.status === "COMPLETED") {
      g.completed += 1;
      g.minutes += v.durationMin ?? 0;
    }
  }
  const all = [...groups.values()];
  return [...all.filter((g) => g.day), ...all.filter((g) => !g.day)];
}
function buildRoutes(items) {
  const map = /* @__PURE__ */ new Map();
  const sorted = items.filter((v) => v.status !== "CANCELLED" && v.customer.lat !== null && v.customer.lng !== null && visitMoment(v)).sort((a, b) => Date.parse(visitMoment(a)) - Date.parse(visitMoment(b)));
  for (const v of sorted) {
    const day = visitDayOf(v);
    const key = `${v.user.id}|${day}`;
    let route = map.get(key);
    if (!route) map.set(key, route = { key, userId: v.user.id, day, stops: [] });
    route.stops.push({ visit: v, order: route.stops.length + 1, lat: v.customer.lat, lng: v.customer.lng });
  }
  return [...map.values()];
}
var LANE_DEFAULT_MIN = 30;
var LANE_MIN_BLOCK_MIN = 12;
var MIN_GAP_MIN = 10;
function layoutLane(visits, nowMin) {
  const blocks = [];
  for (const v of visits) {
    const at2 = visitMoment(v);
    if (!at2) continue;
    const startMin = warsawMinute(at2);
    let endMin = v.endedAt ? warsawMinute(v.endedAt) : v.status === "IN_PROGRESS" && nowMin !== void 0 ? nowMin : startMin + LANE_DEFAULT_MIN;
    if (endMin < startMin) endMin = startMin + LANE_DEFAULT_MIN;
    endMin = Math.max(endMin, startMin + LANE_MIN_BLOCK_MIN);
    const plannedMin = v.plannedAt && v.startedAt ? warsawMinute(v.plannedAt) : null;
    const delayMin = plannedMin !== null && v.startedAt ? startMin - plannedMin : null;
    blocks.push({ visit: v, startMin, endMin, row: 0, plannedMin, delayMin });
  }
  blocks.sort((a, b) => a.startMin - b.startMin || a.endMin - b.endMin);
  const rowEnds = [];
  for (const b of blocks) {
    let row = rowEnds.findIndex((end) => end <= b.startMin);
    if (row === -1) row = rowEnds.length;
    rowEnds[row] = b.endMin;
    b.row = row;
  }
  const gaps = [];
  let maxEnd = null;
  for (const b of blocks) {
    if (maxEnd !== null && b.startMin - maxEnd >= MIN_GAP_MIN) gaps.push({ fromMin: maxEnd, toMin: b.startMin });
    maxEnd = Math.max(maxEnd ?? 0, b.endMin);
  }
  return { blocks, rows: Math.max(1, rowEnds.length), gaps, collisions: blocks.filter((b) => b.row > 0).length };
}
function clusterByGrid(points, cell) {
  const cells = /* @__PURE__ */ new Map();
  for (const p of points) {
    const key = `${Math.floor(p.x / cell)}:${Math.floor(p.y / cell)}`;
    const list = cells.get(key);
    if (list) list.push(p);
    else cells.set(key, [p]);
  }
  return [...cells.values()].map((members) => ({
    x: members.reduce((a, m) => a + m.x, 0) / members.length,
    y: members.reduce((a, m) => a + m.y, 0) / members.length,
    members
  }));
}
var STATUS_RANK = { IN_PROGRESS: 5, MISSED: 4, PLANNED: 3, COMPLETED: 2, CANCELLED: 1 };
var dominantStatus = (statuses) => statuses.reduce((best, s) => STATUS_RANK[s] > STATUS_RANK[best] ? s : best, "CANCELLED");
function distanceM(a, b) {
  const rad = (d) => d * Math.PI / 180;
  const h = Math.sin(rad(b.lat - a.lat) / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(rad(b.lng - a.lng) / 2) ** 2;
  return Math.round(2 * 63710088e-1 * Math.asin(Math.min(1, Math.sqrt(h))));
}

// src/app-version.ts
function parseBuildInfo(value) {
  if (!value || typeof value !== "object") return null;
  const v = value;
  if (typeof v.version !== "string" || typeof v.sha !== "string" || !v.version || !v.sha) return null;
  const app = v.app === "web" || v.app === "mobile" || v.app === "backend" ? v.app : "web";
  return { app, version: v.version, sha: v.sha, builtAt: typeof v.builtAt === "string" ? v.builtAt : "" };
}
function compareVersions(a, b) {
  const parse2 = (s) => {
    const [core = "", pre] = s.replace(/^v/, "").split("-", 2);
    const nums = core.split(".").map((n2) => Number.parseInt(n2, 10) || 0);
    return { nums: [nums[0] ?? 0, nums[1] ?? 0, nums[2] ?? 0], pre };
  };
  const x = parse2(a);
  const y = parse2(b);
  for (let i = 0; i < 3; i++) {
    if (x.nums[i] !== y.nums[i]) return x.nums[i] < y.nums[i] ? -1 : 1;
  }
  if (x.pre === y.pre) return 0;
  if (!x.pre) return 1;
  if (!y.pre) return -1;
  return x.pre < y.pre ? -1 : 1;
}
function isDifferentBuild(current, remote) {
  if (!remote || current.sha === "dev") return false;
  return remote.sha !== current.sha || remote.version !== current.version;
}
var KINDS = ["added", "changed", "fixed", "note"];
function parseChangelogFeed(value) {
  const raw = value && typeof value === "object" ? value.entries : null;
  if (!Array.isArray(raw)) return [];
  const out = [];
  for (const e of raw) {
    if (!e || typeof e !== "object") continue;
    const r = e;
    if (typeof r.version !== "string" || typeof r.date !== "string") continue;
    const sections = (Array.isArray(r.sections) ? r.sections : []).flatMap((s) => {
      if (!s || typeof s !== "object") return [];
      const sec = s;
      if (!KINDS.includes(sec.kind) || !Array.isArray(sec.items)) return [];
      return [{ kind: sec.kind, title: String(sec.title ?? ""), items: sec.items.filter((i) => typeof i === "string") }];
    });
    out.push({
      version: r.version,
      date: r.date,
      title: typeof r.title === "string" ? r.title : void 0,
      summary: typeof r.summary === "string" ? r.summary : void 0,
      sections
    });
  }
  return out;
}
function entriesSince(entries, lastSeen) {
  if (!lastSeen) return entries.slice(0, 1);
  return entries.filter((e) => compareVersions(e.version, lastSeen) > 0);
}

// src/app-update.ts
var RESUME_MIN_HIDDEN_MS = 3e4;
var APP_UPDATE_CHECK_MS = 15 * 6e4;
function buildKey(build) {
  return `${build.version}+${build.sha}`;
}
function decideUpdate(input) {
  const { server, client } = input;
  if (!server || !isDifferentBuild(client, server)) return "none";
  const justResumed = input.hiddenForMs !== null && input.hiddenForMs >= RESUME_MIN_HIDDEN_MS;
  const safeMoment = justResumed && input.online && input.safeScreen && !input.hasUnsyncedWork && !input.uiBusy && input.reloadAttemptedFor !== buildKey(server);
  return safeMoment ? "reload" : "banner";
}
function normalizeUpdatePath(pathname) {
  const bare = pathname.split(/[?#]/)[0] ?? "";
  const trimmed = bare.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}
function isSafeUpdateRoute(pathname, safeRoutes) {
  if (!pathname) return false;
  return safeRoutes.includes(normalizeUpdatePath(pathname));
}
var TEXT_INPUT_TYPES = /* @__PURE__ */ new Set([
  "",
  "text",
  "search",
  "email",
  "tel",
  "url",
  "number",
  "password",
  "date",
  "time",
  "datetime-local"
]);
var UPDATE_OVERLAY_SELECTOR = '[aria-modal="true"], [role="dialog"], [role="alertdialog"], .fixed.inset-0';
function isUiBusy(doc) {
  if (doc.querySelector(UPDATE_OVERLAY_SELECTOR)) return true;
  const active = doc.activeElement;
  if (active) {
    if (active.isContentEditable) return true;
    const tag = active.tagName.toUpperCase();
    if (tag === "TEXTAREA" || tag === "SELECT") return true;
    if (tag === "INPUT" && TEXT_INPUT_TYPES.has((active.type ?? "").toLowerCase())) return true;
  }
  const fields = doc.querySelectorAll("textarea, input");
  for (let i = 0; i < fields.length; i++) {
    const f = fields[i];
    if (f.tagName.toUpperCase() === "INPUT" && !TEXT_INPUT_TYPES.has((f.type ?? "").toLowerCase())) continue;
    if ((f.value ?? "").trim() !== "") return true;
  }
  return false;
}

// src/routing.ts
var ROUTING_LIMITS = {
  /** Maks. liczba punktów w jednym zapytaniu (start + przystanki). */
  maxPoints: 40,
  /** Limit czasu zapytania do OSRM po stronie backendu. */
  timeoutMs: 8e3
};
var ROUTING_UNAVAILABLE_CODE = "ROUTING_UNAVAILABLE";

// src/geocoding.ts
var GEOCODING_UNAVAILABLE_CODE = "GEOCODING_UNAVAILABLE";

// src/gdpr.ts
var GDPR_SUBJECT_TYPES = ["CONTACT", "LEAD", "EMPLOYEE"];
var GDPR_SEARCH_MIN = 3;
var GDPR_ERASED_LABEL = "Usuni\u0119to (RODO)";

// src/workflow.ts
var APPROVAL_AREAS = ["SALES", "LOGISTICS", "ORDERS", "CREDIT"];
var APPROVAL_REQUEST_STATUSES = ["PENDING", "IN_PROGRESS", "RETURNED", "APPROVED", "REJECTED", "CANCELLED"];
var ACTIVE_APPROVAL_STATUSES = ["PENDING", "IN_PROGRESS", "RETURNED"];
var APPROVAL_STEP_STATUSES = ["PENDING", "APPROVED", "RETURNED", "REJECTED", "SKIPPED"];
var APPROVAL_DECISIONS = ["APPROVE", "RETURN", "REJECT"];
var APPROVAL_EVENT_TYPES = ["STARTED", "DECISION", "RETURNED", "RESUBMITTED", "CANCELLED", "OVERDUE", "COMPLETED"];
var WORKFLOW_NOTIFICATION_TYPES = [
  "WORKFLOW_STEP_WAITING",
  "WORKFLOW_STEP_DECIDED",
  "WORKFLOW_RETURNED",
  "WORKFLOW_RESUBMITTED",
  "WORKFLOW_ALL_APPROVED",
  "WORKFLOW_APPROVED",
  "WORKFLOW_REJECTED",
  "WORKFLOW_CANCELLED",
  "WORKFLOW_STEP_OVERDUE"
];
var WORKFLOW_ERROR_CODES = {
  FORBIDDEN: 403,
  // brak uprawnienia kroku / nie jesteś zgłaszającym
  NOT_FOUND: 404,
  // wniosek poza zakresem widoczności
  STEP_NOT_FOUND: 404,
  PROCESS_NOT_FOUND: 404,
  REQUEST_EXISTS: 409,
  // aktywny wniosek (PENDING / IN_PROGRESS / RETURNED) już istnieje
  REQUEST_CLOSED: 409,
  // wniosek zakończony lub anulowany
  STEP_ALREADY_DECIDED: 409,
  // krok został już rozstrzygnięty (także przy wyścigu dwóch decyzji)
  STEP_NOT_CURRENT: 409,
  // krok należy do późniejszego etapu
  NOT_RETURNED: 409,
  // resubmit tylko dla wniosku w statusie RETURNED
  REQUEST_CHANGED: 409,
  // wniosek zmienił się w trakcie operacji — odśwież i spróbuj ponownie
  NOT_APPROVED: 409,
  // eksport ERP tylko dla APPROVED
  LEAD_LOST: 409,
  COMMENT_REQUIRED: 400,
  // RETURN / REJECT bez komentarza
  INVALID_STEP_DATA: 400,
  // `data` nie pasuje do działu kroku
  STEP_DATA_REQUIRED: 400,
  // Handlowy (nowe procesy): APPROVE bez rodzaju płatności zaakceptowanej lub decyzji B2B
  INVALID_ROUTE: 400
  // `routeId` nie istnieje w organizacji lub trasa jest nieaktywna
};
var STEP_DATA_LIMITS = { text: 4e3, listItems: 20, listItemLength: 200, deliveryDays: 7, maxCreditLimit: 1e9, maxPaymentTermDays: 365 };
var NEW_CUSTOMER_FIELD_AREAS = {
  priceNotes: ["SALES"],
  expectedMonthlyVolume: ["SALES"],
  creditLimitRequested: ["SALES"],
  paymentTermDays: ["SALES"],
  customerClass: ["SALES"],
  street: ["LOGISTICS"],
  postalCode: ["LOGISTICS"],
  city: ["LOGISTICS"],
  receivingHours: ["LOGISTICS"],
  deliveryDays: ["LOGISTICS"],
  logisticsNotes: ["LOGISTICS"],
  latitude: ["LOGISTICS"],
  longitude: ["LOGISTICS"],
  contactName: ["ORDERS"],
  contactPhone: ["ORDERS"],
  contactEmail: ["ORDERS"],
  segment: ["ORDERS"],
  deliveryStreet: ["LOGISTICS"],
  deliveryPostalCode: ["LOGISTICS"],
  deliveryCity: ["LOGISTICS"],
  routeId: ["LOGISTICS"],
  deliveryPriority: ["LOGISTICS"],
  avizationHours: ["LOGISTICS"],
  receiverPhone: ["LOGISTICS"],
  paymentMethod: ["SALES"],
  targetDocument: ["SALES"],
  contacts: ["ORDERS"],
  shortName: ["ORDERS"],
  remarks: ["ORDERS"],
  name: ["SALES", "LOGISTICS", "ORDERS"],
  nip: ["SALES", "LOGISTICS", "ORDERS"]
};

// src/owner-dashboard.ts
var OWNER_DEFAULT_THRESHOLDS = {
  realizationWarnPct: 80,
  realizationBadPct: 60,
  overdueWarnPct: 5,
  overdueBadPct: 10,
  marginDropWarnPp: 0.5,
  marginDropBadPp: 1.5,
  visitsOverdueWarnPct: 10,
  visitsOverdueBadPct: 20,
  idleWarnMin: 30,
  idleBadMin: 90
};
var OWNER_DEFAULT_REPORT = {
  enabled: true,
  recipients: [],
  hour: 7,
  minute: 0,
  days: [1, 2, 3, 4, 5],
  lastSentOn: null
};
var OWNER_REPORT_MAX_RECIPIENTS = 20;
var OWNER_SECTION_KEYS = ["forecast", "sales", "customers", "finance", "team", "operations"];

// src/fleet.ts
var FLEET_VEHICLE_STATUSES = ["ACTIVE", "IN_SERVICE", "DECOMMISSIONED"];
var FLEET_VEHICLE_TYPES = ["PASSENGER_CAR", "VAN", "TRUCK", "REFRIGERATED_VAN", "REFRIGERATED_TRUCK", "TRAILER", "OTHER"];
var ODOMETER_SOURCES = ["MANUAL", "LOGBOOK_START", "LOGBOOK_END", "FUEL", "SERVICE", "CHECKLIST", "IMPORT", "LEASE_START", "CORRECTION"];
var FLEET_LEASE_STATUSES = ["ACTIVE", "ENDED", "CANCELLED"];
var LEASE_WARNING_LEVELS = ["OK", "WARNING_1", "WARNING_2", "EXCEEDED"];
var DEFAULT_LEASE_WARNING_THRESHOLDS = [80, 90, 100];
var DEFAULT_FORECAST_MIN_DAYS = 30;
var DEFAULT_FORECAST_MIN_KM = 500;
var LOGBOOK_STATUSES = ["DRAFT", "OPEN", "SUBMITTED", "APPROVED", "RETURNED", "DISCREPANCY"];
var LOGBOOK_EVENT_TYPES = ["CREATED", "STARTED", "SUBMITTED", "RESUBMITTED", "APPROVED", "RETURNED", "DISCREPANCY", "ODOMETER_CORRECTED", "UPDATED"];
var LOGBOOK_ACTIONS = ["start", "submit", "resubmit", "approve", "return", "discrepancy"];
var LOGBOOK_TRANSITIONS = {
  start: { from: ["DRAFT"], to: "OPEN" },
  submit: { from: ["OPEN"], to: "SUBMITTED" },
  resubmit: { from: ["RETURNED"], to: "SUBMITTED" },
  approve: { from: ["SUBMITTED", "DISCREPANCY"], to: "APPROVED" },
  return: { from: ["SUBMITTED", "DISCREPANCY"], to: "RETURNED" },
  discrepancy: { from: ["SUBMITTED"], to: "DISCREPANCY" }
};
var LOGBOOK_FLAGS = ["KM_ABOVE_PLAN", "KM_BELOW_PLAN", "KM_ABOVE_DAILY_MAX", "METER_EVENT"];
var FLEET_ERROR_CODES = [
  "VEHICLE_NOT_FOUND",
  "PLATE_EXISTS",
  "VIN_EXISTS",
  "DRIVER_NOT_FOUND",
  "DRIVER_NOT_DRIVER_ROLE",
  "GROUP_NOT_FOUND",
  "GROUP_EXISTS",
  "ASSIGNMENT_NOT_FOUND",
  "ASSIGNMENT_OVERLAP",
  "ASSIGNMENT_INVALID_RANGE",
  "LEASE_NOT_FOUND",
  "LEASE_OVERLAP",
  "LEASE_NUMBER_EXISTS",
  "LEASE_INVALID_RANGE",
  "LEASE_THRESHOLDS_INVALID",
  "ODOMETER_NOT_MONOTONIC",
  "ODOMETER_CORRECTION_REASON_REQUIRED",
  "ODOMETER_CORRECTION_NOT_LATEST",
  "LOGBOOK_NOT_FOUND",
  "LOGBOOK_INVALID_TRANSITION",
  "LOGBOOK_VEHICLE_BUSY",
  "LOGBOOK_DRIVER_BUSY",
  "LOGBOOK_VEHICLE_NOT_ACTIVE",
  "LOGBOOK_NOT_ASSIGNED",
  "LOGBOOK_END_BELOW_START",
  "LOGBOOK_NOTE_REQUIRED",
  "LOGBOOK_REVIEW_COMMENT_REQUIRED",
  "LOGBOOK_SELF_REVIEW",
  "LOGBOOK_NOT_EDITABLE",
  "LOGBOOK_ODOMETER_REQUIRED"
];
var DEFAULT_FLEET_SETTINGS = {
  leaseWarningThresholds: [...DEFAULT_LEASE_WARNING_THRESHOLDS],
  forecastMinDays: DEFAULT_FORECAST_MIN_DAYS,
  forecastMinKm: DEFAULT_FORECAST_MIN_KM,
  maxLogbookKm: 2e3,
  plannedKmTolerancePct: 15,
  requireChecklistBeforeTrip: false,
  requireChecklistAfterTrip: false,
  requireFuelReceipt: false,
  seriousDefectProcedure: "REQUIRE_DECISION"
};

// src/fleet-reports.ts
var FLEET_REVIEW_STATUSES = ["SUBMITTED", "APPROVED", "REJECTED", "NEEDS_INFO"];
var FLEET_REVIEW_ACTIONS = ["approve", "reject", "request-info", "resubmit"];
var FLEET_REVIEW_TRANSITIONS = {
  approve: { from: ["SUBMITTED"], to: "APPROVED" },
  reject: { from: ["SUBMITTED", "NEEDS_INFO"], to: "REJECTED" },
  "request-info": { from: ["SUBMITTED"], to: "NEEDS_INFO" },
  resubmit: { from: ["NEEDS_INFO"], to: "SUBMITTED" }
};
var FLEET_REVIEW_COMMENT_REQUIRED = ["reject", "request-info"];
var FLEET_REVIEW_AUTHOR_EDITABLE = ["SUBMITTED", "NEEDS_INFO"];
var FLEET_FUEL_TYPES = ["DIESEL", "PETROL", "LPG", "CNG", "ELECTRIC", "ADBLUE", "OTHER"];
var FLEET_PAYMENT_METHODS = ["FUEL_CARD", "COMPANY_CARD", "CASH", "PRIVATE", "OTHER"];
var FLEET_FUEL_SOURCES = ["MANUAL", "CARD_IMPORT"];
var FUEL_WARNINGS = [
  "ODOMETER_BELOW_PREVIOUS",
  "ODOMETER_MISSING",
  "AMOUNT_MISMATCH",
  "UNUSUAL_PRICE",
  "LITERS_ABOVE_CAPACITY",
  "DUPLICATE_SUSPECTED"
];
var FUEL_AMOUNT_TOLERANCE = { absolute: 0.05, relativePct: 1 };
var FUEL_PRICE_DEVIATION_PCT = 40;
var FUEL_PRICE_HARD_RANGE = {
  DIESEL: { min: 2, max: 15 },
  PETROL: { min: 2, max: 15 },
  LPG: { min: 1, max: 10 },
  CNG: { min: 1, max: 15 },
  ELECTRIC: { min: 0.2, max: 6 },
  ADBLUE: { min: 0.5, max: 15 },
  OTHER: { min: 0.1, max: 100 }
};
var FLEET_EXPENSE_CATEGORIES = ["PARKING", "TOLL", "CAR_WASH", "MINOR_REPAIR", "FLUIDS", "OTHER"];
var FLEET_CHECKLIST_PHASES = ["BEFORE_TRIP", "AFTER_TRIP"];
var FLEET_CHECKLIST_RESULTS = ["OK", "WARNING", "DEFECT"];
var FLEET_REQUIREMENTS = ["NEVER", "ON_ISSUE", "ALWAYS"];
var FLEET_CHECKLIST_RUN_STATUSES = ["DRAFT", "SUBMITTED"];

// src/fleet-incidents.ts
var FLEET_INCIDENT_TYPES = ["BREAKDOWN", "DAMAGE", "COLLISION", "IRREGULARITY", "OTHER"];
var FLEET_SEVERITIES = ["LOW", "MEDIUM", "HIGH", "CRITICAL"];
var FLEET_INCIDENT_STATUSES = ["NEW", "IN_PROGRESS", "RESOLVED", "CLOSED"];
var FLEET_INCIDENT_TRANSITIONS = {
  NEW: ["IN_PROGRESS", "RESOLVED", "CLOSED"],
  IN_PROGRESS: ["RESOLVED", "CLOSED"],
  RESOLVED: ["IN_PROGRESS", "CLOSED"],
  CLOSED: []
};
var FLEET_VEHICLE_DECISIONS = ["NONE", "PENDING", "ALLOWED", "BLOCKED"];
var FLEET_INCIDENT_EVENT_TYPES = [
  "CREATED",
  "STATUS_CHANGED",
  "COMMENT",
  "DECISION",
  "VEHICLE_BLOCKED",
  "UPDATED"
];
var FLEET_DEFECT_PROCEDURES = ["NOTIFY_ONLY", "BLOCK_VEHICLE", "REQUIRE_DECISION"];
var FLEET_INCIDENT_FIELD_TYPES = ["text", "number", "boolean", "select", "date"];
var FLEET_SERVICE_TYPES = ["INSPECTION", "SERVICE", "REPAIR", "TIRES", "DEFECT", "OTHER"];
var FLEET_SERVICE_STATUSES = ["PLANNED", "IN_PROGRESS", "DONE"];
var LOGBOOK_REQUIREMENT_CODES = [
  "CHECKLIST_BEFORE_TRIP",
  "CHECKLIST_AFTER_TRIP",
  "CHECKLIST_DRAFT_OPEN"
];
var FLEET_NOTIFICATION_TYPES = [
  "alert.fleet_serious_defect",
  "alert.fleet_incident",
  "alert.fleet_decision_needed",
  "alert.fleet_alert",
  "fleet.vehicle_decision",
  "fleet.incident_status",
  "fleet.incident_comment",
  "fleet.review_result"
];
var FLEET_REPORT_ERROR_CODES = [
  "FUEL_NOT_FOUND",
  "FUEL_INVALID_TRANSITION",
  "FUEL_NOT_EDITABLE",
  "FUEL_EXTERNAL_ID_EXISTS",
  "FUEL_INCOMPLETE",
  "FUEL_RECEIPT_REQUIRED",
  "EXPENSE_NOT_FOUND",
  "EXPENSE_INVALID_TRANSITION",
  "EXPENSE_NOT_EDITABLE",
  "EXPENSE_DESCRIPTION_REQUIRED",
  "REVIEW_COMMENT_REQUIRED",
  "REVIEW_SELF",
  "CHECKLIST_TEMPLATE_NOT_FOUND",
  "CHECKLIST_TEMPLATE_INVALID",
  "CHECKLIST_TEMPLATE_INACTIVE",
  "CHECKLIST_TEMPLATE_VEHICLE_TYPE",
  "CHECKLIST_RUN_NOT_FOUND",
  "CHECKLIST_RUN_NOT_EDITABLE",
  "CHECKLIST_INCOMPLETE",
  "CHECKLIST_ANSWER_INVALID",
  "INCIDENT_NOT_FOUND",
  "INCIDENT_TEMPLATE_NOT_FOUND",
  "INCIDENT_TEMPLATE_INVALID",
  "INCIDENT_INVALID_TRANSITION",
  "INCIDENT_FIELD_INVALID",
  "INCIDENT_DECISION_NOT_PENDING",
  "SERVICE_RECORD_NOT_FOUND",
  "LOGBOOK_REQUIREMENTS_MISSING",
  "LOGBOOK_VEHICLE_PENDING_DECISION",
  "ATTACHMENT_ENTITY_NOT_ALLOWED"
];

// src/fleet-analytics.ts
var FLEET_ENTITY_TYPES = ["VEHICLE", "LEASE", "LOGBOOK", "FUEL", "EXPENSE", "INCIDENT", "ROUTE", "SYNC_RUN"];
var ENTITY_PATHS = {
  VEHICLE: (id) => `/fleet/vehicles/${id}`,
  LEASE: (id) => `/fleet/leases/${id}`,
  LOGBOOK: (id) => `/fleet/logbooks/${id}`,
  FUEL: (id) => `/fleet/fuel/${id}`,
  EXPENSE: (id) => `/fleet/expenses/${id}`,
  INCIDENT: (id) => `/fleet/incidents/${id}`,
  ROUTE: (id) => `/fleet/routes/${id}`,
  SYNC_RUN: (id) => `/fleet/integration/runs/${id}`
};
var fleetEntityPath = (type, id) => ENTITY_PATHS[type](id);
var fleetEntityRef = (entityType, id, label) => ({ entityType, id, path: fleetEntityPath(entityType, id), label: label ?? null });
var FLEET_COST_CATEGORIES = ["FUEL", "LEASE", "SERVICE", "PARKING", "TOLL", "CAR_WASH", "MINOR_REPAIR", "FLUIDS", "OTHER"];
var FLEET_ANALYTICS_GRANULARITIES = ["day", "month"];
var FLEET_ANALYTICS_RULES = {
  /** Minimalny dystans odcinka „pełny do pełnego”, poniżej którego l/100 km jest nierzetelne. */
  minConsumptionSegmentKm: 100,
  /** Wiarygodny zakres zużycia l/100 km — poza nim odcinek jest INCOMPLETE (`IMPLAUSIBLE_VALUE`). */
  plausibleLPer100: { min: 2, max: 100 },
  /** Przebieg bez karty drogowej poniżej tej wartości (km) nie jest raportowany jako brak karty. */
  undocumentedMinKm: 10,
  /** Okno (dni) wstecz do wykrywania brakujących kart. */
  missingLogbookWindowDays: 14,
  /** Po ilu dniach oczekiwania wpis „do weryfikacji” trafia do alertu. */
  pendingReviewAlertDays: 3,
  /** Po ilu dniach zgłoszenie w statusie NEW bez obsługi trafia do alertu. */
  incidentUnhandledDays: 2,
  /** Terminy przeglądu / ubezpieczenia: alert na tyle dni przed terminem (WARNING) i w ostatnim tygodniu (CRITICAL). */
  dueSoonDays: 30,
  dueCriticalDays: 7,
  /** Pojazdy o podwyższonych kosztach: koszt/km > mediana grupy × czynnik, przy min. km w oknie. */
  elevatedCostFactor: 1.4,
  elevatedCostWindowDays: 90,
  elevatedCostMinKm: 300,
  elevatedCostMinPeers: 3
};
var FUEL_CONSUMPTION_REASONS = [
  "NOT_ENOUGH_FULL_TANKS",
  "ODOMETER_MISSING",
  "ODOMETER_INCONSISTENT",
  "DISTANCE_TOO_SHORT",
  "METER_CORRECTION_IN_WINDOW",
  "UNVERIFIED_ENTRY_IN_SEGMENT",
  "MIXED_FUEL_TYPES",
  "FUEL_TYPE_NOT_SUPPORTED",
  "IMPLAUSIBLE_VALUE"
];
var FLEET_TREND_METRICS = ["km", "fuelCost", "totalCost", "totalCostPerKm", "liters"];
var FLEET_ANALYTICS_ERROR_CODES = [
  "ANALYTICS_RANGE_INVALID",
  "ANALYTICS_RANGE_TOO_LARGE",
  "ROUTE_NOT_FOUND",
  "ROUTE_SYNC_RUN_NOT_FOUND",
  "ROUTE_IMPORT_FILE_REQUIRED",
  "ROUTE_IMPORT_FILE_TOO_LARGE",
  "ROUTE_IMPORT_HEADER_INVALID",
  "ROUTE_IMPORT_EMPTY",
  "ROUTE_ID_MAP_INVALID",
  "ROUTE_ID_MAP_NOT_FOUND",
  "ROUTE_LOGBOOK_NOT_FOUND",
  "ROUTE_LOGBOOK_ALREADY_LINKED",
  "ROUTE_VEHICLE_REQUIRED",
  "ROUTE_IMPORT_DUPLICATE",
  "ROUTE_SYNC_FAILED",
  "FLEET_ALERT_NOT_FOUND",
  "FLEET_ALERT_RESOLVED"
];

// src/fleet-routes.ts
var EXTERNAL_ROUTE_STATUSES = ["PLANNED", "IN_PROGRESS", "COMPLETED", "CANCELLED"];
var ROUTE_ROW_ERROR_CODES = [
  "ROUTE_ID_REQUIRED",
  "ROUTE_DATE_INVALID",
  "STOP_SEQUENCE_INVALID",
  "STOP_SEQUENCE_DUPLICATE",
  "PLANNED_KM_INVALID",
  "DATETIME_INVALID",
  "STATUS_INVALID",
  "ROUTE_FIELD_CONFLICT",
  "ROW_TOO_LONG",
  /** Trasa pominięta w całości, bo któryś jej wiersz jest błędny (nie zapisujemy trasy z uciętą listą punktów). */
  "ROUTE_SKIPPED"
];
var ROUTE_SYNC_STATUSES = ["RUNNING", "SUCCESS", "PARTIAL", "FAILED"];
var ROUTE_ID_MAP_KINDS = ["VEHICLE", "DRIVER"];
var ROUTE_PLAN_STATUSES = ["OK", "ABOVE_PLAN", "BELOW_PLAN", "NO_PLAN", "NO_ACTUAL", "NO_DATA"];

// src/fleet-dashboard.ts
var FLEET_ALERT_KINDS = [
  "LEASE_LIMIT",
  "LEASE_FORECAST_OVERAGE",
  "INSPECTION_DUE",
  "INSURANCE_DUE",
  "MISSING_LOGBOOK",
  "PENDING_LOGBOOK_REVIEW",
  "PENDING_FUEL_REVIEW",
  "PENDING_EXPENSE_REVIEW",
  "INCIDENT_OPEN",
  "ELEVATED_COST",
  "DRIVER_HOURS_OVER_LIMIT"
];
var FLEET_ALERT_SEVERITIES = ["CRITICAL", "WARNING", "INFO"];
var FLEET_ALERT_STATUSES = ["OPEN", "ACK", "RESOLVED"];
var FLEET_ALERT_ACTIONS = [
  "REVIEW_LEASE_USAGE",
  "PLAN_LEASE_ANNEX",
  "SCHEDULE_INSPECTION",
  "RENEW_INSURANCE",
  "COMPLETE_LOGBOOK",
  "REVIEW_LOGBOOKS",
  "REVIEW_FUEL",
  "REVIEW_EXPENSES",
  "DECIDE_INCIDENT",
  "HANDLE_INCIDENT",
  "INVESTIGATE_COSTS",
  "REVIEW_DRIVER_HOURS"
];
var FLEET_ALERT_NOTIFICATION_TYPE = "alert.fleet_alert";
var FLEET_DAY_STATES = ["ON_ROUTE", "PARKED", "IN_SERVICE"];
function vehicleDayState(status, hasOpenLogbook) {
  if (status === "IN_SERVICE") return "IN_SERVICE";
  return hasOpenLogbook ? "ON_ROUTE" : "PARKED";
}

// src/fleet-ai.ts
var FLEET_DEVIATION_KINDS = [
  "LEASE_FORECAST_OVERAGE",
  "FUEL_CONSUMPTION_RISE",
  "COST_PER_KM_HIGH",
  "ODOMETER_INCONSISTENT",
  "LOGBOOK_MISSING",
  "INSPECTION_APPROACHING",
  "PLAN_ACTUAL_DISCREPANCY"
];
var FLEET_CONFIDENCE_LEVELS = ["HIGH", "MEDIUM", "LOW"];
var FLEET_DATA_STATUSES = ["SUFFICIENT", "INDICATIVE"];
var FLEET_INSIGHT_ACTIONS = [
  "CHECK_LEASE_PLAN",
  "REVIEW_FUEL_ENTRIES",
  "REVIEW_COSTS",
  "VERIFY_ODOMETER",
  "COMPLETE_LOGBOOKS",
  "SCHEDULE_INSPECTION",
  "REVIEW_ROUTE_PLAN"
];
var FLEET_INSUFFICIENT_REASONS = [
  /** Zużycie paliwa: odcinki „pełny do pełnego” niekompletne (brak pełnych baków, luki, korekta licznika). */
  "FUEL_DATA_INCOMPLETE",
  /** Zużycie paliwa: brak odcinków w ostatnim okresie. */
  "FUEL_NO_RECENT_DATA",
  /** Zużycie paliwa: brak historii do porównania. */
  "FUEL_NO_BASELINE",
  /** Koszt/km: przebieg w oknie poniżej minimum albo brak odczytów licznika. */
  "COST_KM_TOO_LOW",
  /** Koszt/km: za mało porównywalnych pojazdów. */
  "COST_TOO_FEW_PEERS",
  /** Plan vs wykonanie: trasy bez powiązanej karty drogowej (brak „wykonania”). */
  "PLAN_NO_ACTUAL",
  /** Umowa leasingu: brak danych do prognozy (brak limitu lub przebiegu). */
  "LEASE_NO_FORECAST"
];
var FLEET_AI_INSIGHT_KINDS = ["FLEET_DAILY_MANAGER", "FLEET_WEEKLY_MANAGER"];
var FLEET_AI_TOOL_LABELS = {
  fleet_deviations: "Sprawdzam odchylenia we flocie\u2026",
  fleet_lease_outlook: "Licz\u0119 prognoz\u0119 limit\xF3w leasingu\u2026",
  fleet_recommendations: "Szukam mo\u017Cliwo\u015Bci optymalizacji floty\u2026",
  fleet_overview: "Zbieram dane o flocie\u2026"
};

// src/fleet-checklist-service-insights.ts
var FLEET_MATRIX_LEVELS = ["OK", "WARNING", "DEFECT", "CRITICAL"];

// src/admin-users.ts
var USER_PASSWORD_MIN = 10;
var USER_HAS_DATA_CODE = "USER_HAS_DATA";
var RESTRICTION_ERROR_CODES = {
  PASSWORD_CHANGE: "PASSWORD_CHANGE_REQUIRED",
  TWO_FACTOR_SETUP: "TWO_FACTOR_SETUP_REQUIRED"
};
var PASSWORD_LINK_TTL_HOURS = { ACTIVATION: 72, RESET: 2 };
var INVALID_TOKEN_CODE = "INVALID_TOKEN";

// src/audit.ts
var AUDIT_ACTIONS = [
  "CREATE",
  "UPDATE",
  "DELETE",
  "LOGIN",
  "LOGIN_FAILED",
  "LOGOUT",
  "DEMO_SWITCH",
  "TWO_FACTOR_ENABLED",
  "TWO_FACTOR_DISABLED",
  "EXPORT"
];
var AUDIT_SEVERITIES = ["INFO", "WARN", "CRITICAL", "SECURITY"];
var AUDIT_SEVERITY_BY_ACTION = {
  CREATE: "INFO",
  UPDATE: "INFO",
  DELETE: "CRITICAL",
  LOGIN: "INFO",
  LOGIN_FAILED: "SECURITY",
  LOGOUT: "INFO",
  DEMO_SWITCH: "SECURITY",
  TWO_FACTOR_ENABLED: "SECURITY",
  TWO_FACTOR_DISABLED: "SECURITY",
  EXPORT: "WARN"
};
var auditSeverity = (action) => AUDIT_SEVERITY_BY_ACTION[action] ?? "INFO";
var auditActionsOfSeverity = (severities) => AUDIT_ACTIONS.filter((a) => severities.includes(AUDIT_SEVERITY_BY_ACTION[a]));
var AUDIT_EXPORT_MAX = 5e3;

// src/logistics.ts
var DELIVERY_STATUSES = ["PLANNED", "IN_TRANSIT", "DELIVERED", "FAILED", "CANCELLED"];
var DELIVERY_FAILURE_REASONS = [
  "NO_ONE_AT_SITE",
  "REFUSED",
  "WRONG_ADDRESS",
  "DAMAGED_GOODS",
  "NO_PAYMENT",
  "VEHICLE_FAILURE",
  "TIME_EXCEEDED",
  "OTHER"
];
var DELIVERY_TRANSITIONS = {
  PLANNED: ["IN_TRANSIT", "DELIVERED", "FAILED", "CANCELLED"],
  IN_TRANSIT: ["DELIVERED", "FAILED", "PLANNED", "CANCELLED"],
  DELIVERED: ["PLANNED"],
  FAILED: ["PLANNED", "IN_TRANSIT", "DELIVERED"],
  CANCELLED: ["PLANNED"]
};
var LOGISTICS_PAGE_SIZE_MAX = 200;

// src/logistics-rules.ts
function warsawYmd(d) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Warsaw", year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
}
function daysBetween(fromYmd, toYmd) {
  const a = Date.UTC(+fromYmd.slice(0, 4), +fromYmd.slice(5, 7) - 1, +fromYmd.slice(8, 10));
  const b = Date.UTC(+toYmd.slice(0, 4), +toYmd.slice(5, 7) - 1, +toYmd.slice(8, 10));
  return Math.round((b - a) / 864e5);
}
function deliveryTiming(d, now = /* @__PURE__ */ new Date()) {
  const plannedDate = warsawYmd(d.plannedAt);
  let late = false;
  let delayDays = null;
  if (d.status === "DELIVERED" && d.deliveredAt) {
    const diff = daysBetween(plannedDate, warsawYmd(d.deliveredAt));
    if (diff > 0) {
      late = true;
      delayDays = diff;
    }
  } else if (d.status === "PLANNED" || d.status === "IN_TRANSIT") {
    const diff = daysBetween(plannedDate, warsawYmd(now));
    if (diff > 0) {
      late = true;
      delayDays = diff;
    }
  }
  return { plannedDate, late, delayDays, problem: late || d.status === "FAILED" };
}
function onTimePct(delivered, late) {
  if (delivered <= 0) return null;
  return Math.round((delivered - late) / delivered * 1e3) / 10;
}

// src/customer-card.ts
var PAYMENT_METHODS = ["TRANSFER", "CASH", "CARD", "CASH_ON_DELIVERY", "COMPENSATION", "OTHER"];
var TARGET_DOCUMENTS = ["INVOICE", "RECEIPT", "WZ"];
var DELIVERY_PRIORITIES = ["HIGH", "NORMAL", "LOW"];
var B2B_STATUSES = ["YES", "NO", "NEW", "TO_CREATE"];
var CONTACT_ROLES = ["OWNER", "ACCOUNTING", "OFFICE", "EMPLOYEE", "DELIVERY_RECEIVER", "OTHER"];
var B2B_DECISIONS = ["CREATE", "SKIP"];
var CUSTOMER_CARD_LIMITS = {
  shortName: 60,
  street: 200,
  postalCode: 10,
  city: 100,
  avizationHours: 200,
  phone: 30,
  email: 254,
  contactName: 120,
  remarks: 2e3,
  /** Maks. liczba osób kontaktowych w karcie. */
  contacts: 10,
  repComment: 1e3
};
var PL_ASCII = { \u0105: "a", \u0107: "c", \u0119: "e", \u0142: "l", \u0144: "n", \u00F3: "o", \u015B: "s", \u017A: "z", \u017C: "z" };
function suggestShortName(name) {
  return name.toLowerCase().replace(/[ąćęłńóśźż]/g, (c) => PL_ASCII[c] ?? c).replace(/[^a-z0-9]+/g, " ").trim().toUpperCase().slice(0, 20).trim();
}
var filled = (v) => typeof v === "string" && v.trim().length > 0;
function legacyContactFields(contacts) {
  const list = contacts.filter((c) => filled(c.name) || filled(c.email) || filled(c.phone));
  const main = list.find((c) => c.role === "OWNER") ?? list[0];
  return {
    contactName: main?.name?.trim() ?? "",
    contactPhone: (filled(main?.phone) ? main.phone : list.find((c) => filled(c.phone))?.phone ?? "").trim(),
    contactEmail: (filled(main?.email) ? main.email : list.find((c) => filled(c.email))?.email ?? "").trim()
  };
}

// src/daily-report-entries.ts
var REPORT_CLIENT_STATUSES = ["NEW", "SERVICED", "RECOVERED"];
var REPORT_OFFERS = ["YES", "NO", "TO_PREPARE"];
var REPORT_PERIOD_TYPES = ["WEEK", "MONTH"];
var POTENTIAL_BANDS = [
  { key: "1k-5k", min: 1e3, max: 5e3 },
  { key: "5k-10k", min: 5e3, max: 1e4 },
  { key: "10k-15k", min: 1e4, max: 15e3 },
  { key: "15k-20k", min: 15e3, max: 2e4 },
  { key: "20k-30k", min: 2e4, max: 3e4 },
  { key: "30k-40k", min: 3e4, max: 4e4 },
  { key: "40k-50k", min: 4e4, max: 5e4 },
  { key: "50k-60k", min: 5e4, max: 6e4 },
  { key: "60k-80k", min: 6e4, max: 8e4 },
  { key: "80k-100k", min: 8e4, max: 1e5 },
  { key: "100k+", min: 1e5, max: null }
];
function isPotentialBandKey(value) {
  return typeof value === "string" && POTENTIAL_BANDS.some((b) => b.key === value);
}
function potentialRange(keys) {
  let min = 0;
  let max = 0;
  for (const key of keys) {
    const band = POTENTIAL_BANDS.find((b) => b.key === key);
    if (!band) continue;
    min += band.min;
    max = max === null || band.max === null ? null : max + band.max;
  }
  return { min, max };
}
var pad = (n2) => String(n2).padStart(2, "0");
var isoDay = (d) => `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
function reportMonthWeeks(period) {
  const [y, m] = period.split("-").map(Number);
  const weeks = [];
  const days = new Date(Date.UTC(y, m, 0)).getUTCDate();
  let current = null;
  for (let day = 1; day <= days; day++) {
    const date = new Date(Date.UTC(y, m - 1, day));
    const dow = date.getUTCDay();
    if (dow === 0 || dow === 6) continue;
    if (!current || dow === 1) {
      if (current) weeks.push({ index: weeks.length + 1, label: `T${weeks.length + 1}`, ...current });
      current = { from: isoDay(date), to: isoDay(date) };
    } else {
      current.to = isoDay(date);
    }
  }
  if (current) weeks.push({ index: weeks.length + 1, label: `T${weeks.length + 1}`, ...current });
  return weeks;
}
function reportWeekOf(date) {
  const weeks = reportMonthWeeks(date.slice(0, 7));
  return [...weeks].reverse().find((w) => w.from <= date) ?? weeks[0];
}
var DAILY_REPORT_ENTRY_LIMITS = {
  entriesPerDay: 60,
  clientName: 200,
  shortText: 200,
  email: 254,
  phone: 30,
  outcome: 2e3,
  region: 100,
  competitorOther: 80,
  deliveriesPerWeekMax: 14,
  periodNote: 4e3
};
var COMPETITOR_SUPPLIER_NAME_MAX = 80;
var COMPETITOR_SUPPLIER_ERROR_CODES = {
  NAME_EXISTS: 409,
  NOT_FOUND: 404,
  FORBIDDEN: 403
};
var DAILY_REPORT_SUBMITTED_TYPE = "system.daily_report_submitted";
function dailyReportPanelLink(userId, date) {
  return `/analytics/team-reports?user=${encodeURIComponent(userId)}&date=${date}`;
}
var DAILY_REPORT_SHEET_ERROR_CODES = {
  VALIDATION: 400,
  /** Raport wysłany, a dzień już minął — bez edycji. */
  REPORT_LOCKED: 409,
  /** Wysyłka pustego raportu (bez wierszy i bez uwag). */
  REPORT_EMPTY: 400,
  FORBIDDEN: 403,
  NOT_FOUND: 404
};

// src/rep-sales.ts
var REP_SALES_LOW_MARGIN_PCT = 30;
var REP_SALES_BIG_DROP_PCT = 30;
var REP_SALES_COMMENT_MAX = 1e3;
var REP_SALES_DEFAULT_SETTINGS = {
  autoEnabled: true,
  dayOfWeek: 1,
  hour: 7,
  minute: 15,
  channel: "APP",
  managersCopy: false,
  commentDueDays: 3,
  commentDueHour: 16
};
var REP_SALES_NOTE_MAX = 500;
function repSalesAvgMarginPct(months) {
  let net = 0;
  let margin = 0;
  for (const m of months) {
    if (m.net <= 0 || m.marginPct === null) continue;
    net += m.net;
    margin += m.net * m.marginPct / 100;
  }
  return net > 0 ? Math.round(margin / net * 1e3) / 10 : null;
}
function repSalesFlags(months, newOrRecovered) {
  const [m2, m1, m0] = months;
  const noSales = (m1?.net ?? 0) <= 0 && (m0?.net ?? 0) <= 0;
  const base = m2?.net ?? 0;
  const bigDrop = !noSales && base > 0 && (m1?.net ?? 0) <= base * (1 - REP_SALES_BIG_DROP_PCT / 100);
  const avg = repSalesAvgMarginPct(months);
  return { bigDrop, noSales, newOrRecovered, lowMargin: avg !== null && avg < REP_SALES_LOW_MARGIN_PCT };
}
function repSalesTrend(months, flags) {
  if (flags.newOrRecovered) return "NEW";
  if (flags.bigDrop || flags.noSales) return "BIG_DROP_OR_NONE";
  const m2 = months[0]?.net ?? 0;
  const m1 = months[1]?.net ?? 0;
  if (m1 > m2) return "GROWTH";
  if (m1 < m2) return "DROP";
  return "FLAT";
}
function repSalesNeedsComment(row) {
  return row.trend === "DROP" || row.trend === "BIG_DROP_OR_NONE" || row.flags.lowMargin;
}
function repSalesMissingComment(row) {
  return repSalesNeedsComment(row) && !row.repComment?.trim();
}

// src/logistics-optimization.ts
var LOGISTICS_DEPOT = { name: "Magazyn Gda\u0144sk", lat: 54.3305, lng: 18.6905 };
var LOGISTICS_OPT_DEFAULTS = {
  /** Pojemność auta w przystankach (założenie). */
  stopCapacity: 16,
  /** Ile ostatnich kursów trasy próbkować przez OSRM. */
  sampleRuns: 6,
  /** Dni robocze w miesiącu do przeliczeń „na miesiąc”. */
  workingDaysPerMonth: 21,
  /** Wypełnienie poniżej → kandydat do rzadszych kursów. */
  lowFillPct: 55,
  /** Pusty przebieg powyżej (% km kursu) → podpowiedź EMPTY_RUNS. */
  highEmptyPct: 45,
  /** Nadmiarowe km powyżej (% km kursu) → podpowiedź REORDER. */
  excessKmPct: 8
};
var OPTIMIZATION_KINDS = [
  "REORDER",
  "REDUCE_FREQUENCY",
  "REASSIGN_CUSTOMER",
  "EMPTY_RUNS",
  "UNPROFITABLE_DELIVERIES",
  "WEAK_WEEKDAY"
];

// src/mbr/common.ts
var MBR_COMPARE_MODES = ["MOM", "YOY", "YTD", "AVG3M"];
var MBR_SECTION_KEYS = [
  "report",
  "sales",
  "customers",
  "logistics",
  "operations",
  "finance",
  "close"
];
var MBR_DATA_SECTION_KEYS = [
  "sales",
  "customers",
  "logistics",
  "operations",
  "finance"
];
var MBR_BRANCHES = ["GD", "ZK", "CT"];
var MBR_COMPANY_BRANCH_KEY = "_";
var MBR_HQ_ALLOCATION_KEYS = ["SALES", "ORDERS", "KM"];
var MBR_DEFAULT_LOGISTICS_VEHICLE_TYPES = FLEET_VEHICLE_TYPES.filter(
  (t) => t !== "PASSENGER_CAR"
);
var MBR_DEFAULT_SETTINGS = {
  lostAfterMonths: 2,
  toleranceAbs: 100,
  tolerancePct: 0.5,
  hqAllocationKey: "SALES",
  routeBranchMap: {
    GCH: "GD",
    GD: "GD",
    GSP: "GD",
    GA: "GD",
    EL: "GD",
    HEL: "GD",
    ZK: "ZK",
    CT1: "CT",
    CBY: "CT",
    CAT: "GD"
    // arkusz klienta: CAT to trasy Gdańska, Toruń = CT1 + CBY
  },
  recipients: [],
  sendBusinessDay: 2,
  sendHour: 8,
  sendEnabled: false,
  sectionDefaults: {},
  extra: {
    driverHoursAlert: 200,
    alternatingMinSwitches: 3,
    flatDeltaPct: 0.5,
    defaultDeliveryWeekdays: [1, 2, 3, 4, 5, 6],
    segmentSeasons: {},
    fleetUnderusedPct: 60,
    fleetOverLimitPct: 100,
    logisticsVehicleTypes: MBR_DEFAULT_LOGISTICS_VEHICLE_TYPES,
    insightAnomalyZ: 3,
    insightMinAmountPln: 1e4,
    insightMinCount: 20
  }
};

// src/mbr/period.ts
var PERIOD_RE = /^(\d{4})-(0[1-9]|1[0-2])$/;
function isMbrPeriod(value) {
  return typeof value === "string" && PERIOD_RE.test(value);
}
function parsePeriod(period) {
  const m = PERIOD_RE.exec(period);
  if (!m) throw new Error(`Invalid period: ${period}`);
  return { year: Number(m[1]), month: Number(m[2]) };
}
function formatPeriod(year, month) {
  return `${year}-${String(month).padStart(2, "0")}`;
}
function addMonths(period, months) {
  const { year, month } = parsePeriod(period);
  const idx = year * 12 + (month - 1) + months;
  return formatPeriod(Math.floor(idx / 12), idx % 12 + 1);
}
var previousPeriod = (period) => addMonths(period, -1);
var yearAgoPeriod = (period) => addMonths(period, -12);
function periodsBetween(from, to) {
  const out = [];
  for (let p = from; comparePeriods(p, to) <= 0; p = addMonths(p, 1)) out.push(p);
  return out;
}
function comparePeriods(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}
function lastPeriods(period, n2) {
  return periodsBetween(addMonths(period, -(n2 - 1)), period);
}
function ytdPeriods(period) {
  const { year } = parsePeriod(period);
  return periodsBetween(formatPeriod(year, 1), period);
}
function periodRange(period) {
  const { year, month } = parsePeriod(period);
  return { from: new Date(Date.UTC(year, month - 1, 1)), to: new Date(Date.UTC(year, month, 1)) };
}
function daysInPeriod(period) {
  const { year, month } = parsePeriod(period);
  return new Date(Date.UTC(year, month, 0)).getUTCDate();
}
function periodOfDate(date) {
  return formatPeriod(date.getUTCFullYear(), date.getUTCMonth() + 1);
}
function defaultReportPeriod(now = /* @__PURE__ */ new Date()) {
  return addMonths(formatPeriod(now.getFullYear(), now.getMonth() + 1), -1);
}
function comparisonWindows(period, mode) {
  switch (mode) {
    case "MOM":
      return { mode, current: [period], base: [previousPeriod(period)], baseAggregation: "SUM" };
    case "YOY":
      return { mode, current: [period], base: [yearAgoPeriod(period)], baseAggregation: "SUM" };
    case "YTD": {
      const current = ytdPeriods(period);
      return { mode, current, base: current.map(yearAgoPeriod), baseAggregation: "SUM" };
    }
    case "AVG3M":
      return {
        mode,
        current: [period],
        base: lastPeriods(previousPeriod(period), 3),
        baseAggregation: "AVG"
      };
  }
}
function periodsNeeded(period, mode, trendMonths = 12) {
  const w = comparisonWindows(period, mode);
  const all = /* @__PURE__ */ new Set([
    ...w.current,
    ...w.base,
    ...trendMonths > 0 ? lastPeriods(period, trendMonths) : []
  ]);
  return [...all].sort(comparePeriods);
}

// src/mbr/compare.ts
var MBR_DEFAULT_FLAT_DELTA = 0.5;
var round = (v, digits = 6) => Math.round(v * 10 ** digits) / 10 ** digits;
function mbrValue(value) {
  if (value === null || value === void 0 || Number.isNaN(value)) return { value: null, status: "MISSING" };
  return { value, status: value === 0 ? "ZERO" : "OK" };
}
var MBR_MISSING = { value: null, status: "MISSING" };
var MBR_RESTRICTED = { value: null, status: "RESTRICTED" };
var MBR_MISSING_COMPARED = {
  current: MBR_MISSING,
  base: MBR_MISSING,
  delta: null,
  deltaPct: null,
  deltaPp: null,
  tone: "NEUTRAL"
};
var MBR_RESTRICTED_COMPARED = {
  current: MBR_RESTRICTED,
  base: MBR_RESTRICTED,
  delta: null,
  deltaPct: null,
  deltaPp: null,
  tone: "NEUTRAL"
};
function aggregate(values, how) {
  const present = values.filter((v) => v !== null && v !== void 0 && !Number.isNaN(v));
  if (!present.length) return MBR_MISSING;
  const sum = present.reduce((a, b) => a + b, 0);
  const value = how === "SUM" ? sum : sum / present.length;
  if (present.length < values.length) return { value, status: "PARTIAL" };
  return mbrValue(value);
}
function toneFor(change, direction, flat = MBR_DEFAULT_FLAT_DELTA) {
  if (change === null || direction === "NEUTRAL" || Math.abs(change) < flat) return "NEUTRAL";
  const up = change > 0;
  return direction === "UP_IS_GOOD" === up ? "GOOD" : "BAD";
}
function mbrDeltaPct(current, base) {
  if (current === null || base === null || Number.isNaN(current) || Number.isNaN(base)) return null;
  if (base <= 0 || current < 0) return null;
  return (current - base) / base * 100;
}
function mbrRelativeChange(current, base) {
  if (current === null || base === null) return null;
  const scale = Math.max(Math.abs(current), Math.abs(base));
  return scale === 0 ? 0 : (current - base) / scale * 100;
}
function compareValues(current, base, direction, unit, flat = MBR_DEFAULT_FLAT_DELTA) {
  const c = current.value;
  const b = base.value;
  const delta = c !== null && b !== null ? round(c - b) : null;
  const pctRaw = mbrDeltaPct(c, b);
  const deltaPct = pctRaw === null ? null : round(pctRaw, 4);
  const deltaPp = unit === "PCT" ? delta : null;
  const change = unit === "PCT" ? deltaPp : deltaPct ?? (delta === null ? null : mbrRelativeChange(c, b));
  const tone = toneFor(change, direction, flat);
  return { current, base, delta, deltaPct, deltaPp, tone };
}
function pct(numerator, denominator) {
  if (numerator === null || numerator === void 0 || !denominator) return null;
  return numerator / denominator * 100;
}
function div(numerator, denominator) {
  if (numerator === null || numerator === void 0 || !denominator) return null;
  return numerator / denominator;
}
function at(series, p) {
  const v = series instanceof Map ? series.get(p) : series[p];
  return v === void 0 ? null : v;
}
function compareAdditive(series, period, mode, direction, unit, flat) {
  const w = comparisonWindows(period, mode);
  const current = aggregate(
    w.current.map((p) => at(series, p)),
    "SUM"
  );
  const base = aggregate(
    w.base.map((p) => at(series, p)),
    w.baseAggregation
  );
  return compareValues(current, base, direction, unit, flat);
}
function compareRatio(numerator, denominator, period, mode, direction, unit, scale = 1, flat) {
  const w = comparisonWindows(period, mode);
  const present = (v) => v !== null && !Number.isNaN(v);
  const ratio = (periods, how) => {
    const paired = periods.filter((p) => present(at(numerator, p)) && present(at(denominator, p)));
    const n2 = aggregate(
      paired.map((p) => at(numerator, p)),
      how
    );
    const d = aggregate(
      paired.map((p) => at(denominator, p)),
      how
    );
    const v = div(n2.value, d.value);
    if (v === null) return MBR_MISSING;
    const out = mbrValue(v * scale);
    return paired.length < periods.length ? { ...out, status: "PARTIAL" } : out;
  };
  return compareValues(ratio(w.current, "SUM"), ratio(w.base, w.baseAggregation), direction, unit, flat);
}
function trendOf(series, period, months = 12) {
  return lastPeriods(period, months).map((p) => ({ period: p, value: at(series, p) }));
}
function ratioTrendOf(numerator, denominator, period, scale = 1, months = 12) {
  return lastPeriods(period, months).map((p) => {
    const v = div(at(numerator, p), at(denominator, p));
    return { period: p, value: v === null ? null : v * scale };
  });
}
function additiveKpi(def, series, period, mode, flat) {
  return {
    ...def,
    value: compareAdditive(series, period, mode, def.direction, def.unit, flat),
    trend: trendOf(series, period)
  };
}
function perDeliveryDay(value, days) {
  return div(value, days);
}

// src/mbr/bep.ts
function computeBep(i) {
  const fixedTotal = i.fixedCosts + i.payroll;
  const operatingResult = i.sales - i.cogs - i.variableCosts - fixedTotal;
  if (!i.sales) {
    return {
      grossMarginPct: null,
      variableCostsPct: null,
      contributionMarginPct: null,
      bep: null,
      operatingResult,
      pctAboveBep: null,
      gapToBep: null
    };
  }
  const cm = 1 - i.cogs / i.sales - i.variableCosts / i.sales;
  const bep = cm > 0 ? fixedTotal / cm : null;
  return {
    grossMarginPct: (1 - i.cogs / i.sales) * 100,
    variableCostsPct: i.variableCosts / i.sales * 100,
    contributionMarginPct: cm * 100,
    bep,
    operatingResult,
    pctAboveBep: bep ? (i.sales / bep - 1) * 100 : null,
    gapToBep: bep === null ? null : Math.max(0, bep - i.sales)
  };
}
function simulateBep(p) {
  const cogs = p.sales * (1 - p.grossMarginPct / 100);
  const variableCosts = p.sales * (p.variableCostsPct / 100);
  return computeBep({ sales: p.sales, cogs, variableCosts, fixedCosts: p.fixedTotal, payroll: 0 });
}
function bepParamsFrom(i) {
  return {
    sales: i.sales,
    grossMarginPct: i.sales ? (1 - i.cogs / i.sales) * 100 : 0,
    variableCostsPct: i.sales ? i.variableCosts / i.sales * 100 : 0,
    fixedTotal: i.fixedCosts + i.payroll
  };
}

// src/mbr/checks.ts
var MBR_CHECKS = {
  /** Udział oddziału liczony do CAŁOŚCI sprzedaży, nie do GD (Excel: ZK ÷ GD = 18,3% zamiast 15,1%). */
  BRANCH_SHARE_OF_TOTAL: { section: "sales", excel: "Udzia\u0142 sprzeda\u017Cy ZK / CT" },
  /** Zmiana % zawsze od okresu bazowego (Excel: należności pozostałe dzielone przez luty zamiast stycznia). */
  DELTA_FROM_BASE: { section: "report", excel: "Nale\u017Cno\u015Bci pozosta\u0142e, zmiana %" },
  /** Suma tras = sprzedaż po korektach (± tolerancja z ustawień). Excel: różnica 31 428 zł. */
  ROUTES_SUM_EQUALS_SALES: { section: "sales", excel: "Suma tras vs sprzeda\u017C" },
  /** Przedziały wiekowania (<30, >30) sumują się do przeterminowanych. Excel (faktoring, styczeń): 581 979 vs 564 477. */
  RECEIVABLE_BUCKETS_SUM: { section: "finance", excel: "Faktoring, stycze\u0144" },
  /** „7 dni wstecz” identyczne z bieżącym co do grosza = podejrzenie skopiowanej kolumny. */
  RECEIVABLE_WEEK_AGO_COPY: { section: "finance", excel: "Faktoring, \u201E7 dni wstecz\u201D" },
  /** Sekcja identyczna jak w poprzednim miesiącu co do grosza = dane nieodświeżone (Excel: windykacja 47 spraw / 509 447 zł). */
  SECTION_UNCHANGED: { section: "close", excel: "Windykacja" },
  /** Jedna jednostka marży (procent, nie ułamek): 0,35 obok 38,6. */
  MARGIN_UNIT: { section: "customers", excel: "Mar\u017Ca klient\xF3w" },
  /** Brak danych ≠ zero (Toruń w styczniu 0). */
  DATA_MISSING_VS_ZERO: { section: "close", excel: "Mar\u017Ca klient\xF3w, Toru\u0144" },
  /** Rok w danych = okres raportu (Excel: wiersz z rokiem 2027). */
  PERIOD_YEAR_MISMATCH: { section: "close", excel: "Wynagrodzenia" },
  /** Koszt pracodawcy ≥ brutto ≥ netto (umowy zlecenia: koszt = netto). */
  PAYROLL_COST_ORDER: { section: "finance", excel: "Wynagrodzenia" },
  /** Dni dostaw z kalendarza tras, nie wpisywane ręcznie; ręczna wartość ≠ kalendarz = ostrzeżenie. */
  DELIVERY_DAYS_FROM_CALENDAR: { section: "operations", excel: "Reklamacje na dzie\u0144" },
  /** Jedna konwencja kolumn (bieżący, bazowy) w całym raporcie — pilnuje kontrakt, sprawdza import. */
  COLUMN_ORDER: { section: "close", excel: "Tabela BEP" }
};
function toleranceSeverity(expected, actual, toleranceAbs, tolerancePct) {
  const diff = Math.abs(actual - expected);
  if (diff < 5e-3) return "OK";
  const pctDiff = expected ? diff / Math.abs(expected) * 100 : Infinity;
  return diff > toleranceAbs && pctDiff > tolerancePct ? "FAIL" : "WARN";
}
function toleranceCheck(code, sectionKey, expected, actual, tol, target) {
  if (expected === null || actual === null)
    return {
      code,
      sectionKey,
      severity: "INFO",
      target,
      expected,
      actual,
      diff: null,
      params: { reason: "missing" }
    };
  return {
    code,
    sectionKey,
    severity: toleranceSeverity(expected, actual, tol.toleranceAbs, tol.tolerancePct),
    target,
    expected,
    actual,
    diff: actual - expected
  };
}
function identicalToTheGrosz(a, b) {
  if (!a.length || a.length !== b.length) return false;
  if (a.every((v) => v === null || v === void 0 || v === 0)) return false;
  return a.every((v, i) => {
    const w = b[i];
    if (v === null || v === void 0 || w === null || w === void 0) return v === w;
    return Math.round(v * 100) === Math.round(w * 100);
  });
}
function looksLikeFraction(value, peers) {
  if (value === null || value === void 0 || value === 0 || Math.abs(value) > 1) return false;
  return peers.some((p) => p !== null && p !== void 0 && Math.abs(p) > 1);
}
function summarizeChecks(checks) {
  const out = { ok: 0, info: 0, warn: 0, fail: 0 };
  for (const c of checks) out[c.severity.toLowerCase()] += 1;
  return out;
}

// src/mbr/sales.ts
var MBR_SALES_API = "/mbr/sales";
var MBR_SALES_SCENARIOS_API = "/mbr/sales/scenarios";
var MBR_SALES_SIMULATE_API = "/mbr/sales/simulate";
var MBR_ROUTE_GROUPS = [
  "GCH",
  "GD",
  "GSP",
  "GA",
  "EL",
  "HEL",
  "ZK",
  "CT1",
  "CBY",
  "CAT",
  "PICKUP"
];
var MBR_PICKUP_GROUP = "PICKUP";
var MBR_SALES_METRIC_PREFIX = { route: "route.", branchSharePct: "branchSharePct." };
var MBR_SALES_CHECKS = ["ROUTE_GROUP_UNMAPPED"];
var MBR_BEP_PARAM_LIMITS = {
  sales: { min: 0, max: 1e9 },
  grossMarginPct: { min: -100, max: 100 },
  variableCostsPct: { min: 0, max: 100 },
  fixedTotal: { min: 0, max: 1e9 }
};

// src/mbr/customers.ts
var MBR_CUSTOMERS_API = "/mbr/customers";
var MBR_CUSTOMER_STATUSES = [
  "NEW",
  "RECOVERED",
  "ACTIVE",
  "PAUSED",
  "LOST",
  "ALTERNATING",
  "INACTIVE"
];
var MBR_RECOVERABLE_STATUSES = ["LOST", "INACTIVE", "PAUSED", "ALTERNATING"];
var MBR_CUSTOMER_MODES = ["SETTINGS", "EXCEL"];
var MBR_CUSTOMER_LIST_FILTERS = [...MBR_CUSTOMER_STATUSES, "GAINED", "ALL"];
var MBR_CUSTOMERS_CHECKS = [
  "CUSTOMER_FLOW_BRIDGE",
  "MARGIN_MISSING_NOT_ZERO",
  "CUSTOMER_HISTORY_TOO_SHORT"
];
var MBR_DEFAULT_SEGMENT_SEASONS = { INSTITUTION: [7, 8] };

// src/mbr/logistics.ts
var MBR_LOGISTICS_API = "/mbr/logistics";
var MBR_LOGISTICS_CHECKS = [
  "LOGISTICS_KM_SUM",
  "LOGISTICS_FUEL_SUM",
  "LOGISTICS_HOURS_SUM",
  "LOGISTICS_VEHICLE_COUNT"
];
var MBR_LOGISTICS_METRIC_KEYS = {
  km: "km",
  fuelCost: "fuelCost",
  driverHours: "driverHours",
  /** Liczba aut w podsumowaniu (arkusz „2026”) — porównywana z liczbą aut w najmie. */
  vehicles: "vehicles"
};
var MBR_LOGISTICS_RULES = {
  underusedPct: 60,
  overLimitPct: 100,
  maxSwapSuggestions: 6,
  /** Karta drogowa dłuższa niż tyle godzin jest przycinana (niezamknięta karta nie może dać 300 h). */
  maxLogbookHours: 16
};

// src/mbr/operations.ts
var MBR_OPERATIONS_API = "/mbr/operations";
var MBR_OPERATIONS_ENDPOINTS = {
  section: MBR_OPERATIONS_API,
  complaints: `${MBR_OPERATIONS_API}/complaints`,
  complaintsAnalysis: `${MBR_OPERATIONS_API}/complaints/analysis`,
  disposals: `${MBR_OPERATIONS_API}/disposals`,
  lookups: `${MBR_OPERATIONS_API}/lookups`
};
var MBR_COMPLAINT_CATEGORIES = [
  "QUALITY",
  "MISSING_IN_DELIVERY",
  "MISSING_ON_DOCUMENT",
  "WEIGHT_QUANTITY",
  "WRONG_PRODUCT",
  "EXPIRY_DATE",
  "PRICE",
  "OTHER"
];
var MBR_COMPLAINT_STATUSES = ["OPEN", "IN_PROGRESS", "ACCEPTED", "REJECTED", "CLOSED"];
var MBR_OPERATIONS_CHECKS = [
  "COMPLAINT_CATEGORIES_SUM",
  "PRODUCTION_MISSING_NOT_ZERO",
  "WAREHOUSE_ORDERS_VS_ERP"
];
var MBR_OPERATIONS_METRICS = {
  /** Reklamacje łącznie (liczba) — tak, jak podał dział (do uzgodnienia z sumą kategorii). */
  complaintsTotal: "complaints.total",
  /** Reklamacje w kategorii: `complaints.category.QUALITY` itd. (liczba). */
  complaintsCategoryPrefix: "complaints.category.",
  /** Dni dostaw wpisane ręcznie w Excelu / formularzu (do porównania z kalendarzem). */
  deliveryDaysTyped: "deliveryDays.typed",
  /** Utylizacja okresu (zł), gdy nie ma wpisów w rejestrze utylizacji. */
  disposalValue: "disposal.value"
};
var MBR_COMPLAINT_DIMENSIONS = ["category", "product", "route", "driver", "customer"];
var MBR_COMPLAINT_RESOLVED_STATUSES = [
  "ACCEPTED",
  "REJECTED",
  "CLOSED"
];
var MBR_OPERATIONS_LOOKUP_KINDS = ["customer", "product", "route", "driver", "vehicle"];

// src/mbr/finance.ts
var MBR_FINANCE_API = "/mbr/finance";
var MBR_COST_KINDS = [
  "FIXED",
  "SEMI",
  "VARIABLE",
  "PAYROLL"
];
var MBR_SEMI_COUNTS_AS = "FIXED";
var MBR_COST_CATEGORIES = {
  fixedOther: { kind: "FIXED", branched: false },
  vehiclesRent: { kind: "FIXED", branched: true },
  premises: { kind: "FIXED", branched: true },
  equipmentLeasing: { kind: "FIXED", branched: false },
  energy: { kind: "SEMI", branched: true },
  variableOther: { kind: "VARIABLE", branched: false },
  vehiclesOperation: { kind: "VARIABLE", branched: true },
  packaging: { kind: "VARIABLE", branched: false },
  transportPurchase: { kind: "VARIABLE", branched: true },
  transportB2b: { kind: "VARIABLE", branched: true },
  payroll: { kind: "PAYROLL", branched: true }
};
var MBR_COST_CATEGORY_KEYS = Object.keys(MBR_COST_CATEGORIES);
var isMbrCostCategory = (v) => typeof v === "string" && Object.prototype.hasOwnProperty.call(MBR_COST_CATEGORIES, v);
function mbrCostTotals(entries) {
  const out = { fixed: 0, variable: 0, payroll: 0, semi: 0 };
  for (const e of entries) {
    if (e.amount === null) continue;
    if (e.kind === "FIXED") out.fixed += e.amount;
    else if (e.kind === "SEMI") {
      out.semi += e.amount;
      out.fixed += e.amount;
    } else if (e.kind === "VARIABLE") out.variable += e.amount;
    else out.payroll += e.amount;
  }
  return out;
}
var MBR_COLLECTION_STAGES = [
  "preCourt",
  "court",
  "enforcement",
  "bankruptcy",
  "settlement"
];
var MBR_ERP_REMINDER_STAGES = [
  "reminderUpcoming",
  "reminderDue",
  "reminderOverdue",
  "dunningNotice",
  "urge",
  "demand",
  "demandLate"
];
var MBR_COLLECTION_FUNNEL_ORDER = [
  ...MBR_ERP_REMINDER_STAGES,
  ...MBR_COLLECTION_STAGES
];
var MBR_FINANCE_CHECKS = [
  /** Blok identyczny jak w poprzednim miesiącu co do grosza = nieodświeżony (osobny kod na blok — komunikat bez zmiennych). */
  "FINANCE_COSTS_UNCHANGED",
  "FINANCE_HR_UNCHANGED",
  "FINANCE_RECEIVABLES_UNCHANGED",
  "FINANCE_COLLECTIONS_UNCHANGED",
  /** Suma kosztu pracodawcy z kadr = wynagrodzenia w kosztach (± tolerancja). */
  "FINANCE_HR_EQUALS_PAYROLL",
  /** Brak danych w okresie, a ten sam miesiąc rok później ma dane = podejrzenie złego roku (Excel: wiersz z rokiem 2027). */
  "FINANCE_PERIOD_YEAR"
];
var MBR_FINANCE_FORMS = ["costs", "hr", "receivables", "collections"];
var MBR_FINANCE_ANCHORS = {
  costs: "mbr-fin-costs",
  receivables: "mbr-fin-receivables",
  collections: "mbr-fin-collections",
  hr: "mbr-fin-hr"
};

// src/mbr/close-forms.ts
var num = (key, unit, extra = {}) => ({
  key,
  type: "number",
  unit,
  ...extra
});
var int = (key, extra = {}) => ({
  key,
  type: "integer",
  unit: "COUNT",
  ...extra
});
var MBR_BRANCH_ROW_KEYS = ["_", "GD", "ZK", "CT"];
var MBR_RECEIVABLE_KINDS = ["FACTORING", "OTHER"];
var MBR_CLOSE_COLLECTION_SUGGESTIONS = ["enforcement", "court", "other"];
var MBR_CLOSE_FORM_DEFS = {
  warehouse: {
    section: "operations",
    rows: { kind: "branch", options: MBR_BRANCH_ROW_KEYS, maxRows: 4 },
    fields: [
      int("ordersCount"),
      num("pickingHours", "HOURS"),
      int("orderLines"),
      num("inventoryPlus", "PLN"),
      num("inventoryMinus", "PLN")
    ],
    dueBusinessDay: 3
  },
  quality: {
    section: "operations",
    rows: { kind: "single", maxRows: 1 },
    fields: [num("disposalValue", "PLN"), ...MBR_COMPLAINT_CATEGORIES.map((c) => int(c))],
    dueBusinessDay: 3
  },
  production: {
    section: "operations",
    rows: { kind: "single", maxRows: 1 },
    fields: [num("salesValue", "PLN"), num("costValue", "PLN"), num("quantity", "COUNT")],
    dueBusinessDay: 5
  },
  fleet: {
    section: "logistics",
    rows: { kind: "text", withBranch: true, maxRows: 200 },
    fields: [
      num("km", "KM"),
      num("kmLimit", "KM"),
      num("fuelCost", "PLN"),
      num("rentCost", "PLN"),
      num("excessMileageCost", "PLN"),
      num("otherCost", "PLN")
    ],
    dueBusinessDay: 4
  },
  drivers: {
    section: "logistics",
    rows: { kind: "text", withBranch: true, maxRows: 300 },
    fields: [
      num("hours", "HOURS"),
      num("overtimeHours", "HOURS"),
      num("sickLeaveDays", "DAYS"),
      num("vacationDays", "DAYS")
    ],
    dueBusinessDay: 4
  },
  costs: {
    section: "finance",
    rows: {
      kind: "option",
      options: Object.keys(MBR_COST_CATEGORIES),
      withBranch: true,
      maxRows: 60
    },
    fields: [num("amount", "PLN", { required: true, allowNegative: true })],
    dueBusinessDay: 7
  },
  hr: {
    section: "finance",
    rows: { kind: "text", withBranch: true, maxRows: 60 },
    fields: [
      num("headcount", "COUNT"),
      num("grossPay", "PLN"),
      num("bonuses", "PLN"),
      num("netPay", "PLN"),
      num("employerCost", "PLN"),
      num("hours", "HOURS")
    ],
    dueBusinessDay: 7
  },
  receivables: {
    section: "finance",
    rows: { kind: "option", options: MBR_RECEIVABLE_KINDS, maxRows: 2 },
    fields: [
      { key: "date", type: "date", required: true },
      num("balance", "PLN"),
      num("notDue", "PLN"),
      num("overdue", "PLN"),
      num("overdueUpTo30", "PLN"),
      num("overdueOver30", "PLN"),
      num("repayments7d", "PLN"),
      num("weekAgoBalance", "PLN"),
      num("weekAgoOverdue", "PLN")
    ],
    dueBusinessDay: 2
  },
  collections: {
    section: "finance",
    rows: { kind: "text", suggestions: MBR_CLOSE_COLLECTION_SUGGESTIONS, maxRows: 20 },
    fields: [int("casesCount"), num("amount", "PLN")],
    dueBusinessDay: 5
  }
};
var MAX_TEXT_KEY = 120;
var MAX_NOTE = 2e3;
var DATE_RE = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
var BRANCHES = MBR_BRANCH_ROW_KEYS;
function toNumber(raw) {
  if (raw === null || raw === void 0 || raw === "") return null;
  if (typeof raw === "number") return Number.isFinite(raw) ? raw : "NaN";
  if (typeof raw === "string") {
    const s = raw.replace(/\s| /g, "").replace(",", ".");
    if (!s) return null;
    const n2 = Number(s);
    return Number.isFinite(n2) ? n2 : "NaN";
  }
  return "NaN";
}
var round2 = (n2, digits) => Math.round(n2 * 10 ** digits) / 10 ** digits;
function validateCloseForm(def, input, period) {
  const issues = [];
  const issue = (severity, code, row = null, rowKey = null, field = null) => issues.push({ severity, code, row, rowKey, field });
  if (!input || typeof input !== "object" || !Array.isArray(input.rows)) {
    issue("ERROR", "NOT_AN_OBJECT");
    return { data: { rows: [] }, issues };
  }
  const raw = input;
  if (raw.rows.length > def.rows.maxRows) issue("ERROR", "TOO_MANY_ROWS");
  const note = typeof raw.note === "string" ? raw.note.trim() : null;
  if (note && note.length > MAX_NOTE) issue("ERROR", "NOTE_TOO_LONG");
  const fieldDefs = new Map(def.fields.map((f) => [f.key, f]));
  const seen = /* @__PURE__ */ new Set();
  const rows = [];
  raw.rows.slice(0, def.rows.maxRows).forEach((r, i) => {
    const row = r && typeof r === "object" ? r : {};
    let key = typeof row.key === "string" ? row.key.trim() : "";
    if (def.rows.kind === "single") key = "_";
    if (def.rows.kind === "branch" && !key) key = "_";
    const okKey = def.rows.kind === "single" || def.rows.kind === "text" && key.length > 0 && key.length <= MAX_TEXT_KEY || (def.rows.kind === "option" || def.rows.kind === "branch") && !!def.rows.options?.includes(key);
    if (!okKey) issue("ERROR", "BAD_ROW_KEY", i, key || null);
    let branch;
    if (def.rows.withBranch) {
      const b = typeof row.branch === "string" && row.branch ? row.branch : "_";
      if (!BRANCHES.includes(b)) issue("ERROR", "BAD_BRANCH", i, key);
      branch = b;
    }
    const identity = `${def.rows.kind === "text" ? key.toLowerCase() : key}|${branch ?? ""}`;
    if (seen.has(identity)) issue("ERROR", "DUPLICATE_ROW", i, key);
    seen.add(identity);
    const values = {};
    const given = row.values && typeof row.values === "object" ? row.values : {};
    for (const k of Object.keys(given)) if (!fieldDefs.has(k)) issue("ERROR", "UNKNOWN_FIELD", i, key, k);
    for (const f of def.fields) {
      const v = given[f.key];
      if (f.type === "date") {
        const s = typeof v === "string" ? v.trim() : "";
        if (!s) {
          values[f.key] = null;
          if (f.required) issue("ERROR", "REQUIRED", i, key, f.key);
        } else if (!DATE_RE.test(s) || Number.isNaN(Date.parse(`${s}T00:00:00Z`))) {
          issue("ERROR", "BAD_DATE", i, key, f.key);
          values[f.key] = null;
        } else {
          values[f.key] = s;
          if (s.slice(0, 7) !== period) issue("WARN", "DATE_OUTSIDE_PERIOD", i, key, f.key);
        }
        continue;
      }
      const n2 = toNumber(v);
      if (n2 === "NaN") {
        issue("ERROR", "NOT_A_NUMBER", i, key, f.key);
        values[f.key] = null;
        continue;
      }
      if (n2 === null) {
        if (f.required) issue("ERROR", "REQUIRED", i, key, f.key);
        values[f.key] = null;
        continue;
      }
      if (f.type === "integer" && !Number.isInteger(n2)) issue("ERROR", "NOT_INTEGER", i, key, f.key);
      if (n2 < 0 && !f.allowNegative) issue("ERROR", "NEGATIVE", i, key, f.key);
      values[f.key] = round2(n2, f.type === "integer" ? 0 : 3);
    }
    rows.push({ key, ...def.rows.withBranch ? { branch } : {}, values });
  });
  rows.forEach((row, i) => crossFieldWarnings(def, row, i, issue));
  return { data: { rows, ...note ? { note } : {} }, issues };
}
var n = (v) => typeof v === "number" ? v : null;
function crossFieldWarnings(def, row, i, issue) {
  const v = row.values;
  if (def.fields.some((f) => f.key === "employerCost")) {
    const [cost, gross, net] = [n(v.employerCost), n(v.grossPay), n(v.netPay)];
    if (cost !== null && gross !== null && cost < gross || gross !== null && net !== null && gross < net)
      issue("WARN", "PAYROLL_COST_ORDER", i, row.key, "employerCost");
  }
  if (def.fields.some((f) => f.key === "overdueUpTo30")) {
    const [overdue, a, b] = [n(v.overdue), n(v.overdueUpTo30), n(v.overdueOver30)];
    if (overdue !== null && a !== null && b !== null && Math.abs(a + b - overdue) >= 0.01)
      issue("WARN", "RECEIVABLE_BUCKETS_SUM", i, row.key, "overdue");
    const same = (a2, b2) => a2 !== null && b2 !== null && a2 !== 0 && Math.round(a2 * 100) === Math.round(b2 * 100);
    if (same(n(v.overdue), n(v.weekAgoOverdue)))
      issue("WARN", "RECEIVABLE_WEEK_AGO_COPY", i, row.key, "weekAgoOverdue");
    else if (same(n(v.balance), n(v.weekAgoBalance)))
      issue("WARN", "RECEIVABLE_WEEK_AGO_COPY", i, row.key, "weekAgoBalance");
  }
}
function flattenFormNumbers(def, data) {
  if (!data?.rows.length) return [];
  const rows = [...data.rows].sort(
    (a, b) => `${a.key}|${a.branch ?? ""}`.localeCompare(`${b.key}|${b.branch ?? ""}`)
  );
  return rows.flatMap((r) => def.fields.filter((f) => f.type !== "date").map((f) => n(r.values[f.key])));
}
function formHasValues(data) {
  return !!data?.rows.some((r) => Object.values(r.values).some((v) => v !== null && v !== ""));
}

// src/mbr/close.ts
var MBR_CLOSE_API = "/mbr/close";
var MBR_CLOSE_STATUSES = ["DRAFT", "IN_REVIEW", "CLOSED"];
var MBR_FORM_STATUSES = ["PENDING", "IN_PROGRESS", "SUBMITTED", "APPROVED", "REJECTED"];
var MBR_CLOSE_FORMS = {
  warehouse: { section: "operations" },
  quality: { section: "operations" },
  production: { section: "operations" },
  fleet: { section: "logistics" },
  drivers: { section: "logistics" },
  costs: { section: "finance" },
  hr: { section: "finance" },
  receivables: { section: "finance" },
  collections: { section: "finance" }
};
var MBR_CLOSE_FORM_KEYS = Object.keys(MBR_CLOSE_FORMS);
var MBR_CLOSE_CHECKS = [
  /** Formularze niezatwierdzone przed zamknięciem. */
  "FORMS_NOT_APPROVED",
  /** Formularz po terminie (nieprzekazany). */
  "FORM_OVERDUE",
  /** Sekcja raportu nie policzyła się (błąd) — nie ma jej w uzgodnieniach ani w snapshocie. */
  "SECTION_UNAVAILABLE",
  /** Wartość z Excela różni się od policzonej przez system (np. sprzedaż po korektach Excel vs Subiekt). */
  "IMPORT_VS_SYSTEM",
  /** Suma kontrolna w Excelu (wiersz „suma”, „Łącznie”, „RAZEM”) ≠ suma pozycji. */
  "IMPORT_TOTAL_MISMATCH",
  /** Komórka nie dała się odczytać jako liczba (tekst w polu liczbowym). */
  "IMPORT_CELL_INVALID",
  /** Arkusz lub blok nie został rozpoznany po etykietach. */
  "IMPORT_BLOCK_MISSING"
];
var MBR_CLOSE_ENDPOINTS = {
  state: "",
  // GET ?period=
  open: "/:period/open",
  // POST
  review: "/:period/review",
  // POST
  reconcile: "/:period/reconcile",
  // POST
  freeze: "/:period/freeze",
  // POST MbrFreezeInput
  reopen: "/:period/reopen",
  // POST MbrReopenInput
  form: "/:period/forms/:form",
  // GET detail · PUT MbrFormData
  formSubmit: "/:period/forms/:form/submit",
  // POST
  formApprove: "/:period/forms/:form/approve",
  // POST
  formReject: "/:period/forms/:form/reject",
  // POST { reason }
  formAssign: "/:period/forms/:form/assignment",
  // PATCH MbrFormAssignmentInput
  comments: "/:period/comments",
  // GET · POST MbrCommentInput
  importPreview: "/import/preview",
  // POST multipart file
  importCommit: "/import/commit"
  // POST multipart file + periods
};
var MBR_CLOSE_METRIC_KEYS = {
  sales: [
    "excel.netSales",
    "excel.cogs",
    "excel.corrections",
    "route.<GRUPA>",
    "excel.routesTotal",
    "excel.branchSales"
  ],
  operations: ["complaints.category.<KATEGORIA>", "deliveryDays.typed", "complaints.total"],
  logistics: ["fuelCost", "km", "driverHours", "vehicles"],
  finance: ["excel.fixedCosts", "excel.variableCosts", "excel.payroll"],
  customers: [
    "excel.ordering",
    "excel.lost",
    "excel.won",
    "excel.lostAmount",
    "excel.wonAmount",
    "excel.newByRep",
    "excel.lostByRep"
  ]
};
var MBR_CLOSE_MIN_REASON = 10;

// src/mbr/report.ts
var MBR_REPORT_API = "/mbr/report";
var MBR_REPORT_ENDPOINTS = {
  /** GET ?period — komentarz AI miesiąca (mbr.read + mbr.finance); POST {period} — regeneracja (mbr.close, limity AI). */
  ai: "/mbr/report/ai",
  /** GET ?period&compare&format=PDF|XLSX — plik raportu w zakresie danych użytkownika (mbr.read). */
  export: "/mbr/report/export",
  /** POST {period, test?} — wysyłka do odbiorców z ustawień (tylko CLOSED) albo próbna do siebie (mbr.close). */
  send: "/mbr/report/send",
  /** GET ?period — stan harmonogramu wysyłki (mbr.read). */
  schedule: "/mbr/report/schedule"
};
var MBR_EXPORT_FORMATS = ["PDF", "XLSX"];
var MBR_REPORT_CHECKS = [];
var MBR_DASHBOARD_MAX_TILES = 10;
var MBR_AI_SENTENCES = 5;
var MBR_AI_RECOMMENDATIONS = 3;

// src/mbr/kpi-labels.ts
var MBR_KPI_LABELS_PL = {
  "sales.netSales": "Sprzeda\u017C po korektach",
  "sales.orders": "Zam\xF3wienia",
  "sales.ordersPerDeliveryDay": "Zam\xF3wienia na dzie\u0144 dostaw",
  "sales.grossMarginPct": "Mar\u017Ca brutto",
  "sales.profitPerOrder": "Zysk na zam\xF3wienie",
  "sales.cogs": "Koszt towaru",
  "sales.grossProfit": "Zysk ze sprzeda\u017Cy",
  "sales.corrections": "Korekty",
  "sales.correctionsPct": "Korekty, % sprzeda\u017Cy",
  "sales.operatingResult": "Wynik operacyjny",
  "sales.distanceToBep": "Dystans do progu rentowno\u015Bci",
  "sales.contributionMarginPct": "Mar\u017Ca kontrybucji",
  "sales.bep": "Pr\xF3g rentowno\u015Bci (BEP)",
  "sales.pctAboveBep": "Sprzeda\u017C wzgl\u0119dem progu",
  "customers.ordering": "Klienci zamawiaj\u0105cy",
  "customers.gained": "Pozyskani (nowi + odzyskani)",
  "customers.lost": "Utraceni",
  "customers.balanceMargin": "Bilans zysku brutto",
  "customers.balanceAmount": "Bilans obrotu",
  "customers.gainedAmount": "Obr\xF3t pozyskanych",
  "customers.lostAmount": "Obr\xF3t utraconych",
  "logistics.fuelCost": "Paliwo",
  "logistics.km": "Kilometry",
  "logistics.kmPerOrder": "Km na zam\xF3wienie",
  "logistics.hoursPerOrder": "Godziny kierowc\xF3w na zam\xF3wienie",
  "logistics.costPerKm": "Koszt km (paliwo + najem + nadprzebieg)",
  "logistics.driversOverLimit": "Kierowcy powy\u017Cej progu godzin",
  "logistics.driverHours": "Godziny kierowc\xF3w",
  "logistics.hoursPerDeliveryDay": "Godziny kierowc\xF3w na dzie\u0144 dostaw",
  "logistics.fuelPerKm": "Paliwo na km",
  "logistics.rentCost": "Najem i leasing aut",
  "logistics.excessMileageCost": "Nadprzebieg (naliczenie)",
  "logistics.vehiclesRented": "Auta w najmie",
  "logistics.vehiclesNotRented": "Auta bez najmu",
  "operations.complaints": "Reklamacje",
  "operations.complaintsPctOfOrders": "Reklamacje / zam\xF3wienia",
  "operations.complaintsPerDeliveryDay": "Reklamacje na dzie\u0144 dostaw",
  "operations.complaintsValue": "Warto\u015B\u0107 reklamacji",
  "operations.disposalValue": "Utylizacja",
  "operations.disposalPctOfSales": "Utylizacja / sprzeda\u017C",
  "operations.pickingMinutesPerOrder": "Kompletacja \u2014 min na zam\xF3wienie",
  "operations.orders": "Zam\xF3wienia",
  "operations.ordersPerDeliveryDay": "Zam\xF3wienia na dzie\u0144 dostaw",
  "operations.pickingHours": "Godziny kompletacji",
  "operations.pickingHoursPerDeliveryDay": "Godziny kompletacji na dzie\u0144 dostaw",
  "operations.orderLines": "Pozycje w zam\xF3wieniach",
  "operations.pickingMinutesPerLine": "Kompletacja \u2014 min na pozycj\u0119",
  "operations.linesPerOrder": "Pozycje na zam\xF3wienie",
  "operations.inventoryBalance": "Inwentaryzacja \u2014 saldo",
  "operations.productionSales": "Produkcja \u2014 sprzeda\u017C wyrob\xF3w",
  "operations.productionCost": "Produkcja \u2014 koszt wyrob\xF3w",
  "finance.fixedCosts": "Koszty sta\u0142e bez wynagrodze\u0144",
  "finance.variableCosts": "Koszty zmienne bez wynagrodze\u0144",
  "finance.payroll": "Wynagrodzenia",
  "finance.payrollPerSalesPln": "Wynagrodzenia na 1 z\u0142 sprzeda\u017Cy",
  "finance.receivablesOverdue": "Nale\u017Cno\u015Bci przeterminowane",
  "finance.collectionsAmount": "Windykacja \u2014 kwota w kancelarii",
  "finance.totalCosts": "Koszty razem",
  "finance.headcount": "Liczba os\xF3b",
  "finance.employerCost": "Koszt pracodawcy (kadry)",
  "finance.erpOverdue": "Przeterminowane w Subiekcie",
  "finance.erpCei": "Skuteczno\u015B\u0107 windykacji (CEI)"
};

// src/mbr/index.ts
var MBR_API = "/mbr";

// src/insurance/common.ts
var INSURANCE_API = "/insurance";
var INSURANCE_LINES = ["OC", "AC", "NNW", "ASS", "SZYBY", "CARGO", "OCP"];
var INSURANCE_IMPORT_STATUSES = ["PREVIEW", "APPLIED", "DISCARDED"];
var CLAIM_PATHS = ["OC_OWN", "AC_OWN", "OC_THIRD_PARTY", "CARGO", "OWN_COST"];
var CLAIM_STAGES = ["QUALIFICATION", "REPORTED", "ADJUSTMENT", "DECISION", "SETTLEMENT", "CLOSED"];
var CLAIM_DECISIONS = ["ACCEPTED", "PARTIAL", "REJECTED", "APPEALED"];
var CLAIM_SOURCE_TYPES = ["FLEET_INCIDENT", "MANUAL"];
var CLAIM_SOURCE_DECISIONS = ["PENDING", "CLAIM", "ATTACHED", "NO_CLAIM"];
var CLAIM_PAYMENT_DIRECTIONS = ["IN", "OUT"];
var CLAIM_PAYMENT_KINDS = ["INDEMNITY", "RECOURSE", "OWN_SHARE", "REPAIR", "TOWING", "DOWNTIME", "CARGO", "OTHER"];
var CLAIM_EVENT_TYPES = ["STAGE", "NOTE", "LETTER", "DOCUMENT", "AMOUNT", "DEADLINE", "SOURCE", "SYSTEM"];
var TENDER_STATUSES = ["PREPARATION", "SENT", "QUESTIONS", "OFFERS_RECEIVED", "EVALUATION", "NEGOTIATION", "AWARDED", "CONTRACT_SIGNED", "CANCELLED"];
var TENDER_PROCEDURE_TYPES = ["BROKER", "DIRECT", "RENEWAL"];
var INSURANCE_ATTACHMENT_TYPES = ["INSURANCE_CONTRACT", "INSURANCE_POLICY", "INSURANCE_CLAIM", "INSURANCE_TENDER"];
var INSURANCE_SETTING_KEYS = {
  deadlines: "claims.deadlines",
  queue: "claims.queue",
  downtimeRates: "claims.downtimeRates",
  policyAlerts: "policies.alerts",
  thresholds: "analytics.thresholds"
};
var INSURANCE_SETTINGS_DEFAULTS = {
  deadlines: { reportDays: 7, decisionDays: 30, appealDays: 30, recourseYears: 3 },
  queue: { startDate: null, incidentTypes: ["COLLISION", "DAMAGE"] },
  downtimeRates: { PASSENGER_CAR: 250, VAN: 600, TRUCK: 1e3, REFRIGERATED_VAN: 800, REFRIGERATED_TRUCK: 1200, TRAILER: 300, OTHER: 300 },
  policyAlerts: { expiringDays: 30 },
  thresholds: { lossRatioWarn: 0.6, lossRatioCritical: 0.8, frequencyWarn: 0.5 }
};

// src/insurance/policies.ts
var POLICY_TABS = ["all", "oc", "ocac", "cargo", "expiring", "novehicle"];
var POLICY_STATUS_FILTERS = ["active", "expired", "all"];
var POLICY_SORT_KEYS = ["plate", "vehicleLabel", "policyNumber", "insurerName", "lines", "acSumInsured", "premiumTotal", "endDate", "claims12m"];
var IMPORT_WARNING_KINDS = [
  "MODEL_NO_BRAND",
  "NUMERIC_DATE",
  "EMPTY_COLUMN",
  "BAD_AMOUNT",
  "BAD_DATE",
  "MISSING_REGISTRATION",
  "DUPLICATE_POLICY",
  "UNKNOWN_COLUMNS",
  "TOTAL_MISMATCH",
  "NO_LINES",
  "NO_VEHICLE",
  "MATCHED_BY_VIN",
  "VIN_MISMATCH",
  "VEHICLE_WITHOUT_POLICY",
  "MISSING_IN_FILE"
];

// src/insurance/claims.ts
var QUEUE_TABS = ["pending", "decided", "no_claim"];
var CLAIM_SUGGESTION_REASONS = ["CARGO", "OWN_FAULT", "THIRD_PARTY", "UNKNOWN_PERPETRATOR", "AC_POLICY", "NO_AC", "MANUAL"];
var CLAIM_LETTER_TYPES = ["REPORT", "REMINDER", "APPEAL", "RECOURSE"];
var CLAIM_DEADLINE_KINDS = ["REPORT", "DECISION", "APPEAL", "RECOURSE"];
var CLAIMS_VIEWS = ["board", "list", "map"];
var CLAIM_SORT_FIELDS = ["occurredAt", "claimNumber", "stage", "claimedAmount", "paidAmount", "decisionDueAt", "updatedAt"];

// src/insurance/tenders.ts
var TENDER_STATUS_TRANSITIONS = {
  PREPARATION: ["SENT", "CANCELLED"],
  SENT: ["PREPARATION", "QUESTIONS", "OFFERS_RECEIVED", "CANCELLED"],
  QUESTIONS: ["SENT", "OFFERS_RECEIVED", "CANCELLED"],
  OFFERS_RECEIVED: ["QUESTIONS", "EVALUATION", "NEGOTIATION", "CANCELLED"],
  EVALUATION: ["OFFERS_RECEIVED", "NEGOTIATION", "AWARDED", "CANCELLED"],
  NEGOTIATION: ["EVALUATION", "AWARDED", "CANCELLED"],
  AWARDED: ["EVALUATION", "NEGOTIATION", "CONTRACT_SIGNED", "CANCELLED"],
  CONTRACT_SIGNED: [],
  CANCELLED: ["PREPARATION"]
};
var TENDER_ACTION_STATUSES = ["AWARDED", "CONTRACT_SIGNED"];
var TENDER_STATUS_FLOW = [
  "PREPARATION",
  "SENT",
  "QUESTIONS",
  "OFFERS_RECEIVED",
  "EVALUATION",
  "NEGOTIATION",
  "AWARDED",
  "CONTRACT_SIGNED"
];
var TENDER_AWARDABLE_STATUSES = ["OFFERS_RECEIVED", "EVALUATION", "NEGOTIATION", "AWARDED"];
var TENDER_LOCKED_STATUSES = ["CONTRACT_SIGNED", "CANCELLED"];
var TENDER_BUILTIN_CRITERIA = ["price", "clauses", "terms"];
var TENDER_DEFAULT_CRITERIA = [
  { key: "price", label: "Cena", weight: 60 },
  { key: "clauses", label: "Klauzule fakultatywne", weight: 30 },
  { key: "terms", label: "Warunki likwidacji (franszyza, udzia\u0142 w\u0142asny)", weight: 10 }
];
var TENDER_CLAUSE_LIBRARY = [
  { id: "NO_DEPRECIATION", label: "Brak amortyzacji cz\u0119\u015Bci w AC", points: 6, relevantFor: ["AC_OWN"] },
  { id: "ZERO_DEDUCTIBLE", label: "Zniesienie franszyzy integralnej i udzia\u0142u w\u0142asnego", points: 8, relevantFor: ["AC_OWN", "CARGO"] },
  { id: "SERVICE_VARIANT", label: "Wariant serwisowy (ASO)", points: 5, relevantFor: ["AC_OWN"] },
  { id: "SUM_PROTECTION", label: "Ochrona sumy ubezpieczenia (bez konsumpcji)", points: 4, relevantFor: ["AC_OWN"] },
  { id: "REFRIGERATION_UNIT", label: "Agregat ch\u0142odniczy w zakresie AC (awaria i uszkodzenie)", points: 6, relevantFor: ["AC_OWN", "CARGO"] },
  { id: "CARGO_SPOILAGE", label: "Zepsucie towaru po awarii ch\u0142odzenia", points: 6, relevantFor: ["CARGO"] },
  { id: "REPLACEMENT_VEH", label: "Pojazd zast\u0119pczy tej samej klasy (tak\u017Ce ch\u0142odnia)", points: 5, relevantFor: ["AC_OWN", "OC_THIRD_PARTY"] },
  { id: "TOWING_NO_LIMIT", label: "Holowanie bez limitu kilometr\xF3w w kraju", points: 3, relevantFor: ["AC_OWN", "OC_THIRD_PARTY"] },
  { id: "CLAIM_SLA_14", label: "Decyzja w 14 dni od zg\u0142oszenia", points: 4, relevantFor: ["OC_OWN", "AC_OWN", "CARGO"] },
  { id: "GLASS_NO_SHARE", label: "Szyby bez udzia\u0142u w\u0142asnego", points: 3, relevantFor: ["AC_OWN", "OWN_COST"] },
  { id: "NEW_VEHICLES_AUTO", label: "Automatyczne obj\u0119cie nowych pojazd\xF3w ochron\u0105", points: 5, relevantFor: [] },
  { id: "PRO_RATA_REFUND", label: "Zwrot sk\u0142adki co do dnia za wycofany pojazd", points: 3, relevantFor: [] }
];
var TENDER_STAGE_LABELS = {
  scope: "Zakres i dane floty",
  sent: "Wys\u0142anie zapytania",
  questions: "Pytania ubezpieczycieli",
  offers: "Termin sk\u0142adania ofert",
  evaluation: "Ocena i por\xF3wnanie ofert",
  negotiation: "Negocjacje",
  contract: "Podpisanie umowy",
  policies: "Polisy i import do rejestru"
};
var TENDER_SCHEDULE_TEMPLATES = {
  DIRECT: [
    { key: "scope", daysBeforeStart: 90 },
    { key: "sent", daysBeforeStart: 75 },
    { key: "questions", daysBeforeStart: 60 },
    { key: "offers", daysBeforeStart: 45 },
    { key: "evaluation", daysBeforeStart: 35 },
    { key: "negotiation", daysBeforeStart: 25 },
    { key: "contract", daysBeforeStart: 14 },
    { key: "policies", daysBeforeStart: 3 }
  ],
  BROKER: [
    { key: "scope", daysBeforeStart: 100 },
    { key: "sent", daysBeforeStart: 85 },
    { key: "questions", daysBeforeStart: 70 },
    { key: "offers", daysBeforeStart: 55 },
    { key: "evaluation", daysBeforeStart: 42 },
    { key: "negotiation", daysBeforeStart: 30 },
    { key: "contract", daysBeforeStart: 14 },
    { key: "policies", daysBeforeStart: 3 }
  ],
  RENEWAL: [
    { key: "scope", daysBeforeStart: 60 },
    { key: "sent", daysBeforeStart: 50 },
    { key: "offers", daysBeforeStart: 35 },
    { key: "evaluation", daysBeforeStart: 28 },
    { key: "negotiation", daysBeforeStart: 21 },
    { key: "contract", daysBeforeStart: 10 },
    { key: "policies", daysBeforeStart: 3 }
  ]
};
var TENDER_LOT_GROUPS = ["REFRIGERATED", "DELIVERY", "PASSENGER"];
var TENDER_LOT_GROUP_TYPES = {
  REFRIGERATED: ["REFRIGERATED_VAN", "REFRIGERATED_TRUCK"],
  DELIVERY: ["VAN", "TRUCK", "TRAILER", "OTHER"],
  PASSENGER: ["PASSENGER_CAR"]
};
var TENDER_COMPLIANCE_KINDS = [
  "MISSING_RISK",
  "DEDUCTIBLE_HIGHER",
  "OWN_SHARE_HIGHER",
  "VEHICLE_NOT_COVERED",
  "POLICY_OUTSIDE_LOTS",
  "PREMIUM_MISMATCH",
  "NO_WINNER"
];
var TENDER_LOSS_GROUPS = ["OC", "AC", "CARGO"];
var TENDER_ERROR_CODES = [
  "TENDER_NOT_FOUND",
  "TENDER_LOT_NOT_FOUND",
  "TENDER_QUESTION_NOT_FOUND",
  "TENDER_OFFER_NOT_FOUND",
  "TENDER_STAGE_NOT_FOUND",
  "TENDER_ATTACHMENT_NOT_FOUND",
  "TENDER_CRITERIA_INVALID",
  "TENDER_CRITERIA_SUM",
  "TENDER_SCHEDULE_INVALID",
  "TENDER_TITLE_REQUIRED",
  "TENDER_COVERAGE_INVALID",
  "TENDER_LOT_NAME_REQUIRED",
  "TENDER_TRANSITION_NOT_ALLOWED",
  "TENDER_USE_ACTION",
  "TENDER_NO_LOTS",
  "TENDER_NO_RECIPIENTS",
  "TENDER_NO_OFFERS",
  "TENDER_LOCKED",
  "TENDER_NOT_SENT",
  "TENDER_PREMIUM_INVALID",
  "TENDER_AMOUNT_INVALID",
  "TENDER_WINNER_INVALID",
  "TENDER_WINNER_DUPLICATE_LOT",
  "TENDER_NO_WINNERS",
  "TENDER_NOT_AWARDABLE",
  "TENDER_NOT_AWARDED",
  "TENDER_CONTRACT_NUMBER_REQUIRED",
  "TENDER_CONTRACT_EXISTS",
  "TENDER_VEHICLE_NOT_FOUND",
  "TENDER_QUESTION_REQUIRED",
  "TENDER_BIDDER_REQUIRED"
];

// src/insurance/analytics.ts
var INSURER_CLAIM_PATHS = ["OC_OWN", "AC_OWN", "CARGO"];
var INSURANCE_NONE_KEY = "_none";
var INSURANCE_ANALYTICS_PRESETS = ["12m", "py", "pyprev", "cy"];

// src/erp-sync.ts
var ERP_SYNC_FEEDS = ["customers", "products", "documents", "receivables", "routimo", "reconcile", "ledger-costs", "collections", "cashflow", "purchasing", "quality", "commissions", "consents", "warehouse", "retro", "prices", "leave"];
var ERP_SYNC_RUN_STATUSES = ["RUNNING", "SUCCESS", "PARTIAL", "FAILED", "SKIPPED"];
var ERP_SYNC_TRIGGERS = ["SCHEDULE", "MANUAL", "CLI", "STARTUP", "RETRY"];
function isErpSyncFeed(v) {
  return ERP_SYNC_FEEDS.includes(v);
}
var ERP_OUTBOX_KINDS = ["ORDER", "CUSTOMER"];
var ERP_OUTBOX_STATUSES = ["PENDING", "CLAIMED", "DONE", "FAILED"];

// src/planner/working-time-engine.ts
var MIN_PER_DAY = 24 * 60;
function dayIndex(date) {
  const [y, m, d] = date.split("-").map(Number);
  return Math.floor(Date.UTC(y, (m || 1) - 1, d || 1) / 864e5);
}
function dateFromIndex(idx) {
  const d = new Date(idx * 864e5);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
function round1(n2) {
  return Math.round(n2 * 10) / 10;
}
function toAbs(s) {
  const startAbs = dayIndex(s.date) * MIN_PER_DAY + s.startMin;
  const span = s.endMin > s.startMin ? s.endMin - s.startMin : s.endMin + MIN_PER_DAY - s.startMin;
  return { src: s, startAbs, endAbs: startAbs + span };
}
function effectiveSeverity(ruleId, base, ruleset) {
  const chosen = ruleset.severity?.[ruleId] ?? base;
  return ruleset.enforceBlock ? chosen : "WARN";
}
function evaluateWorkingTime(week, ruleset) {
  const out = [];
  const t = ruleset.thresholds;
  const shifts = (week.shifts || []).filter((s) => s && s.date);
  const abs = shifts.map(toAbs).sort((a, b) => a.startAbs - b.startAbs);
  for (let i = 1; i < abs.length; i++) {
    if (dayIndex(abs[i].src.date) - dayIndex(abs[i - 1].src.date) !== 1) continue;
    const restMin = abs[i].startAbs - abs[i - 1].endAbs;
    if (restMin < 0) continue;
    const restH = restMin / 60;
    if (restH >= t.dailyRestMinH) continue;
    const base = restH < t.dailyRestReducedMinH ? "BLOCK" : "WARN";
    out.push({
      ruleId: "R2",
      severity: effectiveSeverity("R2", base, ruleset),
      scope: "PAIR",
      date: abs[i].src.date,
      messageKey: "wt.r2.dailyRest",
      values: { restH: round1(restH), minH: t.dailyRestMinH }
    });
  }
  const weekStartIdx = dayIndex(week.weekStart);
  const weekEndIdx = weekStartIdx + 6;
  let weeklyMin = 0;
  for (const s of shifts) {
    const di = dayIndex(s.date);
    if (di >= weekStartIdx && di <= weekEndIdx) weeklyMin += s.workMin || 0;
  }
  const weeklyH = weeklyMin / 60;
  if (weeklyH > t.weeklyWorkWarnH) {
    const overBlock = weeklyH > t.weeklyWorkBlockH;
    out.push({
      ruleId: "R4",
      severity: effectiveSeverity("R4", overBlock ? "BLOCK" : "WARN", ruleset),
      scope: "WEEK",
      date: week.weekStart,
      messageKey: overBlock ? "wt.r4.weeklyBlock" : "wt.r4.weeklyWarn",
      values: {
        weeklyH: round1(weeklyH),
        capH: overBlock ? t.weeklyWorkBlockH : t.weeklyWorkWarnH
      }
    });
  }
  const workedDays = Array.from(new Set(shifts.map((s) => dayIndex(s.date)))).sort(
    (a, b) => a - b
  );
  if (workedDays.length) {
    const flagRun = (start, end) => {
      const len = end - start + 1;
      if (len > t.maxConsecutiveDays) {
        out.push({
          ruleId: "R5",
          severity: effectiveSeverity("R5", "WARN", ruleset),
          scope: "STREAK",
          date: dateFromIndex(start + t.maxConsecutiveDays),
          messageKey: "wt.r5.consecutiveDays",
          values: { days: len, maxDays: t.maxConsecutiveDays }
        });
      }
    };
    let runStart = workedDays[0];
    let prev = workedDays[0];
    for (let i = 1; i < workedDays.length; i++) {
      if (workedDays[i] === prev + 1) {
        prev = workedDays[i];
        continue;
      }
      flagRun(runStart, prev);
      runStart = workedDays[i];
      prev = workedDays[i];
    }
    flagRun(runStart, prev);
  }
  return out;
}

// src/planner/common.ts
var PLANNER_SHIFT_TYPES = ["MORNING", "AFTERNOON", "NIGHT", "FULL_DAY"];
var PLANNER_SHIFT_PRESETS = {
  MORNING: { startHour: 6, endHour: 14 },
  AFTERNOON: { startHour: 14, endHour: 22 },
  NIGHT: { startHour: 22, endHour: 30 },
  FULL_DAY: { startHour: 8, endHour: 16 }
};
var PLANNER_SHIFT_STATUSES = ["DRAFT", "CONFIRMED", "IN_PROGRESS", "COMPLETED"];
var PLANNER_TASK_TYPES = ["VISITS", "DELIVERY_ROUTE", "WAREHOUSE", "OFFICE", "TRAINING", "MEETING", "TASK"];
var PLANNER_TASK_PRIORITIES = ["LOW", "MEDIUM", "HIGH"];
var PLANNER_TASK_STATUSES = ["PENDING", "IN_PROGRESS", "DONE", "SKIPPED", "MISSED"];
var PLANNER_SCHEDULING_HINTS = [
  "FIXED_TIME",
  "BEFORE_FIRST_TASK",
  "AFTER_LAST_TASK",
  "RELATIVE_TO_SHIFT_START",
  "RELATIVE_TO_SHIFT_END"
];
var SCHEDULE_REQUEST_TYPES = ["VACATION", "SICK", "BUSINESS_TRIP", "TRAINING_EXT", "SHIFT_SWAP", "AVAILABILITY", "PREFERENCE"];
var SCHEDULE_REQUEST_STATUSES = ["PENDING", "APPROVED", "REJECTED", "CANCELLED"];
var SHIFT_ATTRIBUTE_SOURCES = ["LIST", "VEHICLE", "TEXT"];
var ABSENCE_TYPES = [
  { code: "UW", paid: true },
  { code: "UZ", paid: true },
  { code: "CH", paid: true },
  { code: "OP", paid: true },
  { code: "OK", paid: true },
  { code: "DEL", paid: true },
  { code: "SZK", paid: true },
  { code: "UB", paid: false },
  { code: "NN", paid: false }
];
var ABSENCE_CODE_BY_REQUEST_TYPE = {
  VACATION: "UW",
  SICK: "CH",
  BUSINESS_TRIP: "DEL",
  TRAINING_EXT: "SZK"
};
var PLANNER_TEMPLATE_COLORS = ["slate", "blue", "teal", "green", "amber", "orange", "red", "violet", "pink"];
var WORKING_TIME_BLOCK = "WORKING_TIME_BLOCK";
var PLANNER_CONFLICT_CODES = ["VEHICLE_DOUBLE", "PERSON_OVERLAP", "ABSENCE", "TASK_OUTSIDE_SHIFT"];
var PLANNER_NOTIFICATION_TYPES = {
  /**
   * Nowy wniosek → akceptujący wg `organization.settings.planner.requestApprover`: przełożony wnioskującego (managerId;
   * bez przełożonego — osoby z planner.manage i zakresem ALL), zarząd (rola BOARD) albo jedni i drudzy.
   */
  REQUEST_CREATED: "planner.request_created",
  /** Decyzja (zatwierdzony / odrzucony) → wnioskujący. */
  REQUEST_RESOLVED: "planner.request_resolved",
  /** Anulowanie zatwierdzonego wniosku → osoba, która go zatwierdziła. */
  REQUEST_CANCELLED: "planner.request_cancelled",
  /** Zmiana opublikowana (utworzona jako CONFIRMED albo DRAFT → CONFIRMED) → pracownik. */
  SHIFT_PUBLISHED: "planner.shift_published",
  /** Zmiana w opublikowanej zmianie → pracownik. */
  SHIFT_CHANGED: "planner.shift_changed",
  /** Usunięcie opublikowanej zmiany → pracownik. */
  SHIFT_DELETED: "planner.shift_deleted",
  /** Bulk: jedno zbiorcze powiadomienie na osobę (ile opublikowanych dodano / usunięto). */
  SCHEDULE_UPDATED: "planner.schedule_updated",
  ABSENCE_CREATED: "planner.absence_created",
  ABSENCE_DELETED: "planner.absence_deleted"
};

// src/worktime/engine.ts
var DEFAULT_PARAMS = {
  nightStartHour: 21,
  nightEndHour: 5,
  annualOvertimeLimitH: 150
};
function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = (h + l - 7 * m + 114) % 31 + 1;
  return new Date(Date.UTC(year, month - 1, day));
}
var ymd = (d) => `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
var addDays = (d, n2) => new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + n2));
function polishHolidays(year) {
  const fixed = [
    [1, 1],
    // Nowy Rok
    [1, 6],
    // Trzech Króli
    [5, 1],
    // Święto Pracy
    [5, 3],
    // Święto Konstytucji 3 Maja
    [8, 15],
    // Wniebowzięcie NMP
    [11, 1],
    // Wszystkich Świętych
    [11, 11],
    // Święto Niepodległości
    [12, 25],
    // Boże Narodzenie (1. dzień)
    [12, 26]
    // Boże Narodzenie (2. dzień)
  ];
  if (year >= 2025) fixed.push([12, 24]);
  const set = /* @__PURE__ */ new Set();
  for (const [m, d] of fixed) set.add(ymd(new Date(Date.UTC(year, m - 1, d))));
  const easter = easterSunday(year);
  set.add(ymd(easter));
  set.add(ymd(addDays(easter, 1)));
  set.add(ymd(addDays(easter, 49)));
  set.add(ymd(addDays(easter, 60)));
  return set;
}
function isHoliday(date, holidays) {
  const h = holidays ?? polishHolidays(date.getFullYear());
  const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  return h.has(key);
}
var isSunday = (date) => date.getDay() === 0;
function parseEtat(etat) {
  if (!etat) return 1;
  const s = etat.trim();
  if (s.includes("/")) {
    const [n2, d] = s.split("/").map((x) => Number(x.trim()));
    if (d) return n2 / d;
  }
  const v = Number(s.replace(",", "."));
  return Number.isFinite(v) && v > 0 ? v : 1;
}
var r2 = (n2) => Math.round(n2 * 100) / 100;
function computeNominal(start, end, etatMultiplier = 1) {
  const s = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const e = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  if (e < s) return 0;
  const totalDays = Math.round((e.getTime() - s.getTime()) / 864e5) + 1;
  const fullWeeks = Math.floor(totalDays / 7);
  const leftoverDays = totalDays - fullWeeks * 7;
  let leftoverWeekdays = 0;
  const tailStart = addLocalDays(s, fullWeeks * 7);
  for (let i = 0; i < leftoverDays; i++) {
    const d = addLocalDays(tailStart, i);
    const dow = d.getDay();
    if (dow >= 1 && dow <= 5) leftoverWeekdays++;
  }
  let holidayReduction = 0;
  const yearsSpanned = /* @__PURE__ */ new Set();
  for (let y = s.getFullYear(); y <= e.getFullYear(); y++) yearsSpanned.add(y);
  const holidaySets = /* @__PURE__ */ new Map();
  yearsSpanned.forEach((y) => holidaySets.set(y, polishHolidays(y)));
  for (let d = new Date(s); d <= e; d = addLocalDays(d, 1)) {
    if (isSunday(d)) continue;
    const set = holidaySets.get(d.getFullYear());
    if (set && isHolidayLocal(d, set)) holidayReduction += 1;
  }
  const baseHours = 40 * fullWeeks + 8 * leftoverWeekdays - 8 * holidayReduction;
  return r2(Math.max(0, baseHours) * etatMultiplier);
}
function addLocalDays(d, n2) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n2);
}
function isHolidayLocal(d, set) {
  const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  return set.has(key);
}
function computeDay(input, params = DEFAULT_PARAMS) {
  const { date, execFrom, execTo, dailyNormH, isScheduledFree, absenceCode, onCallMinutes } = input;
  const sunday = isSunday(date);
  const holiday = isHoliday(date);
  if (absenceCode) {
    return {
      dayCode: "ABSENCE",
      worked: 0,
      overtime50: 0,
      overtime100: 0,
      night: 0,
      sundayHoliday: 0,
      onCall: r2(onCallMinutes / 60),
      absenceH: r2(dailyNormH)
    };
  }
  let dayCode = "WORK";
  if (holiday) dayCode = "HOLIDAY";
  else if (sunday) dayCode = "SUNDAY";
  else if (isScheduledFree) dayCode = "FREE";
  if (execFrom == null || execTo == null || execTo <= execFrom) {
    return {
      dayCode,
      worked: 0,
      overtime50: 0,
      overtime100: 0,
      night: 0,
      sundayHoliday: 0,
      onCall: r2(onCallMinutes / 60),
      absenceH: 0
    };
  }
  const workedMin = execTo - execFrom;
  const workedH = workedMin / 60;
  const nightMin = nightMinutes(execFrom, execTo, params.nightStartHour, params.nightEndHour);
  const nightH = nightMin / 60;
  const isFullySupplemented100 = sunday || holiday || dayCode === "FREE";
  let overtime100 = 0;
  let overtime50 = 0;
  let sundayHoliday = 0;
  if (isFullySupplemented100) {
    overtime100 = r2(workedH);
    if (sunday || holiday) sundayHoliday = r2(workedH);
  } else {
    overtime100 = r2(nightH);
    const overNorm = Math.max(0, workedH - dailyNormH);
    const nonNightOverNorm = Math.max(0, overNorm - nightH);
    overtime50 = r2(nonNightOverNorm);
  }
  return {
    dayCode,
    worked: r2(workedH),
    overtime50,
    overtime100,
    night: r2(nightH),
    sundayHoliday,
    onCall: r2(onCallMinutes / 60),
    absenceH: 0
  };
}
function nightMinutes(from, to, nightStartHour, nightEndHour) {
  const ns = nightStartHour * 60;
  const ne = nightEndHour * 60;
  let count = 0;
  for (let m = from; m < to; m++) {
    const minuteOfDay = (m % 1440 + 1440) % 1440;
    const inNight = nightStartHour <= nightEndHour ? minuteOfDay >= ns && minuteOfDay < ne : minuteOfDay >= ns || minuteOfDay < ne;
    if (inNight) count++;
  }
  return count;
}
function summarizePeriod(days, rangeStart, rangeEnd, etatMultiplier, params = DEFAULT_PARAMS, carryBalanceH = 0) {
  const sum = (sel) => r2(days.reduce((a, d) => a + sel(d), 0));
  const workedH = sum((d) => d.worked);
  const overtime50H = sum((d) => d.overtime50);
  const overtime100H = sum((d) => d.overtime100);
  const nightH = sum((d) => d.night);
  const sundayHolidayH = sum((d) => d.sundayHoliday);
  const onCallH = sum((d) => d.onCall);
  const absenceH = sum((d) => d.absenceH);
  const rawNominalH = computeNominal(rangeStart, rangeEnd, etatMultiplier);
  const nominalH = r2(Math.max(0, rawNominalH - absenceH));
  const overtimeTotalH = r2(overtime50H + overtime100H);
  const balanceH = r2(workedH - nominalH + carryBalanceH);
  const overtimeLimitPct = params.annualOvertimeLimitH > 0 ? r2(overtimeTotalH / params.annualOvertimeLimitH * 100) : 0;
  return {
    nominalH,
    rawNominalH,
    workedH,
    overtime50H,
    overtime100H,
    nightH,
    sundayHolidayH,
    onCallH,
    absenceH,
    balanceH,
    overtimeTotalH,
    annualOvertimeLimitH: params.annualOvertimeLimitH,
    overtimeLimitPct
  };
}
function detectAlerts(days, summary) {
  const alerts = [];
  const dayKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const sorted = [...days].sort((a, b) => a.date.getTime() - b.date.getTime());
  for (let i = 0; i < sorted.length - 1; i++) {
    const cur = sorted[i];
    const nxt = sorted[i + 1];
    if (cur.execTo == null || nxt.execFrom == null) continue;
    const consecutive = Math.round((nxt.date.getTime() - cur.date.getTime()) / 864e5) === 1;
    if (!consecutive) continue;
    const restMin = 1440 - Math.min(1440, cur.execTo) + Math.max(0, nxt.execFrom);
    if (restMin < 11 * 60) {
      alerts.push({
        date: dayKey(nxt.date),
        code: "REST_DAILY",
        severity: "warn",
        messageKey: "restDaily",
        values: { hours: Math.floor(restMin / 60), minutes: restMin % 60 }
      });
    }
  }
  const byWeek = /* @__PURE__ */ new Map();
  for (const d of sorted) {
    const k = isoWeekKey(d.date);
    if (!byWeek.has(k)) byWeek.set(k, []);
    byWeek.get(k).push(d);
  }
  for (const [wk, wdays] of byWeek) {
    const workedDays = wdays.filter((d) => d.workedH > 0).length;
    if (workedDays >= 7) {
      alerts.push({
        date: "",
        code: "REST_WEEKLY",
        severity: "warn",
        messageKey: "restWeekly",
        values: { week: wk }
      });
    }
    const sundayHolidayWork = wdays.some((d) => (d.dayCode === "SUNDAY" || d.dayCode === "HOLIDAY") && d.workedH > 0);
    const hasFreeDay = wdays.some((d) => d.workedH === 0 && d.dayCode !== "ABSENCE");
    if (sundayHolidayWork && !hasFreeDay && wdays.length >= 6) {
      alerts.push({
        date: "",
        code: "SUNDAY_HOLIDAY_NO_OFF",
        severity: "warn",
        messageKey: "sundayHolidayNoOff",
        values: { week: wk }
      });
    }
  }
  if (summary.overtimeTotalH > summary.annualOvertimeLimitH) {
    alerts.push({
      date: "",
      code: "OVERTIME_LIMIT",
      severity: "critical",
      messageKey: "overtimeLimitExceeded",
      values: { overtimeH: summary.overtimeTotalH, limitH: summary.annualOvertimeLimitH }
    });
  } else if (summary.overtimeLimitPct >= 80) {
    alerts.push({
      date: "",
      code: "OVERTIME_LIMIT",
      severity: "warn",
      messageKey: "overtimeLimitNear",
      values: { pct: summary.overtimeLimitPct, overtimeH: summary.overtimeTotalH, limitH: summary.annualOvertimeLimitH }
    });
  }
  return alerts;
}
function isoWeekKey(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = (d.getUTCDay() + 6) % 7;
  d.setUTCDate(d.getUTCDate() - dayNum + 3);
  const firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
  const week = 1 + Math.round(((d.getTime() - firstThursday.getTime()) / 864e5 - 3 + (firstThursday.getUTCDay() + 6) % 7) / 7);
  return `${d.getUTCFullYear()}-W${String(week).padStart(2, "0")}`;
}

// src/planner/vacation.ts
var ymdUtc = (d) => `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
var parse = (ymd2) => /* @__PURE__ */ new Date(`${ymd2.slice(0, 10)}T00:00:00Z`);
var VACATION_ABSENCE_CODES = ["UW", "UZ"];
var VACATION_STATUTORY_DAYS = [20, 26];
var VACATION_OVER_LIMIT_MODES = ["WARN", "BLOCK"];
var VACATION_API = {
  balance: "/planner/vacation/balance",
  entitlements: "/planner/vacation/entitlements"
};
var VACATION_ENTITLEMENT_SOURCES = ["MANUAL", "ERP", "DEFAULT"];
var VACATION_DAY_MINUTES = 480;
var round1v = (n2) => Math.round(n2 * 10) / 10;
function computeVacationBalance(i) {
  const inYear = (d) => Number(d.slice(0, 4)) === i.year && isWorkingDay(d);
  const nexops = new Set([...i.nexopsDays].filter(inYear));
  const erp = new Set([...i.erpDays].filter(inYear));
  const both = [...erp].filter((d) => nexops.has(d)).length;
  const used = /* @__PURE__ */ new Set([...nexops, ...erp]);
  const planned = new Set([...i.pendingDays].filter((d) => inYear(d) && !used.has(d)));
  const source = i.manual ? "MANUAL" : i.erp ? "ERP" : "DEFAULT";
  const entitlementDays = i.manual ? i.manual.entitlementDays : i.erp ? round1v(i.erp.entitlementMinutes / VACATION_DAY_MINUTES) : i.defaultDays;
  const carriedOverDays = i.manual ? i.manual.carriedOverDays : i.erp ? round1v(i.erp.carriedOverMinutes / VACATION_DAY_MINUTES) : 0;
  const norm2 = i.dailyNormMinutes && i.dailyNormMinutes > 0 ? i.dailyNormMinutes : VACATION_DAY_MINUTES;
  const poolMinutes = i.manual ? (i.manual.entitlementDays + i.manual.carriedOverDays) * VACATION_DAY_MINUTES : i.erp ? i.erp.entitlementMinutes + i.erp.carriedOverMinutes : i.defaultDays * VACATION_DAY_MINUTES;
  const remainingMinutes = poolMinutes - (used.size + planned.size) * norm2;
  return {
    userId: i.userId,
    year: i.year,
    entitlementDays,
    carriedOverDays,
    isDefault: source === "DEFAULT",
    entitlementSource: source,
    usedDays: used.size,
    usedBySource: { erp: erp.size - both, nexops: nexops.size - both, both },
    plannedDays: planned.size,
    remainingDays: round1v(remainingMinutes / norm2),
    remainingHours: round1v(remainingMinutes / 60),
    dailyNormMinutes: norm2
  };
}
function workingDaysOf(from, to, year) {
  const out = [];
  let d = parse(from);
  const end = parse(to || from);
  for (let guard = 0; d <= end && guard < 3700; guard++) {
    const ymd2 = ymdUtc(d);
    if ((year === void 0 || d.getUTCFullYear() === year) && isWorkingDay(ymd2)) out.push(ymd2);
    d = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + 1));
  }
  return out;
}
function isWorkingDay(ymd2) {
  const d = parse(ymd2);
  const dow = d.getUTCDay();
  return dow !== 0 && dow !== 6 && !polishHolidays(d.getUTCFullYear()).has(ymdUtc(d));
}
function countWorkingDays(from, to, year) {
  let d = parse(from);
  const end = parse(to || from);
  let n2 = 0;
  const holidays = /* @__PURE__ */ new Map();
  for (let guard = 0; d <= end && guard < 3700; guard++) {
    const y = d.getUTCFullYear();
    if (year === void 0 || y === year) {
      const dow = d.getUTCDay();
      if (!holidays.has(y)) holidays.set(y, polishHolidays(y));
      if (dow !== 0 && dow !== 6 && !holidays.get(y).has(ymdUtc(d))) n2++;
    }
    d = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + 1));
  }
  return n2;
}
var remainingAfter = (b, extraDays) => b.remainingDays - extraDays;
function formatVacationDays(n2, locale = "pl-PL") {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(n2);
}

// src/planner/org-settings.ts
var PLANNER_REQUEST_APPROVERS = ["MANAGER", "BOARD", "MANAGER_OR_BOARD"];
var PLANNER_ORG_SETTINGS_API = "/organization/settings/planner";
function requestApproverPaths(approver) {
  return { manager: approver !== "BOARD", board: approver !== "MANAGER" };
}
var REQUEST_ADMIN_ROLE = "ADMIN";
function decidesAsAdmin(actor, requesterId) {
  return actor.role === REQUEST_ADMIN_ROLE && actor.id !== requesterId;
}
var PLANNER_ORG_SETTINGS_DEFAULT = {
  requestApprover: "MANAGER",
  disabledRequestTypes: [],
  disabledAbsenceCodes: [],
  vacationDaysDefault: 26,
  vacationOverLimit: "WARN"
};
var VACATION_DAYS_MAX = 60;
function disabledRequestTypesOf(s) {
  return SCHEDULE_REQUEST_TYPES.filter((t) => {
    const code = ABSENCE_CODE_BY_REQUEST_TYPE[t];
    return s.disabledRequestTypes.includes(t) || !!code && s.disabledAbsenceCodes.includes(code);
  });
}
function availableRequestTypes(s) {
  const off = disabledRequestTypesOf(s);
  return SCHEDULE_REQUEST_TYPES.filter((t) => !off.includes(t));
}
function availableAbsenceCodes(s) {
  return ABSENCE_TYPES.map((a) => a.code).filter((c) => !s.disabledAbsenceCodes.includes(c));
}
var isRequestApprover = (v) => typeof v === "string" && PLANNER_REQUEST_APPROVERS.includes(v);
var isScheduleRequestType = (v) => typeof v === "string" && SCHEDULE_REQUEST_TYPES.includes(v);
var isAbsenceCode = (v) => typeof v === "string" && ABSENCE_TYPES.some((a) => a.code === v);
var isVacationOverLimitMode = (v) => typeof v === "string" && VACATION_OVER_LIMIT_MODES.includes(v);
var isVacationDays = (v) => typeof v === "number" && Number.isFinite(v) && v >= 0 && v <= VACATION_DAYS_MAX && Math.round(v * 10) === v * 10;

// src/worktime/contracts.ts
var WORKTIME_SYSTEMS = ["BASIC", "EQUIVALENT", "TASK_BASED"];
var SETTLEMENT_PERIOD_STATUSES = ["OPEN", "CLOSED"];
var TIME_ENTRY_SOURCES = ["PLAN", "MANUAL", "APP_CLOCK", "VISIT", "LOGBOOK"];
var TIME_ENTRY_SOURCE_PRIORITY = { MANUAL: 4, APP_CLOCK: 3, VISIT: 2, LOGBOOK: 2, PLAN: 1 };
var TIME_ENTRY_STATUSES = ["DRAFT", "OPEN", "CONFIRMED"];
var WORKTIME_MAX_OPEN_HOURS = 16;
var WORKTIME_ERROR_CODES = [
  "ALREADY_CLOCKED_IN",
  "MANUAL_ENTRY",
  "NOT_CLOCKED_IN",
  "OPEN_TOO_LONG",
  "PERIOD_CLOSED",
  "OCCURRED_AT_FUTURE",
  "OCCURRED_AT_TOO_OLD",
  "CLOCK_REPLAY_FOREIGN",
  "REASON_REQUIRED",
  "INVALID_RANGE",
  "INVALID_ABSENCE",
  "USER_NOT_FOUND",
  "ENTRY_NOT_FOUND",
  "PERIOD_NOT_FOUND"
];

// src/customer-lifecycle.ts
var CUSTOMER_LOST_AFTER_DAYS_DEFAULT = 120;
var CUSTOMER_LOST_AFTER_DAYS_MIN = 7;
var CUSTOMER_LOST_AFTER_DAYS_MAX = 365;
var CUSTOMER_LIFECYCLE_API = "/organization/settings/customer-lifecycle";
var isValidLostAfterDays = (v) => Number.isInteger(v) && v >= CUSTOMER_LOST_AFTER_DAYS_MIN && v <= CUSTOMER_LOST_AFTER_DAYS_MAX;
function customerStatusRules(lostAfterDays = CUSTOMER_LOST_AFTER_DAYS_DEFAULT) {
  const lost = isValidLostAfterDays(lostAfterDays) ? lostAfterDays : CUSTOMER_LOST_AFTER_DAYS_DEFAULT;
  return {
    newDays: 30,
    activeDays: Math.min(60, Math.floor(lost / 2)),
    inactiveDays: lost,
    recoveredWindowDays: Math.min(45, lost)
  };
}

// src/costs.ts
var COST_DEPARTMENTS = [
  "WAREHOUSE",
  "LOGISTICS",
  "PRODUCTION",
  "CUSTOMER_SERVICE",
  "ACCOUNTING",
  "HR",
  "MANAGEMENT",
  "PURCHASING",
  "MARKETING",
  "SORTING",
  "QUALITY",
  "COMPLAINTS",
  "SALES"
];
var COST_DEPARTMENT_BUCKETS = ["UNASSIGNED", "UNALLOCATED"];
var DEFAULT_COST_CENTRE_DEPARTMENTS = {
  // Magazyn (dzień i noc razem)
  "521-5100": "WAREHOUSE",
  "521-5101": "WAREHOUSE",
  "521-5201": "WAREHOUSE",
  "521-5301": "WAREHOUSE",
  "521-5401": "WAREHOUSE",
  "521-5601": "WAREHOUSE",
  // Logistyka (transport)
  "521-5103": "LOGISTICS",
  "521-5104": "LOGISTICS",
  "521-5203": "LOGISTICS",
  "521-5603": "LOGISTICS",
  // Produkcja
  "521-5102": "PRODUCTION",
  "521-5202": "PRODUCTION",
  "521-5501": "PRODUCTION",
  "521-5602": "PRODUCTION",
  // BOK
  "513-3100": "CUSTOMER_SERVICE",
  "513-3200": "CUSTOMER_SERVICE",
  "513-3300": "CUSTOMER_SERVICE",
  "527-4101": "CUSTOMER_SERVICE",
  "550-1103": "CUSTOMER_SERVICE",
  // Księgowość, kadry, marketing
  "550-1101": "ACCOUNTING",
  "550-1002": "HR",
  "550-1003": "MARKETING",
  // Zarząd (z sekretariatem, oddziałem Olsztyn i kosztami ogólnymi)
  "550-1000": "MANAGEMENT",
  "550-1001": "MANAGEMENT",
  "550-1004": "MANAGEMENT",
  "550-1102": "MANAGEMENT",
  "550-1203": "MANAGEMENT",
  "529-7100": "MANAGEMENT",
  "529-7200": "MANAGEMENT",
  // Zakupy i dział jakości
  "523-2101": "PURCHASING",
  "523-2103": "PURCHASING",
  "523-2303": "PURCHASING",
  "523-2102": "QUALITY",
  // Dział handlowy (przedstawiciele, dyrektor, detal)
  "527-4100": "SALES",
  "527-4200": "SALES",
  "527-4201": "SALES",
  "527-4300": "SALES",
  "527-4301": "SALES"
};
var COST_CENTRE_PATTERN = /^5\d{2}(-\d{1,8})?$/;
function departmentOfCentre(centre, map) {
  const own = map?.[centre];
  if (own === "UNASSIGNED") return "UNASSIGNED";
  if (own && COST_DEPARTMENTS.includes(own)) return own;
  return DEFAULT_COST_CENTRE_DEPARTMENTS[centre] ?? "UNASSIGNED";
}
var EXTERNAL_LABOR_KINDS = ["AGENCY", "B2B"];
var FLEET_COST_KINDS = ["FUEL", "RENT_LEASE", "DEPRECIATION", "REPAIRS", "WASH_TOLLS", "INSURANCE", "OTHER"];
var FLEET_LEDGER_GROUPS = ["505", "506", "507", "508", "509"];

// src/collections.ts
var COLLECTION_BUCKETS = ["d0_30", "d31_60", "d61_90", "d90plus"];
var COLLECTION_PATH_STAGES = ["NONE", "EMAIL", "PHONE", "URGE1", "URGE2", "URGE3", "DEMAND", "FINAL_DEMAND", "AGENCY", "COURT"];
var COLLECTION_ACTION_KINDS = ["PHONE", "URGE1", "URGE2", "URGE3", "DEMAND", "FINAL_DEMAND", "AGENCY", "COURT", "INTEREST_NOTE", "OTHER"];
var COLLECTION_CASE_KINDS = ["AGENCY", "COURT"];
var COLLECTION_CASE_STATUSES = ["HANDED_OVER", "IN_PROGRESS", "IN_COURT", "ENFORCEMENT", "SETTLED", "CLOSED", "WRITTEN_OFF"];
var CLOSED_CASE_STATUSES = ["SETTLED", "CLOSED", "WRITTEN_OFF"];
var FACTORING_STATUSES = ["FINANCED", "SETTLED", "REJECTED"];

// src/cashflow.ts
var CASHFLOW_CATEGORIES = ["CUSTOMERS", "SUPPLIERS", "WAGES", "TAXES", "OTHER", "TRANSFER"];
var CASHFLOW_FLOW_CATEGORIES = ["CUSTOMERS", "SUPPLIERS", "WAGES", "TAXES", "OTHER"];
var CASHFLOW_DOUBTFUL_AFTER_DAYS = 90;

// src/purchasing.ts
var PURCHASE_DOCUMENT_TYPES = ["FZ", "KFZ", "PZ", "ZD"];
var TO_ORDER_HORIZONS = [7, 14, 30];

// src/demand-forecast-scenario.ts
var DEMAND_SCENARIO_NO_GROUP = "_none";
var DEMAND_SCENARIO_RANGE = { min: -50, max: 100 };
var EMPTY_DEMAND_SCENARIO = { allPct: 0, groups: {} };
var clamp = (v) => Math.max(DEMAND_SCENARIO_RANGE.min, Math.min(DEMAND_SCENARIO_RANGE.max, Math.round(v)));
var groupKey = (groupId) => groupId ?? DEMAND_SCENARIO_NO_GROUP;
function isScenarioActive(s) {
  return !!s && (s.allPct !== 0 || Object.values(s.groups).some((v) => v !== 0));
}
function scenarioFactor(s, groupId) {
  return (1 + s.allPct / 100) * (1 + (s.groups[groupKey(groupId)] ?? 0) / 100);
}
function scaleMonth(value, factor, delivered = 0) {
  const done = Math.max(0, Math.min(delivered, value));
  return done + (value - done) * factor;
}
function applyScenarioToRow(r, s, current) {
  const k = scenarioFactor(s, r.groupId);
  if (k === 1) return r;
  const forecast = r.forecast.map(
    (q, i) => Math.round(scaleMonth(q, k, i === 0 && current ? r.monthToDate : 0) * 10) / 10
  );
  const forecastNet = forecast.map(
    (q, i) => r.forecast[i] ? Math.round((r.forecastNet[i] ?? 0) * q * 100 / r.forecast[i]) / 100 : 0
  );
  return { ...r, forecast, forecastNet };
}
function encodeScenario(s) {
  const parts = [
    ...s.allPct ? [`all:${clamp(s.allPct)}`] : [],
    ...Object.entries(s.groups).filter(([, v]) => v).map(([g, v]) => `${g}:${clamp(v)}`)
  ];
  return parts.length ? parts.join(",") : void 0;
}
function parseScenario(text) {
  const s = { allPct: 0, groups: {} };
  for (const part of (text ?? "").split(",")) {
    const m = /^([A-Za-z0-9_-]{1,64}):(-?\d{1,3})$/.exec(part.trim());
    if (!m) continue;
    const v = clamp(Number(m[2]));
    if (m[1] === "all") s.allPct = v;
    else if (v) s.groups[m[1]] = v;
  }
  return s;
}
var DEMAND_SCENARIO_PATTERN = /^[A-Za-z0-9_-]{1,64}:-?\d{1,3}(,[A-Za-z0-9_-]{1,64}:-?\d{1,3}){0,63}$/;

// src/quality.ts
var QUALITY_COMPLAINT_SOURCES = ["CORRECTION", "DRIVER", "MANUAL"];
var QUALITY_COMPLAINT_STATUSES = ["OPEN", "IN_PROGRESS", "ACCEPTED", "REJECTED", "CLOSED"];
var QUALITY_STATUS_TRANSITIONS = {
  OPEN: ["IN_PROGRESS", "ACCEPTED", "REJECTED", "CLOSED"],
  IN_PROGRESS: ["OPEN", "ACCEPTED", "REJECTED", "CLOSED"],
  ACCEPTED: ["IN_PROGRESS", "CLOSED"],
  REJECTED: ["IN_PROGRESS", "CLOSED"],
  CLOSED: ["IN_PROGRESS"]
};
var QUALITY_COMMENT_REQUIRED = ["REJECTED"];
function canChangeQualityStatus(from, to) {
  return QUALITY_STATUS_TRANSITIONS[from]?.includes(to) ?? false;
}
var QUALITY_EVENT_TYPES = ["RECEIPT_SORTING", "SUPPLIER_COMPLAINT", "PROCESS", "OTHER"];
var QUALITY_EVENT_STATUSES = ["OPEN", "IN_PROGRESS", "CLOSED"];
var QUALITY_SUPPLIER_NOTE_KINDS = ["NOTE", "AGREEMENT"];
var QUALITY_LOOKUP_KINDS = ["customer", "owner", "product", "supplier", "user"];
function qualityPreviousRange(from, to) {
  const DAY = 864e5;
  const f = Date.parse(`${from}T00:00:00Z`);
  const t = Date.parse(`${to}T00:00:00Z`);
  const days = Math.round((t - f) / DAY) + 1;
  const prevTo = f - DAY;
  const prevFrom = prevTo - (days - 1) * DAY;
  const iso = (ms) => new Date(ms).toISOString().slice(0, 10);
  return { from: iso(prevFrom), to: iso(prevTo) };
}
function qualityDeltaPct(current, previous) {
  if (current === null || previous === null || previous === 0) return null;
  return Math.round((current - previous) / Math.abs(previous) * 1e3) / 10;
}
var QUALITY_AGING_BUCKETS = ["D0_7", "D8_30", "D31_90", "D90_PLUS"];
function qualityAgingBucket(ageDays) {
  return ageDays <= 7 ? "D0_7" : ageDays <= 30 ? "D8_30" : ageDays <= 90 ? "D31_90" : "D90_PLUS";
}
function qualityAgeDays(date, today) {
  return Math.max(0, Math.round((Date.parse(`${today}T00:00:00Z`) - Date.parse(`${date}T00:00:00Z`)) / 864e5));
}
var QUALITY_COMPLAINT_SORTS = ["date", "value"];
var QUALITY_BULK_MAX = 200;
var QUALITY_SUPPLIER_GRADES = ["A", "B", "C", "D"];
var QUALITY_GRADE_COST_PCT = [1, 2.5, 5];
var QUALITY_GRADE_MIN_PURCHASES = 1e4;
var QUALITY_GRADE_REJECT_PCT = [2, 5, 10];
function qualitySupplierGrade(costPct, rejectedPct) {
  const level = (v, t) => v === null ? -1 : v < t[0] ? 0 : v < t[1] ? 1 : v < t[2] ? 2 : 3;
  const worst = Math.max(level(costPct, QUALITY_GRADE_COST_PCT), level(rejectedPct, QUALITY_GRADE_REJECT_PCT));
  return worst < 0 ? null : QUALITY_SUPPLIER_GRADES[worst];
}

// src/commissions.ts
var CUSTOMER_RETRO_KINDS = ["PERCENT", "AMOUNT"];
var CUSTOMER_RETRO_TYPES = ["OFFICIAL", "UNOFFICIAL"];
var COMMISSION_LATE_BUCKETS = ["onTime", "d1_14", "d15_30", "d31_60", "d61_90", "d91"];
var COMMISSION_PAYOUT_SORTS = ["payable", "daysLate", "penalty", "net"];

// src/teren.ts
var INVOICE_FORMATS = ["ELECTRONIC", "PAPER"];
var NOTIFICATION_CHANNELS = ["SMS", "EMAIL", "PHONE"];
var CUSTOMER_PROFILE_QUESTIONS = {
  marketingConsent: "profileMarketingConsent",
  channels: "profileChannels",
  invoiceFormat: "profileInvoiceFormat"
};
var MENU_URL_MAX = 500;
function normalizeMenuUrl(input) {
  const raw = input.trim();
  if (!raw || raw.length > MENU_URL_MAX) return null;
  let url;
  try {
    url = new URL(/^[a-z][a-z0-9+.-]*:/i.test(raw) ? raw : `https://${raw}`);
  } catch {
    return null;
  }
  if (url.protocol !== "https:" && url.protocol !== "http:") return null;
  if (url.username || url.password || !url.hostname.includes(".")) return null;
  return url.toString();
}
function effectiveInvoiceFormat(s) {
  if (s.invoiceFormat === "ELECTRONIC" || s.invoiceFormat === "PAPER") return { value: s.invoiceFormat, source: "SURVEY" };
  if (s.erpInvoiceFormat === "ELECTRONIC" || s.erpInvoiceFormat === "PAPER") return { value: s.erpInvoiceFormat, source: "ERP" };
  if (s.erpEInvoice === true) return { value: "ELECTRONIC", source: "ERP" };
  if (s.erpEInvoice === false) return { value: "PAPER", source: "ERP" };
  return null;
}
var ERP_CONTACT_TYPES = ["PHONE", "EMAIL", "SMS", "VISIT", "POST", "FAX", "OTHER"];
var ERP_CUSTOM_FIELD_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8];
var ERP_EXTRA_TEXT_FIELDS = ["pwd_Tekst01", "pwd_Tekst02", "pwd_Tekst03", "pwd_Tekst04", "pwd_Tekst05", "pwd_Tekst06", "pwd_Tekst07", "pwd_Tekst08"];
var DEFAULT_ERP_CONSENTS_CONFIG = { contactType: true, invoiceField: null, channelsField: null, notifyEmailField: null };
function resolveErpConsentsConfig(raw) {
  const o = raw && typeof raw === "object" && !Array.isArray(raw) ? raw : {};
  const field = (v) => typeof v === "number" && ERP_CUSTOM_FIELD_NUMBERS.includes(v) ? v : null;
  const extra = o.notifyEmailField;
  return {
    contactType: o.contactType !== false,
    invoiceField: field(o.invoiceField),
    channelsField: field(o.channelsField),
    notifyEmailField: typeof extra === "string" && ERP_EXTRA_TEXT_FIELDS.includes(extra) ? extra : null
  };
}
var plain = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ł/gi, "l").toUpperCase();
function invoiceFormatFromText(text) {
  if (!text) return null;
  const t = plain(text);
  const electronic = /ELEKTRON|E-?FAKTUR|KSEF|E-?MAIL|PDF/.test(t);
  const paper = /PAPIER|DRUK/.test(t);
  if (electronic === paper) return null;
  return electronic ? "ELECTRONIC" : "PAPER";
}
function channelsFromText(text) {
  if (!text) return [];
  const t = plain(text);
  const out = /* @__PURE__ */ new Set();
  if (/SMS/.test(t)) out.add("SMS");
  if (/MAIL|@/.test(t)) out.add("EMAIL");
  if (/TEL|PHONE|DZWON/.test(t)) out.add("PHONE");
  return NOTIFICATION_CHANNELS.filter((c) => out.has(c));
}
function contactTypeFromName(name) {
  if (!name || !name.trim()) return null;
  const t = plain(name);
  if (/SMS/.test(t)) return "SMS";
  if (/MAIL/.test(t)) return "EMAIL";
  if (/TEL/.test(t)) return "PHONE";
  if (/WIZYT/.test(t)) return "VISIT";
  if (/POCZT|LIST/.test(t)) return "POST";
  if (/FAX|FAKS/.test(t)) return "FAX";
  return "OTHER";
}
function channelOfContactType(t) {
  return t === "PHONE" || t === "EMAIL" || t === "SMS" ? t : null;
}
var CUSTOMER_PROFILE_FILTERS = {
  invoiceFormat: INVOICE_FORMATS,
  marketingConsent: ["yes", "no"],
  channel: NOTIFICATION_CHANNELS,
  hasMenu: ["yes", "no"]
};
var LOGISTICS_REPORT_SHEETS = ["routes", "drivers", "problems", "complaints", "loading"];
var LOGISTICS_REPORT_MAX_DAYS = 31;
var DEFAULT_LOGISTICS_REPORT_SETTINGS = { enabled: false, hour: 7, recipientIds: [], lastSentOn: null };
function resolveLogisticsReportSettings(raw) {
  const o = raw && typeof raw === "object" && !Array.isArray(raw) ? raw : {};
  const hour = typeof o.hour === "number" && Number.isInteger(o.hour) && o.hour >= 0 && o.hour <= 23 ? o.hour : DEFAULT_LOGISTICS_REPORT_SETTINGS.hour;
  const recipientIds = Array.isArray(o.recipientIds) ? [...new Set(o.recipientIds.filter((x) => typeof x === "string" && x.length > 0))].slice(0, 50) : [];
  const lastSentOn = typeof o.lastSentOn === "string" && /^\d{4}-\d{2}-\d{2}$/.test(o.lastSentOn) ? o.lastSentOn : null;
  return { enabled: o.enabled === true, hour, recipientIds, lastSentOn };
}

// src/surveys.ts
var SURVEY_EDITOR_QUESTION_TYPES = ["single", "multi", "boolean", "text", "number", "date"];
var SURVEY_AUDIENCES = ["ALL", "SEGMENT", "GROUP"];
var SURVEY_LIMITS = {
  titleMax: 120,
  descriptionMax: 1e3,
  questionsMax: 40,
  labelMax: 300,
  optionsMax: 30,
  optionLabelMax: 120,
  audienceValuesMax: 50,
  textMaxLength: 2e3,
  unitMax: 20,
  resultsPageSize: 50,
  resultsTexts: 8
};
var CONSENTS_TEMPLATE_KEY = "consents_invoices";
var CONSENTS_TEMPLATE_TITLE = "Zgody i faktury";
var CONSENTS_TEMPLATE_DESCRIPTION = "Zgoda na kontakt marketingowy, kana\u0142 powiadomie\u0144 i forma faktury.";
var CONSENTS_TEMPLATE_QUESTIONS = [
  { key: "profileMarketingConsent", label: "Zgoda na kontakt marketingowy", type: "boolean", required: false },
  {
    key: "profileChannels",
    label: "Kana\u0142 powiadomie\u0144",
    type: "multi",
    required: false,
    options: [
      { value: "SMS", label: "SMS" },
      { value: "EMAIL", label: "E-mail" },
      { value: "PHONE", label: "Telefon" }
    ]
  },
  {
    key: "profileInvoiceFormat",
    label: "Faktura",
    type: "single",
    required: false,
    options: [
      { value: "ELECTRONIC", label: "Elektroniczna" },
      { value: "PAPER", label: "Papierowa" }
    ]
  }
];
var norm = (s) => s.trim().toLocaleUpperCase("pl");
function surveyAudienceMatches(t, c) {
  if (t.audience === "ALL") return true;
  const value = t.audience === "SEGMENT" ? c.segment : c.priceGroup;
  if (!value) return false;
  const v = norm(value);
  return t.audienceValues.some((x) => norm(x) === v);
}
function surveyStatus(t, today) {
  if (!t.active) return "INACTIVE";
  if (t.validFrom && today < t.validFrom) return "SCHEDULED";
  if (t.validTo && today > t.validTo) return "EXPIRED";
  return "ACTIVE";
}
function surveyAppliesTo(t, c, today) {
  return surveyStatus(t, today) === "ACTIVE" && surveyAudienceMatches(t, c);
}
var KEY_RE = /^[A-Za-z][A-Za-z0-9_]{0,39}$/;
var YMD_RE = /^\d{4}-\d{2}-\d{2}$/;
function isYmd(s) {
  if (typeof s !== "string" || !YMD_RE.test(s)) return false;
  const d = /* @__PURE__ */ new Date(`${s}T00:00:00Z`);
  return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === s;
}
function validateSurveyTemplate(input) {
  const issues = [];
  const title = input.title?.trim() ?? "";
  if (!title) issues.push({ code: "TITLE_REQUIRED" });
  else if (title.length > SURVEY_LIMITS.titleMax) issues.push({ code: "TITLE_TOO_LONG" });
  if ((input.description ?? "").length > SURVEY_LIMITS.descriptionMax) issues.push({ code: "DESCRIPTION_TOO_LONG" });
  if (!input.questions.length) issues.push({ code: "NO_QUESTIONS" });
  if (input.questions.length > SURVEY_LIMITS.questionsMax) issues.push({ code: "TOO_MANY_QUESTIONS" });
  const keys = /* @__PURE__ */ new Set();
  input.questions.forEach((q, i) => {
    if (!KEY_RE.test(q.key)) issues.push({ code: "KEY_INVALID", question: i });
    else if (keys.has(q.key)) issues.push({ code: "KEY_DUPLICATE", question: i });
    keys.add(q.key);
    if (!SURVEY_EDITOR_QUESTION_TYPES.includes(q.type)) issues.push({ code: "TYPE_INVALID", question: i });
    const label = q.label?.trim() ?? "";
    if (!label) issues.push({ code: "LABEL_REQUIRED", question: i });
    else if (label.length > SURVEY_LIMITS.labelMax) issues.push({ code: "LABEL_TOO_LONG", question: i });
    if (q.type === "single" || q.type === "multi") {
      const options = q.options ?? [];
      if (options.length < 2) issues.push({ code: "OPTIONS_MIN", question: i });
      if (options.length > SURVEY_LIMITS.optionsMax) issues.push({ code: "OPTIONS_MAX", question: i });
      const values = /* @__PURE__ */ new Set();
      const labels = /* @__PURE__ */ new Set();
      options.forEach((o, j) => {
        const l = o.label?.trim() ?? "";
        if (!l || l.length > SURVEY_LIMITS.optionLabelMax) issues.push({ code: "OPTION_LABEL_REQUIRED", question: i, option: j });
        if (!KEY_RE.test(o.value) || values.has(o.value) || l && labels.has(norm(l))) issues.push({ code: "OPTION_DUPLICATE", question: i, option: j });
        values.add(o.value);
        if (l) labels.add(norm(l));
      });
    }
    if (q.type === "number" && q.min !== void 0 && q.max !== void 0 && q.min > q.max) issues.push({ code: "RANGE_INVALID", question: i });
  });
  if (input.audience !== "ALL" && !input.audienceValues.some((v) => v.trim())) issues.push({ code: "AUDIENCE_VALUES_REQUIRED" });
  if (input.validFrom && !isYmd(input.validFrom) || input.validTo && !isYmd(input.validTo)) issues.push({ code: "DATE_INVALID" });
  else if (input.validFrom && input.validTo && input.validFrom > input.validTo) issues.push({ code: "VALIDITY_INVALID" });
  return issues;
}
function nextSurveyKey(prefix, taken) {
  const used = new Set(taken);
  let n2 = 1;
  while (used.has(`${prefix}${n2}`)) n2++;
  return `${prefix}${n2}`;
}
function formatSurveyAnswer(q, v, yesNo) {
  if (v === void 0 || v === null || v === "") return "";
  const label = (value) => q.options?.find((o) => o.value === value)?.label ?? value;
  if (Array.isArray(v)) return v.map(label).join(", ");
  if (typeof v === "boolean") return v ? yesNo.yes : yesNo.no;
  if (q.type === "single") return label(String(v));
  if (typeof v === "number") return q.unit ? `${v} ${q.unit}` : String(v);
  return String(v);
}

// src/warehouse.ts
var WAREHOUSE_PICK_KINDS = ["SMALL", "MEDIUM", "LARGE"];
var PICK_KIND_MAX_LINES = { SMALL: 5, MEDIUM: 20 };
function pickKindOf(lines) {
  if (lines <= PICK_KIND_MAX_LINES.SMALL) return "SMALL";
  if (lines <= PICK_KIND_MAX_LINES.MEDIUM) return "MEDIUM";
  return "LARGE";
}
var WAREHOUSE_TASK_SOURCES = ["SIMULATION", "WMS_CSV"];
var WAREHOUSE_NORM_METHODS = ["MEDIAN", "P60", "P75"];
var METHOD_P = { MEDIAN: 0.5, P60: 0.6, P75: 0.75 };
var WAREHOUSE_GROUP_BY = ["person", "team", "shift", "zone", "day"];
var DEFAULT_WAREHOUSE_DAY_START = 19;
var DEFAULT_WAREHOUSE_SHIFTS = [
  { key: "N", label: "Nocna", from: 19, to: 3 },
  { key: "R", label: "Poranna", from: 3, to: 11 },
  { key: "D", label: "Dzienna", from: 11, to: 19 }
];
var DEFAULT_WAREHOUSE_BONUS_TIERS = [
  { minPct: 100, label: "Pr\xF3g I" },
  { minPct: 110, label: "Pr\xF3g II" }
];
function inShift(hour, s) {
  return s.to > s.from ? hour >= s.from && hour < s.to : hour >= s.from || hour < s.to;
}
function shiftKeyOf(hour, shifts) {
  return (shifts.find((s) => inShift(hour, s)) ?? shifts[0])?.key ?? "-";
}
function shiftsCoverDay(shifts) {
  if (!shifts.length || new Set(shifts.map((s) => s.key)).size !== shifts.length) return false;
  for (let q = 0; q < 96; q++) if (shifts.filter((s) => inShift(q / 4, s)).length !== 1) return false;
  return true;
}
function percentile(values, p) {
  if (!values.length) return null;
  const v = [...values].sort((a, b) => a - b);
  const pos = (v.length - 1) * Math.min(1, Math.max(0, p));
  const lo = Math.floor(pos);
  const hi = Math.ceil(pos);
  return v[lo] + (v[hi] - v[lo]) * (pos - lo);
}
function normFromRates(rates, method, minSample = 1) {
  const ok = rates.filter((r) => Number.isFinite(r) && r > 0);
  if (ok.length < Math.max(1, minSample)) return null;
  const p = percentile(ok, METHOD_P[method]);
  return p === null ? null : Math.round(p * 10) / 10;
}
function performancePct(normHours, actualHours) {
  if (!(actualHours > 0)) return null;
  return Math.round(normHours / actualHours * 1e3) / 10;
}
function bonusTierOf(pct2, hours, tiers, minHours) {
  if (hours < minHours) return { eligible: false, tier: null, reason: "MIN_HOURS" };
  const hit = [...tiers].sort((a, b) => b.minPct - a.minPct).find((t) => pct2 !== null && pct2 >= t.minPct);
  return hit ? { eligible: true, tier: hit.label, reason: "OK" } : { eligible: false, tier: null, reason: "BELOW" };
}

// src/customer-documents.ts
var CUSTOMER_DOCUMENT_KINDS = ["DOCUMENT_LIST", "RECEIVABLES_STATEMENT", "BALANCE_CONFIRMATION", "PAYMENT_REMINDER"];
var ORDER_CONFIRMATION_KIND = "ORDER_CONFIRMATION";
var CUSTOMER_DOCUMENT_LOG_KINDS = [...CUSTOMER_DOCUMENT_KINDS, ORDER_CONFIRMATION_KIND];
var PERIOD_DOCUMENT_KINDS = ["DOCUMENT_LIST"];
var PDF_ONLY_DOCUMENT_KINDS = ["BALANCE_CONFIRMATION", "PAYMENT_REMINDER"];
var CUSTOMER_DOCUMENT_FORMATS = ["PDF", "XLSX", "BOTH"];
var LISTABLE_DOCUMENT_TYPES = ["FV", "KOR", "PA", "WZ", "ZK"];
var DEFAULT_LIST_DOCUMENT_TYPES = ["FV", "KOR"];
var RECIPIENT_SOURCES = ["ERP_DOCUMENTS", "CUSTOMER", "CONTACT"];
var SEND_STATUSES = ["SENT", "FAILED"];
var TEMPLATE_PLACEHOLDERS = ["klient", "sprzedawca", "data", "okres", "saldo", "przeterminowane", "nadawca"];
var MAX_TEMPLATE_SUBJECT = 200;
var MAX_TEMPLATE_BODY = 4e3;
var MAX_DOCUMENT_RECIPIENTS = 10;
var MAX_DOCUMENT_LIST_DAYS = 731;
var EMAIL_RE = /^[^\s@,;<>]+@[^\s@,;<>]+\.[^\s@,;<>]{2,}$/;
function isValidEmail(v) {
  return EMAIL_RE.test(v.trim());
}
function splitEmails(text) {
  if (!text) return [];
  const out = [];
  for (const part of text.split(/[;,\s]+/)) {
    const e = part.trim().replace(/^<|>$/g, "").toLowerCase();
    if (e && isValidEmail(e) && !out.includes(e)) out.push(e);
  }
  return out;
}
function fillTemplate(text, values) {
  return text.replace(/\{([a-ząćęłńóśźż]+)\}/g, (m, key) => {
    const v = values[key];
    return v === void 0 ? m : v;
  });
}

// src/pricing.ts
var CUSTOMER_PRICE_SOURCES = ["INDIVIDUAL", "PRICE_LEVEL", "HISTORY"];
var PRICE_RULE_KINDS = ["FIXED_PRICE", "LEVEL_PERCENT", "LEVEL_AMOUNT"];
var PRICE_RULE_SCOPES = ["ALL", "LISTED", "GROUP"];
var PRICE_QUOTE_MAX_PRODUCTS = 200;
var PRICED_CATALOG_PAGE_SIZE = 30;
var PRICED_CATALOG_MAX_PAGE_SIZE = 100;

// src/invoice-compare.ts
var INVOICE_COMPARISON_SOURCES = ["ASSISTANT", "CHAT", "CUSTOMER_CARD", "UPLOAD"];
var INVOICE_COMPARISON_MODES = ["COMPETITOR", "OWN_INVOICE"];
var INVOICE_MATCH_CONFIDENCES = ["SURE", "TO_CONFIRM", "NONE"];
var INVOICE_FILE_EXTENSIONS = ["jpg", "jpeg", "png", "webp", "pdf"];
var INVOICE_MAX_FILE_BYTES = 10 * 1024 * 1024;

// src/salesOrders.ts
var SALES_ORDER_STATUSES = ["SUBMITTED", "ENTERED", "ACCEPTED", "REJECTED", "CANCELLED"];
var SALES_ORDER_OPEN_STATUSES = ["SUBMITTED", "ENTERED"];
var SALES_ORDER_FINAL_STATUSES = ["ACCEPTED", "REJECTED", "CANCELLED"];
var SALES_ORDER_ACTIONS = ["cancel", "enter", "reject", "match"];
var SALES_ORDER_TRANSITIONS = {
  cancel: { from: ["SUBMITTED"], to: "CANCELLED" },
  enter: { from: ["SUBMITTED"], to: "ENTERED" },
  reject: { from: ["SUBMITTED", "ENTERED"], to: "REJECTED" },
  match: { from: ["SUBMITTED", "ENTERED"], to: "ACCEPTED" }
};
function salesOrderTransition(from, action) {
  const t = SALES_ORDER_TRANSITIONS[action];
  return t.from.includes(from) ? t.to : null;
}
var SALES_ORDER_ENTRY_MODES = ["DESK", "SFERA"];
var SALES_ORDER_LINE_DIFFS = ["NONE", "CHANGED", "REMOVED", "ADDED"];
var DELIVERY_SUGGESTION_SOURCES = ["CUSTOMER_DELIVERIES", "ROUTE", "NEXT_WORKDAY"];
var SALES_ORDER_CONFIRMATION_STATUSES = ["SENT", "FAILED", "NO_RECIPIENT", "NOT_REQUESTED"];
var SALES_ORDER_LIMITS = {
  maxLines: 200,
  maxNotes: 1e3,
  maxQuantity: 1e5,
  /** Ilość: najwyżej 3 miejsca po przecinku (jak ilości w Subiekcie). */
  quantityDecimals: 3,
  maxPriceRequestNote: 300,
  maxPriceRequest: 1e6,
  maxRejectReason: 500,
  /** Najdalszy dzień dostawy (dni od dziś). */
  maxDeliveryDaysAhead: 60,
  /** clientRequestId: 8–64 znaki [A-Za-z0-9_-] (UUID z telefonu). */
  clientRequestIdPattern: "^[A-Za-z0-9_-]{8,64}$",
  /** „Moje zamówienia” — z ilu ostatnich dni. */
  mineDays: 60
};

// src/leave.ts
var LEAVE_API = {
  overview: "/leave/overview",
  requests: "/leave/requests",
  pendingCount: "/leave/requests/pending-count",
  entitlement: (userId) => `/leave/entitlements/${encodeURIComponent(userId)}`,
  employees: "/leave/employees",
  link: (employeeId) => `/leave/employees/${encodeURIComponent(employeeId)}/link`
};
var LEAVE_LINK_MODES = ["AUTO", "MANUAL"];
function personNameKey(firstName, lastName) {
  const norm2 = (s) => (s ?? "").replace(/[łŁ]/g, "l").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  const first = norm2(firstName);
  const last = norm2(lastName);
  return first && last ? `${first} ${last}` : "";
}
function matchEmployeesToUsers(employees, users, taken = /* @__PURE__ */ new Set()) {
  const count = (xs) => {
    const m = /* @__PURE__ */ new Map();
    for (const x of xs) if (x.nameKey) m.set(x.nameKey, [...m.get(x.nameKey) ?? [], x]);
    return m;
  };
  const byEmp = count(employees);
  const byUser = count(users);
  const out = /* @__PURE__ */ new Map();
  for (const [key, emps] of byEmp) {
    const us = byUser.get(key);
    if (emps.length !== 1 || us?.length !== 1 || taken.has(us[0].id)) continue;
    out.set(emps[0].id, us[0].id);
  }
  return out;
}
export {
  ABC_CLASS_LABELS,
  ABC_THRESHOLDS,
  ABSENCE_CODE_BY_REQUEST_TYPE,
  ABSENCE_TYPES,
  ACTIVE_APPROVAL_STATUSES,
  ACTIVITY_THRESHOLDS,
  AI_ERROR_CODES,
  AI_INSIGHT_KINDS,
  AI_LOGISTICS_INSIGHT_KINDS,
  AI_MAX_HISTORY_TURNS,
  AI_MAX_MESSAGE_CHARS,
  AI_PROVIDERS,
  AI_TOOL_LABELS,
  ALERT_SEVERITIES,
  ALERT_TYPES,
  APPROVAL_AREAS,
  APPROVAL_DECISIONS,
  APPROVAL_EVENT_TYPES,
  APPROVAL_REQUEST_STATUSES,
  APPROVAL_STEP_STATUSES,
  APP_UPDATE_CHECK_MS,
  AUDIT_ACTIONS,
  AUDIT_EXPORT_MAX,
  AUDIT_SEVERITIES,
  AUDIT_SEVERITY_BY_ACTION,
  B2B_DECISIONS,
  B2B_STATUSES,
  BONUS_COMPONENT_KEYS,
  BONUS_MANDATORY_KEYS,
  BULK_TASKS_MAX,
  BULK_TASK_ACTIONS,
  CASHFLOW_CATEGORIES,
  CASHFLOW_DOUBTFUL_AFTER_DAYS,
  CASHFLOW_FLOW_CATEGORIES,
  CATALOG_LIMITS,
  CHAT_ALLOWED_EXTENSIONS,
  CHAT_CONVERSATION_KINDS,
  CHAT_MAX_ATTACHMENTS,
  CHAT_MAX_FILE_BYTES,
  CHAT_MESSAGE_MAX_CHARS,
  CHAT_PAGE_SIZE,
  CHAT_REACTION_EMOJIS,
  CHAT_SSE_HEARTBEAT_MS,
  CHAT_SUBJECT_TYPES,
  CHAT_TITLE_MAX_CHARS,
  CHAT_TYPING_TTL_MS,
  CHURN_BANDS,
  CLAIMS_VIEWS,
  CLAIM_DEADLINE_KINDS,
  CLAIM_DECISIONS,
  CLAIM_EVENT_TYPES,
  CLAIM_LETTER_TYPES,
  CLAIM_PATHS,
  CLAIM_PAYMENT_DIRECTIONS,
  CLAIM_PAYMENT_KINDS,
  CLAIM_SORT_FIELDS,
  CLAIM_SOURCE_DECISIONS,
  CLAIM_SOURCE_TYPES,
  CLAIM_STAGES,
  CLAIM_SUGGESTION_REASONS,
  CLOSED_CASE_STATUSES,
  COLLECTION_ACTION_KINDS,
  COLLECTION_BUCKETS,
  COLLECTION_CASE_KINDS,
  COLLECTION_CASE_STATUSES,
  COLLECTION_PATH_STAGES,
  COMMISSION_LATE_BUCKETS,
  COMMISSION_PAYOUT_SORTS,
  COMPETITOR_SUPPLIER_ERROR_CODES,
  COMPETITOR_SUPPLIER_NAME_MAX,
  CONSENTS_TEMPLATE_DESCRIPTION,
  CONSENTS_TEMPLATE_KEY,
  CONSENTS_TEMPLATE_QUESTIONS,
  CONSENTS_TEMPLATE_TITLE,
  CONTACT_CADENCE_DAYS,
  CONTACT_ROLES,
  COST_CENTRE_PATTERN,
  COST_DEPARTMENTS,
  COST_DEPARTMENT_BUCKETS,
  CUSTOMER_CARD_LIMITS,
  CUSTOMER_DOCUMENT_FORMATS,
  CUSTOMER_DOCUMENT_KINDS,
  CUSTOMER_DOCUMENT_LOG_KINDS,
  CUSTOMER_GROUP_BY,
  CUSTOMER_GROUP_NONE,
  CUSTOMER_LIFECYCLE_API,
  CUSTOMER_LOST_AFTER_DAYS_DEFAULT,
  CUSTOMER_LOST_AFTER_DAYS_MAX,
  CUSTOMER_LOST_AFTER_DAYS_MIN,
  CUSTOMER_PRICE_SOURCES,
  CUSTOMER_PROFILE_FILTERS,
  CUSTOMER_PROFILE_QUESTIONS,
  CUSTOMER_RETRO_KINDS,
  CUSTOMER_RETRO_TYPES,
  CUSTOMER_STATUSES,
  DAILY_REPORT_COMMENT_MAX,
  DAILY_REPORT_ENTRY_LIMITS,
  DAILY_REPORT_SHEET_ERROR_CODES,
  DAILY_REPORT_SUBMITTED_TYPE,
  DEFAULT_BONUS_RULES,
  DEFAULT_COST_CENTRE_DEPARTMENTS,
  DEFAULT_ERP_CONSENTS_CONFIG,
  DEFAULT_FLEET_SETTINGS,
  DEFAULT_FORECAST_MIN_DAYS,
  DEFAULT_FORECAST_MIN_KM,
  DEFAULT_LEASE_WARNING_THRESHOLDS,
  DEFAULT_LIST_DOCUMENT_TYPES,
  DEFAULT_LOCALE,
  DEFAULT_LOGISTICS_REPORT_SETTINGS,
  DEFAULT_PARAMS,
  DEFAULT_ROLE_PERMISSIONS,
  DEFAULT_WAREHOUSE_BONUS_TIERS,
  DEFAULT_WAREHOUSE_DAY_START,
  DEFAULT_WAREHOUSE_SHIFTS,
  DELIVERY_FAILURE_REASONS,
  DELIVERY_PRIORITIES,
  DELIVERY_STATUSES,
  DELIVERY_SUGGESTION_SOURCES,
  DELIVERY_TRANSITIONS,
  DEMAND_FORECAST_SEGMENTS,
  DEMAND_FORECAST_SORT_KEYS,
  DEMAND_SCENARIO_NO_GROUP,
  DEMAND_SCENARIO_PATTERN,
  DEMAND_SCENARIO_RANGE,
  EMPTY_DEMAND_SCENARIO,
  ERP_CONTACT_TYPES,
  ERP_CUSTOM_FIELD_NUMBERS,
  ERP_EXTRA_TEXT_FIELDS,
  ERP_OUTBOX_KINDS,
  ERP_OUTBOX_STATUSES,
  ERP_SYNC_FEEDS,
  ERP_SYNC_RUN_STATUSES,
  ERP_SYNC_TRIGGERS,
  EXTERNAL_LABOR_KINDS,
  EXTERNAL_ROUTE_STATUSES,
  FACTORING_STATUSES,
  FIELD_CUSTOMER_SCOPES,
  FIELD_CUSTOMER_SORTS,
  FIELD_DEFAULT_GEOFENCE_RADIUS_M,
  FIELD_DEFAULT_MANDATORY_STEPS,
  FIELD_ERROR_CODES,
  FIELD_HISTORY_LIMITS,
  FIELD_LIMITS,
  FIELD_NEARBY_DEFAULT_RADIUS_M,
  FIELD_NEARBY_MAX_RADIUS_M,
  FIELD_VISIT_BOARD_LIMIT,
  FIELD_VISIT_PLAN_ERRORS,
  FIELD_VISIT_RESCHEDULABLE,
  FIELD_VISIT_STEP_KEYS,
  FLEET_AI_INSIGHT_KINDS,
  FLEET_AI_TOOL_LABELS,
  FLEET_ALERT_ACTIONS,
  FLEET_ALERT_KINDS,
  FLEET_ALERT_NOTIFICATION_TYPE,
  FLEET_ALERT_SEVERITIES,
  FLEET_ALERT_STATUSES,
  FLEET_ANALYTICS_ERROR_CODES,
  FLEET_ANALYTICS_GRANULARITIES,
  FLEET_ANALYTICS_RULES,
  FLEET_CHECKLIST_PHASES,
  FLEET_CHECKLIST_RESULTS,
  FLEET_CHECKLIST_RUN_STATUSES,
  FLEET_CONFIDENCE_LEVELS,
  FLEET_COST_CATEGORIES,
  FLEET_COST_KINDS,
  FLEET_DATA_STATUSES,
  FLEET_DAY_STATES,
  FLEET_DEFECT_PROCEDURES,
  FLEET_DEVIATION_KINDS,
  FLEET_ENTITY_TYPES,
  FLEET_ERROR_CODES,
  FLEET_EXPENSE_CATEGORIES,
  FLEET_FUEL_SOURCES,
  FLEET_FUEL_TYPES,
  FLEET_INCIDENT_EVENT_TYPES,
  FLEET_INCIDENT_FIELD_TYPES,
  FLEET_INCIDENT_STATUSES,
  FLEET_INCIDENT_TRANSITIONS,
  FLEET_INCIDENT_TYPES,
  FLEET_INSIGHT_ACTIONS,
  FLEET_INSUFFICIENT_REASONS,
  FLEET_LEASE_STATUSES,
  FLEET_LEDGER_GROUPS,
  FLEET_MATRIX_LEVELS,
  FLEET_NOTIFICATION_TYPES,
  FLEET_PAYMENT_METHODS,
  FLEET_REPORT_ERROR_CODES,
  FLEET_REQUIREMENTS,
  FLEET_REVIEW_ACTIONS,
  FLEET_REVIEW_AUTHOR_EDITABLE,
  FLEET_REVIEW_COMMENT_REQUIRED,
  FLEET_REVIEW_STATUSES,
  FLEET_REVIEW_TRANSITIONS,
  FLEET_SERVICE_STATUSES,
  FLEET_SERVICE_TYPES,
  FLEET_SEVERITIES,
  FLEET_TREND_METRICS,
  FLEET_VEHICLE_DECISIONS,
  FLEET_VEHICLE_STATUSES,
  FLEET_VEHICLE_TYPES,
  FOREIGN_CUSTOMER_ACCESS,
  FOREIGN_CUSTOMER_MESSAGE,
  FOREIGN_VISIT_NOTIFICATION_TYPES,
  FOREIGN_VISIT_POLICIES,
  FOREIGN_VISIT_REASONS,
  FOREIGN_VISIT_REASON_NOTE_MAX,
  FUEL_AMOUNT_TOLERANCE,
  FUEL_CONSUMPTION_REASONS,
  FUEL_PRICE_DEVIATION_PCT,
  FUEL_PRICE_HARD_RANGE,
  FUEL_WARNINGS,
  GDPR_ERASED_LABEL,
  GDPR_SEARCH_MIN,
  GDPR_SUBJECT_TYPES,
  GEOCODING_UNAVAILABLE_CODE,
  IMPORT_WARNING_KINDS,
  INSURANCE_ANALYTICS_PRESETS,
  INSURANCE_API,
  INSURANCE_ATTACHMENT_TYPES,
  INSURANCE_IMPORT_STATUSES,
  INSURANCE_LINES,
  INSURANCE_NONE_KEY,
  INSURANCE_SETTINGS_DEFAULTS,
  INSURANCE_SETTING_KEYS,
  INSURER_CLAIM_PATHS,
  INVALID_TOKEN_CODE,
  INVOICE_COMPARISON_MODES,
  INVOICE_COMPARISON_SOURCES,
  INVOICE_FILE_EXTENSIONS,
  INVOICE_FORMATS,
  INVOICE_MATCH_CONFIDENCES,
  INVOICE_MAX_FILE_BYTES,
  LANE_DEFAULT_MIN,
  LANE_MIN_BLOCK_MIN,
  LEAD_STAGES,
  LEASE_WARNING_LEVELS,
  LEAVE_API,
  LEAVE_LINK_MODES,
  LISTABLE_DOCUMENT_TYPES,
  LOCALES,
  LOGBOOK_ACTIONS,
  LOGBOOK_EVENT_TYPES,
  LOGBOOK_FLAGS,
  LOGBOOK_REQUIREMENT_CODES,
  LOGBOOK_STATUSES,
  LOGBOOK_TRANSITIONS,
  LOGISTICS_DEPOT,
  LOGISTICS_OPT_DEFAULTS,
  LOGISTICS_PAGE_SIZE_MAX,
  LOGISTICS_REPORT_MAX_DAYS,
  LOGISTICS_REPORT_SHEETS,
  MANUAL_NOTIFICATION_CATEGORIES,
  MAX_DOCUMENT_LIST_DAYS,
  MAX_DOCUMENT_RECIPIENTS,
  MAX_TEMPLATE_BODY,
  MAX_TEMPLATE_SUBJECT,
  MBR_AI_RECOMMENDATIONS,
  MBR_AI_SENTENCES,
  MBR_API,
  MBR_BEP_PARAM_LIMITS,
  MBR_BRANCHES,
  MBR_BRANCH_ROW_KEYS,
  MBR_CHECKS,
  MBR_CLOSE_API,
  MBR_CLOSE_CHECKS,
  MBR_CLOSE_COLLECTION_SUGGESTIONS,
  MBR_CLOSE_ENDPOINTS,
  MBR_CLOSE_FORMS,
  MBR_CLOSE_FORM_DEFS,
  MBR_CLOSE_FORM_KEYS,
  MBR_CLOSE_METRIC_KEYS,
  MBR_CLOSE_MIN_REASON,
  MBR_CLOSE_STATUSES,
  MBR_COLLECTION_FUNNEL_ORDER,
  MBR_COLLECTION_STAGES,
  MBR_COMPANY_BRANCH_KEY,
  MBR_COMPARE_MODES,
  MBR_COMPLAINT_CATEGORIES,
  MBR_COMPLAINT_DIMENSIONS,
  MBR_COMPLAINT_RESOLVED_STATUSES,
  MBR_COMPLAINT_STATUSES,
  MBR_COST_CATEGORIES,
  MBR_COST_CATEGORY_KEYS,
  MBR_COST_KINDS,
  MBR_CUSTOMERS_API,
  MBR_CUSTOMERS_CHECKS,
  MBR_CUSTOMER_LIST_FILTERS,
  MBR_CUSTOMER_MODES,
  MBR_CUSTOMER_STATUSES,
  MBR_DASHBOARD_MAX_TILES,
  MBR_DATA_SECTION_KEYS,
  MBR_DEFAULT_FLAT_DELTA,
  MBR_DEFAULT_LOGISTICS_VEHICLE_TYPES,
  MBR_DEFAULT_SEGMENT_SEASONS,
  MBR_DEFAULT_SETTINGS,
  MBR_ERP_REMINDER_STAGES,
  MBR_EXPORT_FORMATS,
  MBR_FINANCE_ANCHORS,
  MBR_FINANCE_API,
  MBR_FINANCE_CHECKS,
  MBR_FINANCE_FORMS,
  MBR_FORM_STATUSES,
  MBR_HQ_ALLOCATION_KEYS,
  MBR_KPI_LABELS_PL,
  MBR_LOGISTICS_API,
  MBR_LOGISTICS_CHECKS,
  MBR_LOGISTICS_METRIC_KEYS,
  MBR_LOGISTICS_RULES,
  MBR_MISSING,
  MBR_MISSING_COMPARED,
  MBR_OPERATIONS_API,
  MBR_OPERATIONS_CHECKS,
  MBR_OPERATIONS_ENDPOINTS,
  MBR_OPERATIONS_LOOKUP_KINDS,
  MBR_OPERATIONS_METRICS,
  MBR_PICKUP_GROUP,
  MBR_RECEIVABLE_KINDS,
  MBR_RECOVERABLE_STATUSES,
  MBR_REPORT_API,
  MBR_REPORT_CHECKS,
  MBR_REPORT_ENDPOINTS,
  MBR_RESTRICTED,
  MBR_RESTRICTED_COMPARED,
  MBR_ROUTE_GROUPS,
  MBR_SALES_API,
  MBR_SALES_CHECKS,
  MBR_SALES_METRIC_PREFIX,
  MBR_SALES_SCENARIOS_API,
  MBR_SALES_SIMULATE_API,
  MBR_SECTION_KEYS,
  MBR_SEMI_COUNTS_AS,
  MENU_URL_MAX,
  MIN_GAP_MIN,
  NEW_CUSTOMER_FIELD_AREAS,
  NOTIFICATION_BODY_MAX,
  NOTIFICATION_CATEGORIES,
  NOTIFICATION_CHANNELS,
  NOTIFICATION_PAGE_SIZE,
  NOTIFICATION_PRIORITIES,
  NOTIFICATION_TITLE_MAX,
  ODOMETER_SOURCES,
  OPTIMIZATION_KINDS,
  ORDER_CONFIRMATION_KIND,
  OWNER_DEFAULT_REPORT,
  OWNER_DEFAULT_THRESHOLDS,
  OWNER_REPORT_MAX_RECIPIENTS,
  OWNER_SECTION_KEYS,
  PASSWORD_LINK_TTL_HOURS,
  PAYMENT_METHODS,
  PDF_ONLY_DOCUMENT_KINDS,
  PERIOD_DOCUMENT_KINDS,
  PERMISSIONS,
  PICK_KIND_MAX_LINES,
  PLANNER_CONFLICT_CODES,
  PLANNER_NOTIFICATION_TYPES,
  PLANNER_ORG_SETTINGS_API,
  PLANNER_ORG_SETTINGS_DEFAULT,
  PLANNER_REQUEST_APPROVERS,
  PLANNER_SCHEDULING_HINTS,
  PLANNER_SHIFT_PRESETS,
  PLANNER_SHIFT_STATUSES,
  PLANNER_SHIFT_TYPES,
  PLANNER_TASK_PRIORITIES,
  PLANNER_TASK_STATUSES,
  PLANNER_TASK_TYPES,
  PLANNER_TEMPLATE_COLORS,
  POLICY_SORT_KEYS,
  POLICY_STATUS_FILTERS,
  POLICY_TABS,
  POTENTIAL_BANDS,
  PRICED_CATALOG_MAX_PAGE_SIZE,
  PRICED_CATALOG_PAGE_SIZE,
  PRICE_QUOTE_MAX_PRODUCTS,
  PRICE_RULE_KINDS,
  PRICE_RULE_SCOPES,
  PRIORITY_RANK,
  PRODUCT_QUADRANTS,
  PROFIT_LOW_THRESHOLD_PCT,
  PURCHASE_DOCUMENT_TYPES,
  QUALITY_AGING_BUCKETS,
  QUALITY_BULK_MAX,
  QUALITY_COMMENT_REQUIRED,
  QUALITY_COMPLAINT_SORTS,
  QUALITY_COMPLAINT_SOURCES,
  QUALITY_COMPLAINT_STATUSES,
  QUALITY_EVENT_STATUSES,
  QUALITY_EVENT_TYPES,
  QUALITY_GRADE_COST_PCT,
  QUALITY_GRADE_MIN_PURCHASES,
  QUALITY_GRADE_REJECT_PCT,
  QUALITY_LOOKUP_KINDS,
  QUALITY_STATUS_TRANSITIONS,
  QUALITY_SUPPLIER_GRADES,
  QUALITY_SUPPLIER_NOTE_KINDS,
  QUEUE_TABS,
  RECIPIENT_SOURCES,
  REPORT_CLIENT_STATUSES,
  REPORT_OFFERS,
  REPORT_PERIOD_TYPES,
  REP_SALES_BIG_DROP_PCT,
  REP_SALES_COMMENT_MAX,
  REP_SALES_DEFAULT_SETTINGS,
  REP_SALES_LOW_MARGIN_PCT,
  REP_SALES_NOTE_MAX,
  REQUEST_ADMIN_ROLE,
  RESTRICTION_ERROR_CODES,
  RESUME_MIN_HIDDEN_MS,
  RFM_SEGMENTS,
  ROLES,
  ROLE_DATA_SCOPE,
  ROUTE_ID_MAP_KINDS,
  ROUTE_PLAN_STATUSES,
  ROUTE_ROW_ERROR_CODES,
  ROUTE_SYNC_STATUSES,
  ROUTING_LIMITS,
  ROUTING_UNAVAILABLE_CODE,
  SALES_BASES,
  SALES_ORDER_ACTIONS,
  SALES_ORDER_CONFIRMATION_STATUSES,
  SALES_ORDER_ENTRY_MODES,
  SALES_ORDER_FINAL_STATUSES,
  SALES_ORDER_LIMITS,
  SALES_ORDER_LINE_DIFFS,
  SALES_ORDER_OPEN_STATUSES,
  SALES_ORDER_STATUSES,
  SALES_ORDER_TRANSITIONS,
  SCHEDULE_REQUEST_STATUSES,
  SCHEDULE_REQUEST_TYPES,
  SEARCH_DEFAULT_LIMIT,
  SEARCH_GROUPS,
  SEARCH_MAX_CHARS,
  SEARCH_MAX_LIMIT,
  SEARCH_MIN_CHARS,
  SEND_STATUSES,
  SETTLEMENT_PERIOD_STATUSES,
  SHIFT_ATTRIBUTE_SOURCES,
  STEP_DATA_LIMITS,
  SURVEY_AUDIENCES,
  SURVEY_EDITOR_QUESTION_TYPES,
  SURVEY_LIMITS,
  TARGET_DOCUMENTS,
  TASK_PRIORITIES,
  TASK_RECURRENCES,
  TASK_REMINDER_MINUTES,
  TEMPLATE_PLACEHOLDERS,
  TENDER_ACTION_STATUSES,
  TENDER_AWARDABLE_STATUSES,
  TENDER_BUILTIN_CRITERIA,
  TENDER_CLAUSE_LIBRARY,
  TENDER_COMPLIANCE_KINDS,
  TENDER_DEFAULT_CRITERIA,
  TENDER_ERROR_CODES,
  TENDER_LOCKED_STATUSES,
  TENDER_LOSS_GROUPS,
  TENDER_LOT_GROUPS,
  TENDER_LOT_GROUP_TYPES,
  TENDER_PROCEDURE_TYPES,
  TENDER_SCHEDULE_TEMPLATES,
  TENDER_STAGE_LABELS,
  TENDER_STATUSES,
  TENDER_STATUS_FLOW,
  TENDER_STATUS_TRANSITIONS,
  TEXT_INPUT_TYPES,
  TIME_ENTRY_SOURCES,
  TIME_ENTRY_SOURCE_PRIORITY,
  TIME_ENTRY_STATUSES,
  TO_ORDER_HORIZONS,
  UPDATE_OVERLAY_SELECTOR,
  USER_HAS_DATA_CODE,
  USER_PASSWORD_MIN,
  VACATION_ABSENCE_CODES,
  VACATION_API,
  VACATION_DAYS_MAX,
  VACATION_DAY_MINUTES,
  VACATION_ENTITLEMENT_SOURCES,
  VACATION_OVER_LIMIT_MODES,
  VACATION_STATUTORY_DAYS,
  WAREHOUSE_GROUP_BY,
  WAREHOUSE_NORM_METHODS,
  WAREHOUSE_PICK_KINDS,
  WAREHOUSE_TASK_SOURCES,
  WORKFLOW_ERROR_CODES,
  WORKFLOW_NOTIFICATION_TYPES,
  WORKING_TIME_BLOCK,
  WORKTIME_ERROR_CODES,
  WORKTIME_MAX_OPEN_HOURS,
  WORKTIME_SYSTEMS,
  YMD_RE,
  addDaysYmd,
  addMonths,
  additiveKpi,
  aggregate,
  applyScenarioToRow,
  auditActionsOfSeverity,
  auditSeverity,
  availableAbsenceCodes,
  availableRequestTypes,
  bepParamsFrom,
  bonusTierOf,
  buildKey,
  buildRoutes,
  canChangeQualityStatus,
  channelOfContactType,
  channelsFromText,
  clusterByGrid,
  compareAdditive,
  comparePeriods,
  compareRatio,
  compareValues,
  compareVersions,
  comparisonWindows,
  computeBep,
  computeDay,
  computeNominal,
  computeVacationBalance,
  contactTypeFromName,
  countWorkingDays,
  customerStatusRules,
  dailyReportPanelLink,
  daysInPeriod,
  decideUpdate,
  decidesAsAdmin,
  defaultReportPeriod,
  deliveryTiming,
  departmentOfCentre,
  detectAlerts,
  disabledRequestTypesOf,
  distanceM,
  div,
  dominantStatus,
  easterSunday,
  effectiveInvoiceFormat,
  encodeScenario,
  entriesSince,
  evaluateWorkingTime,
  fillTemplate,
  flattenFormNumbers,
  fleetEntityPath,
  fleetEntityRef,
  formHasValues,
  formatPeriod,
  formatSurveyAnswer,
  formatVacationDays,
  groupVisitsByDay,
  identicalToTheGrosz,
  inShift,
  invoiceFormatFromText,
  isAbsenceCode,
  isDifferentBuild,
  isErpSyncFeed,
  isForeignCustomerRow,
  isHoliday,
  isLogisticsInsightKind,
  isMbrCostCategory,
  isMbrPeriod,
  isPotentialBandKey,
  isRequestApprover,
  isSafeUpdateRoute,
  isScenarioActive,
  isScheduleRequestType,
  isSunday,
  isUiBusy,
  isVacationDays,
  isVacationOverLimitMode,
  isValidEmail,
  isValidLostAfterDays,
  isWorkingDay,
  isYmd,
  lastPeriods,
  layoutLane,
  legacyContactFields,
  looksLikeFraction,
  matchEmployeesToUsers,
  mbrCostTotals,
  mbrDeltaPct,
  mbrRelativeChange,
  mbrValue,
  messages,
  mondayOf,
  nextSurveyKey,
  nightMinutes,
  normFromRates,
  normalizeMenuUrl,
  normalizeUpdatePath,
  notificationCategoryForType,
  onTimePct,
  parseBuildInfo,
  parseChangelogFeed,
  parseEtat,
  parsePeriod,
  parseScenario,
  pct,
  perDeliveryDay,
  percentile,
  performancePct,
  periodOfDate,
  periodRange,
  periodsBetween,
  periodsNeeded,
  personNameKey,
  pickKindOf,
  polishHolidays,
  potentialRange,
  previousPeriod,
  qualityAgeDays,
  qualityAgingBucket,
  qualityDeltaPct,
  qualityPreviousRange,
  qualitySupplierGrade,
  ratioTrendOf,
  remainingAfter,
  repSalesAvgMarginPct,
  repSalesFlags,
  repSalesMissingComment,
  repSalesNeedsComment,
  repSalesTrend,
  reportMonthWeeks,
  reportWeekOf,
  requestApproverPaths,
  resolveErpConsentsConfig,
  resolveLogisticsReportSettings,
  roleHasPermission,
  salesOrderTransition,
  scaleMonth,
  scenarioFactor,
  shiftKeyOf,
  shiftsCoverDay,
  simulateBep,
  splitEmails,
  suggestShortName,
  summarizeChecks,
  summarizePeriod,
  surveyAppliesTo,
  surveyAudienceMatches,
  surveyStatus,
  toleranceCheck,
  toleranceSeverity,
  toneFor,
  trendOf,
  validateCloseForm,
  validateSurveyTemplate,
  vehicleDayState,
  visitDayOf,
  visitFlags,
  visitMoment,
  warsawDay,
  warsawMinute,
  warsawToIso,
  warsawYmd,
  workingDaysOf,
  yearAgoPeriod,
  ytdPeriods
};
